/* Generated from simple-emoji-map + emoji-datasource. cp values are
 * verified against the twemoji 14.0.2 CDN so every emoji renders. */
export const EMOJI_CATEGORIES = [
  { key: 'smileys', name: 'Smileys & Emotion', emojis: [
    { id: "grinning", cp: '1f600' },
    { id: "grinning_face_with_big_eyes", cp: '1f603' },
    { id: "grinning_face_with_closed_eyes", cp: '1f604' },
    { id: "beaming_face", cp: '1f601' },
    { id: "laughing", cp: '1f606' },
    { id: "grinning_face_with_sweat", cp: '1f605' },
    { id: "rofl", cp: '1f923' },
    { id: "joy", cp: '1f602' },
    { id: "slightly_smiling_face", cp: '1f642' },
    { id: "upside_down_face", cp: '1f643' },
    { id: "melt", cp: '1fae0' },
    { id: "wink", cp: '1f609' },
    { id: "blush", cp: '1f60a' },
    { id: "halo", cp: '1f607' },
    { id: "smiling_face_with_3_hearts", cp: '1f970' },
    { id: "heart_eyes", cp: '1f60d' },
    { id: "star_struck", cp: '1f929' },
    { id: "blowing_a_kiss", cp: '1f618' },
    { id: "kissing", cp: '1f617' },
    { id: "relaxed", cp: '263a' },
    { id: "kissing_closed_eyes", cp: '1f61a' },
    { id: "kissing_face_with_smiling_eyes", cp: '1f619' },
    { id: "smiling_face_with_tear", cp: '1f972' },
    { id: "savoring_food", cp: '1f60b' },
    { id: "face_with_tongue", cp: '1f61b' },
    { id: "stuck_out_tongue_winking_eye", cp: '1f61c' },
    { id: "zany", cp: '1f92a' },
    { id: "stuck_out_tongue_closed_eyes", cp: '1f61d' },
    { id: "money_mouth_face", cp: '1f911' },
    { id: "hug", cp: '1f917' },
    { id: "face_with_hand_over_mouth", cp: '1f92d' },
    { id: "face_with_open_eyes_hand_over_mouth", cp: '1fae2' },
    { id: "face_with_peeking_eye", cp: '1fae3' },
    { id: "shush", cp: '1f92b' },
    { id: "thinking", cp: '1f914' },
    { id: "salute", cp: '1fae1' },
    { id: "zipper_mouth", cp: '1f910' },
    { id: "face_with_raised_eyebrow", cp: '1f928' },
    { id: "neutral", cp: '1f610' },
    { id: "expressionless", cp: '1f611' },
    { id: "no_mouth", cp: '1f636' },
    { id: "dotted_line_face", cp: '1fae5' },
    { id: "in_clouds", cp: '1f636-200d-1f32b-fe0f' },
    { id: "smirk", cp: '1f60f' },
    { id: "unamused", cp: '1f612' },
    { id: "rolling_eyes", cp: '1f644' },
    { id: "grimacing", cp: '1f62c' },
    { id: "exhale", cp: '1f62e-200d-1f4a8' },
    { id: "lying", cp: '1f925' },
    { id: "relieved", cp: '1f60c' },
    { id: "pensive", cp: '1f614' },
    { id: "sleepy", cp: '1f62a' },
    { id: "drooling", cp: '1f924' },
    { id: "sleeping", cp: '1f634' },
    { id: "mask", cp: '1f637' },
    { id: "face_with_thermometer", cp: '1f912' },
    { id: "face_with_head_bandage", cp: '1f915' },
    { id: "nauseated", cp: '1f922' },
    { id: "face_vomiting", cp: '1f92e' },
    { id: "sneezing", cp: '1f927' },
    { id: "hot", cp: '1f975' },
    { id: "cold", cp: '1f976' },
    { id: "woozy", cp: '1f974' },
    { id: "dizzy_face", cp: '1f635' },
    { id: "dizzy_eyes", cp: '1f635-200d-1f4ab' },
    { id: "exploding_head", cp: '1f92f' },
    { id: "cowboy", cp: '1f920' },
    { id: "hooray", cp: '1f973' },
    { id: "disguised", cp: '1f978' },
    { id: "smiling_face_with_sunglasses", cp: '1f60e' },
    { id: "nerd", cp: '1f913' },
    { id: "face_with_monocle", cp: '1f9d0' },
    { id: "confused", cp: '1f615' },
    { id: "face_with_diagonal_mouth", cp: '1fae4' },
    { id: "worried", cp: '1f61f' },
    { id: "slightly_frowning_face", cp: '1f641' },
    { id: "white_frowning_face", cp: '2639' },
    { id: "face_with_open_mouth", cp: '1f62e' },
    { id: "hushed", cp: '1f62f' },
    { id: "astonished", cp: '1f632' },
    { id: "flushed", cp: '1f633' },
    { id: "pleading", cp: '1f97a' },
    { id: "face_holding_back_tears", cp: '1f979' },
    { id: "frowning", cp: '1f626' },
    { id: "anguished", cp: '1f627' },
    { id: "fearful", cp: '1f628' },
    { id: "anxious", cp: '1f630' },
    { id: "disappointed_relieved", cp: '1f625' },
    { id: "cry", cp: '1f622' },
    { id: "loudly_crying_face", cp: '1f62d' },
    { id: "scream", cp: '1f631' },
    { id: "confounded", cp: '1f616' },
    { id: "persevere", cp: '1f623' },
    { id: "disappointed", cp: '1f61e' },
    { id: "downcast_face", cp: '1f613' },
    { id: "weary", cp: '1f629' },
    { id: "tired", cp: '1f62b' },
    { id: "yawn", cp: '1f971' },
    { id: "nose_steam", cp: '1f624' },
    { id: "pout", cp: '1f621' },
    { id: "angry", cp: '1f620' },
    { id: "censored", cp: '1f92c' },
    { id: "smiling_imp", cp: '1f608' },
    { id: "angry_imp", cp: '1f47f' },
    { id: "skull", cp: '1f480' },
    { id: "skull_and_crossbones", cp: '2620' },
    { id: "poop", cp: '1f4a9' },
    { id: "clown", cp: '1f921' },
    { id: "japanese_ogre", cp: '1f479' },
    { id: "goblin", cp: '1f47a' },
    { id: "ghost", cp: '1f47b' },
    { id: "alien", cp: '1f47d' },
    { id: "alien_monster", cp: '1f47e' },
    { id: "robot", cp: '1f916' },
    { id: "grinning_cat", cp: '1f63a' },
    { id: "grinning_cat_with_closed_eyes", cp: '1f638' },
    { id: "joy_cat", cp: '1f639' },
    { id: "heart_eyes_cat", cp: '1f63b' },
    { id: "smirk_cat", cp: '1f63c' },
    { id: "kissing_cat", cp: '1f63d' },
    { id: "scream_cat", cp: '1f640' },
    { id: "crying_cat", cp: '1f63f' },
    { id: "pouting_cat", cp: '1f63e' },
    { id: "see_no_evil", cp: '1f648' },
    { id: "hear_no_evil", cp: '1f649' },
    { id: "speak_no_evil", cp: '1f64a' },
    { id: "love_letter", cp: '1f48c' },
    { id: "cupid", cp: '1f498' },
    { id: "gift_heart", cp: '1f49d' },
    { id: "sparkling_heart", cp: '1f496' },
    { id: "growing_heart", cp: '1f497' },
    { id: "beating_heart", cp: '1f493' },
    { id: "revolving_hearts", cp: '1f49e' },
    { id: "two_hearts", cp: '1f495' },
    { id: "heart_decoration", cp: '1f49f' },
    { id: "heart_exclamation", cp: '2763' },
    { id: "broken_heart", cp: '1f494' },
    { id: "heart_on_fire", cp: '2764-fe0f-200d-1f525' },
    { id: "mending_heart", cp: '2764-fe0f-200d-1fa79' },
    { id: "heart", cp: '2764' },
    { id: "orange_heart", cp: '1f9e1' },
    { id: "yellow_heart", cp: '1f49b' },
    { id: "green_heart", cp: '1f49a' },
    { id: "blue_heart", cp: '1f499' },
    { id: "purple_heart", cp: '1f49c' },
    { id: "brown_heart", cp: '1f90e' },
    { id: "black_heart", cp: '1f5a4' },
    { id: "white_heart", cp: '1f90d' },
    { id: "kiss", cp: '1f48b' },
    { id: "100", cp: '1f4af' },
    { id: "anger", cp: '1f4a2' },
    { id: "boom", cp: '1f4a5' },
    { id: "dizzy", cp: '1f4ab' },
    { id: "sweat_drops", cp: '1f4a6' },
    { id: "dash", cp: '1f4a8' },
    { id: "hole", cp: '1f573' },
    { id: "speech_balloon", cp: '1f4ac' },
    { id: "eye_in_speech_bubble", cp: '1f441-200d-1f5e8' },
    { id: "left_speech_bubble", cp: '1f5e8' },
    { id: "right_anger_bubble", cp: '1f5ef' },
    { id: "thought_balloon", cp: '1f4ad' },
    { id: "zzz", cp: '1f4a4' },
  ] },
  { key: 'people', name: 'People & Body', emojis: [
    { id: "wave", cp: '1f44b' },
    { id: "raised_back_of_hand", cp: '1f91a' },
    { id: "raised_hand_with_fingers_splayed", cp: '1f590' },
    { id: "high_five", cp: '270b' },
    { id: "vulcan", cp: '1f596' },
    { id: "rightwards_hand", cp: '1faf1' },
    { id: "leftwards_hand", cp: '1faf2' },
    { id: "palm_down", cp: '1faf3' },
    { id: "palm_up", cp: '1faf4' },
    { id: "ok_hand", cp: '1f44c' },
    { id: "pinch", cp: '1f90c' },
    { id: "pinching_hand", cp: '1f90f' },
    { id: "v", cp: '270c' },
    { id: "fingers_crossed", cp: '1f91e' },
    { id: "hand_with_index_finger_and_thumb_crossed", cp: '1faf0' },
    { id: "love_you_gesture", cp: '1f91f' },
    { id: "metal", cp: '1f918' },
    { id: "call_me_hand", cp: '1f919' },
    { id: "point_left", cp: '1f448' },
    { id: "point_right", cp: '1f449' },
    { id: "point_up", cp: '1f446' },
    { id: "middle_finger", cp: '1f595' },
    { id: "point_down", cp: '1f447' },
    { id: "point_up_2", cp: '261d' },
    { id: "point_forward", cp: '1faf5' },
    { id: "+1", cp: '1f44d' },
    { id: "-1", cp: '1f44e' },
    { id: "fist", cp: '270a' },
    { id: "punch", cp: '1f44a' },
    { id: "left_facing_fist", cp: '1f91b' },
    { id: "right_facing_fist", cp: '1f91c' },
    { id: "clap", cp: '1f44f' },
    { id: "raised_hands", cp: '1f64c' },
    { id: "heart_hands", cp: '1faf6' },
    { id: "open_hands", cp: '1f450' },
    { id: "palms_up_together", cp: '1f932' },
    { id: "handshake", cp: '1f91d' },
    { id: "folded_hands", cp: '1f64f' },
    { id: "writing_hand", cp: '270d' },
    { id: "nail_care", cp: '1f485' },
    { id: "selfie", cp: '1f933' },
    { id: "muscle", cp: '1f4aa' },
    { id: "mechanical_arm", cp: '1f9be' },
    { id: "mechanical_leg", cp: '1f9bf' },
    { id: "leg", cp: '1f9b5' },
    { id: "foot", cp: '1f9b6' },
    { id: "ear", cp: '1f442' },
    { id: "ear_with_hearing_aid", cp: '1f9bb' },
    { id: "nose", cp: '1f443' },
    { id: "brain", cp: '1f9e0' },
    { id: "anatomical_heart", cp: '1fac0' },
    { id: "lungs", cp: '1fac1' },
    { id: "tooth", cp: '1f9b7' },
    { id: "bone", cp: '1f9b4' },
    { id: "eyes", cp: '1f440' },
    { id: "eye", cp: '1f441' },
    { id: "tongue", cp: '1f445' },
    { id: "lips", cp: '1f444' },
    { id: "biting_lip", cp: '1fae6' },
    { id: "baby", cp: '1f476' },
    { id: "child", cp: '1f9d2' },
    { id: "boy", cp: '1f466' },
    { id: "girl", cp: '1f467' },
    { id: "adult", cp: '1f9d1' },
    { id: "blond_haired", cp: '1f471' },
    { id: "man", cp: '1f468' },
    { id: "person_bearded", cp: '1f9d4' },
    { id: "man_bearded", cp: '1f9d4-200d-2642-fe0f' },
    { id: "woman_bearded", cp: '1f9d4-200d-2640-fe0f' },
    { id: "man_red_haired", cp: '1f468-200d-1f9b0' },
    { id: "man_curly_haired", cp: '1f468-200d-1f9b1' },
    { id: "man_white_haired", cp: '1f468-200d-1f9b3' },
    { id: "man_bald", cp: '1f468-200d-1f9b2' },
    { id: "woman", cp: '1f469' },
    { id: "woman_red_haired", cp: '1f469-200d-1f9b0' },
    { id: "red_haired", cp: '1f9d1-200d-1f9b0' },
    { id: "woman_curly_haired", cp: '1f469-200d-1f9b1' },
    { id: "curly_haired", cp: '1f9d1-200d-1f9b1' },
    { id: "woman_white_haired", cp: '1f469-200d-1f9b3' },
    { id: "white_haired", cp: '1f9d1-200d-1f9b3' },
    { id: "woman_bald", cp: '1f469-200d-1f9b2' },
    { id: "bald", cp: '1f9d1-200d-1f9b2' },
    { id: "woman_blond_haired", cp: '1f471-200d-2640-fe0f' },
    { id: "man_blond_haired", cp: '1f471-200d-2642-fe0f' },
    { id: "older_adult", cp: '1f9d3' },
    { id: "older_man", cp: '1f474' },
    { id: "older_woman", cp: '1f475' },
    { id: "person_frowning", cp: '1f64d' },
    { id: "man_frowning", cp: '1f64d-200d-2642-fe0f' },
    { id: "woman_frowning", cp: '1f64d-200d-2640-fe0f' },
    { id: "person_pouting", cp: '1f64e' },
    { id: "man_pouting", cp: '1f64e-200d-2642-fe0f' },
    { id: "woman_pouting", cp: '1f64e-200d-2640-fe0f' },
    { id: "no_good", cp: '1f645' },
    { id: "man_gesturing_no", cp: '1f645-200d-2642-fe0f' },
    { id: "woman_gesturing_no", cp: '1f645-200d-2640-fe0f' },
    { id: "all_good", cp: '1f646' },
    { id: "man_gesturing_ok", cp: '1f646-200d-2642-fe0f' },
    { id: "woman_gesturing_ok", cp: '1f646-200d-2640-fe0f' },
    { id: "person_tipping_hand", cp: '1f481' },
    { id: "man_tipping_hand", cp: '1f481-200d-2642-fe0f' },
    { id: "woman_tipping_hand", cp: '1f481-200d-2640-fe0f' },
    { id: "person_raising_hand", cp: '1f64b' },
    { id: "man_raising_hand", cp: '1f64b-200d-2642-fe0f' },
    { id: "woman_raising_hand", cp: '1f64b-200d-2640-fe0f' },
    { id: "deaf_person", cp: '1f9cf' },
    { id: "deaf_man", cp: '1f9cf-200d-2642-fe0f' },
    { id: "deaf_woman", cp: '1f9cf-200d-2640-fe0f' },
    { id: "bow", cp: '1f647' },
    { id: "man_bowing", cp: '1f647-200d-2642-fe0f' },
    { id: "woman_bowing", cp: '1f647-200d-2640-fe0f' },
    { id: "facepalm", cp: '1f926' },
    { id: "man_facepalming", cp: '1f926-200d-2642-fe0f' },
    { id: "woman_facepalming", cp: '1f926-200d-2640-fe0f' },
    { id: "person_shrugging", cp: '1f937' },
    { id: "man_shrugging", cp: '1f937-200d-2642-fe0f' },
    { id: "woman_shrugging", cp: '1f937-200d-2640-fe0f' },
    { id: "health_worker", cp: '1f9d1-200d-2695-fe0f' },
    { id: "man_health_worker", cp: '1f468-200d-2695-fe0f' },
    { id: "woman_health_worker", cp: '1f469-200d-2695-fe0f' },
    { id: "student", cp: '1f9d1-200d-1f393' },
    { id: "man_student", cp: '1f468-200d-1f393' },
    { id: "woman_student", cp: '1f469-200d-1f393' },
    { id: "teacher", cp: '1f9d1-200d-1f3eb' },
    { id: "man_teacher", cp: '1f468-200d-1f3eb' },
    { id: "woman_teacher", cp: '1f469-200d-1f3eb' },
    { id: "judge", cp: '1f9d1-200d-2696-fe0f' },
    { id: "man_judge", cp: '1f468-200d-2696-fe0f' },
    { id: "woman_judge", cp: '1f469-200d-2696-fe0f' },
    { id: "farmer", cp: '1f9d1-200d-1f33e' },
    { id: "man_farmer", cp: '1f468-200d-1f33e' },
    { id: "woman_farmer", cp: '1f469-200d-1f33e' },
    { id: "cook", cp: '1f9d1-200d-1f373' },
    { id: "man_cook", cp: '1f468-200d-1f373' },
    { id: "woman_cook", cp: '1f469-200d-1f373' },
    { id: "mechanic", cp: '1f9d1-200d-1f527' },
    { id: "man_mechanic", cp: '1f468-200d-1f527' },
    { id: "woman_mechanic", cp: '1f469-200d-1f527' },
    { id: "factory_worker", cp: '1f9d1-200d-1f3ed' },
    { id: "man_factory_worker", cp: '1f468-200d-1f3ed' },
    { id: "woman_factory_worker", cp: '1f469-200d-1f3ed' },
    { id: "office_worker", cp: '1f9d1-200d-1f4bc' },
    { id: "man_office_worker", cp: '1f468-200d-1f4bc' },
    { id: "woman_office_worker", cp: '1f469-200d-1f4bc' },
    { id: "scientist", cp: '1f9d1-200d-1f52c' },
    { id: "man_scientist", cp: '1f468-200d-1f52c' },
    { id: "woman_scientist", cp: '1f469-200d-1f52c' },
    { id: "technologist", cp: '1f9d1-200d-1f4bb' },
    { id: "man_technologist", cp: '1f468-200d-1f4bb' },
    { id: "woman_technologist", cp: '1f469-200d-1f4bb' },
    { id: "singer", cp: '1f9d1-200d-1f3a4' },
    { id: "man_singer", cp: '1f468-200d-1f3a4' },
    { id: "woman_singer", cp: '1f469-200d-1f3a4' },
    { id: "artist", cp: '1f9d1-200d-1f3a8' },
    { id: "man_artist", cp: '1f468-200d-1f3a8' },
    { id: "woman_artist", cp: '1f469-200d-1f3a8' },
    { id: "pilot", cp: '1f9d1-200d-2708-fe0f' },
    { id: "man_pilot", cp: '1f468-200d-2708-fe0f' },
    { id: "woman_pilot", cp: '1f469-200d-2708-fe0f' },
    { id: "astronaut", cp: '1f9d1-200d-1f680' },
    { id: "man_astronaut", cp: '1f468-200d-1f680' },
    { id: "woman_astronaut", cp: '1f469-200d-1f680' },
    { id: "firefighter", cp: '1f9d1-200d-1f692' },
    { id: "man_firefighter", cp: '1f468-200d-1f692' },
    { id: "woman_firefighter", cp: '1f469-200d-1f692' },
    { id: "cop", cp: '1f46e' },
    { id: "man_police_officer", cp: '1f46e-200d-2642-fe0f' },
    { id: "woman_police_officer", cp: '1f46e-200d-2640-fe0f' },
    { id: "detective", cp: '1f575' },
    { id: "man_detective", cp: '1f575-fe0f-200d-2642-fe0f' },
    { id: "woman_detective", cp: '1f575-fe0f-200d-2640-fe0f' },
    { id: "guard", cp: '1f482' },
    { id: "man_guard", cp: '1f482-200d-2642-fe0f' },
    { id: "woman_guard", cp: '1f482-200d-2640-fe0f' },
    { id: "ninja", cp: '1f977' },
    { id: "construction_worker", cp: '1f477' },
    { id: "man_construction_worker", cp: '1f477-200d-2642-fe0f' },
    { id: "woman_construction_worker", cp: '1f477-200d-2640-fe0f' },
    { id: "person_with_crown", cp: '1fac5' },
    { id: "prince", cp: '1f934' },
    { id: "princess", cp: '1f478' },
    { id: "person_wearing_turban", cp: '1f473' },
    { id: "man_wearing_turban", cp: '1f473-200d-2642-fe0f' },
    { id: "woman_wearing_turban", cp: '1f473-200d-2640-fe0f' },
    { id: "person_with_skullcap", cp: '1f472' },
    { id: "woman_with_headscarf", cp: '1f9d5' },
    { id: "person_in_tuxedo", cp: '1f935' },
    { id: "man_in_tuxedo", cp: '1f935-200d-2642-fe0f' },
    { id: "woman_in_tuxedo", cp: '1f935-200d-2640-fe0f' },
    { id: "person_with_veil", cp: '1f470' },
    { id: "man_with_veil", cp: '1f470-200d-2642-fe0f' },
    { id: "woman_with_veil", cp: '1f470-200d-2640-fe0f' },
    { id: "pregnant_woman", cp: '1f930' },
    { id: "pregnant_man", cp: '1fac3' },
    { id: "pregnant_person", cp: '1fac4' },
    { id: "breast_feeding", cp: '1f931' },
    { id: "woman_feeding_baby", cp: '1f469-200d-1f37c' },
    { id: "man_feeding_baby", cp: '1f468-200d-1f37c' },
    { id: "person_feeding_baby", cp: '1f9d1-200d-1f37c' },
    { id: "angel", cp: '1f47c' },
    { id: "santa", cp: '1f385' },
    { id: "mrs_claus", cp: '1f936' },
    { id: "mx_claus", cp: '1f9d1-200d-1f384' },
    { id: "superhero", cp: '1f9b8' },
    { id: "man_superhero", cp: '1f9b8-200d-2642-fe0f' },
    { id: "woman_superhero", cp: '1f9b8-200d-2640-fe0f' },
    { id: "supervillain", cp: '1f9b9' },
    { id: "man_supervillain", cp: '1f9b9-200d-2642-fe0f' },
    { id: "woman_supervillain", cp: '1f9b9-200d-2640-fe0f' },
    { id: "mage", cp: '1f9d9' },
    { id: "man_mage", cp: '1f9d9-200d-2642-fe0f' },
    { id: "woman_mage", cp: '1f9d9-200d-2640-fe0f' },
    { id: "fairy", cp: '1f9da' },
    { id: "man_fairy", cp: '1f9da-200d-2642-fe0f' },
    { id: "woman_fairy", cp: '1f9da-200d-2640-fe0f' },
    { id: "vampire", cp: '1f9db' },
    { id: "man_vampire", cp: '1f9db-200d-2642-fe0f' },
    { id: "woman_vampire", cp: '1f9db-200d-2640-fe0f' },
    { id: "merperson", cp: '1f9dc' },
    { id: "merman", cp: '1f9dc-200d-2642-fe0f' },
    { id: "mermaid", cp: '1f9dc-200d-2640-fe0f' },
    { id: "elf", cp: '1f9dd' },
    { id: "man_elf", cp: '1f9dd-200d-2642-fe0f' },
    { id: "woman_elf", cp: '1f9dd-200d-2640-fe0f' },
    { id: "genie", cp: '1f9de' },
    { id: "man_genie", cp: '1f9de-200d-2642-fe0f' },
    { id: "woman_genie", cp: '1f9de-200d-2640-fe0f' },
    { id: "zombie", cp: '1f9df' },
    { id: "man_zombie", cp: '1f9df-200d-2642-fe0f' },
    { id: "woman_zombie", cp: '1f9df-200d-2640-fe0f' },
    { id: "troll", cp: '1f9cc' },
    { id: "massage", cp: '1f486' },
    { id: "man_getting_massage", cp: '1f486-200d-2642-fe0f' },
    { id: "woman_getting_massage", cp: '1f486-200d-2640-fe0f' },
    { id: "haircut", cp: '1f487' },
    { id: "man_getting_haircut", cp: '1f487-200d-2642-fe0f' },
    { id: "woman_getting_haircut", cp: '1f487-200d-2640-fe0f' },
    { id: "person_walking", cp: '1f6b6' },
    { id: "man_walking", cp: '1f6b6-200d-2642-fe0f' },
    { id: "woman_walking", cp: '1f6b6-200d-2640-fe0f' },
    { id: "person_standing", cp: '1f9cd' },
    { id: "man_standing", cp: '1f9cd-200d-2642-fe0f' },
    { id: "woman_standing", cp: '1f9cd-200d-2640-fe0f' },
    { id: "kneeling", cp: '1f9ce' },
    { id: "man_kneeling", cp: '1f9ce-200d-2642-fe0f' },
    { id: "woman_kneeling", cp: '1f9ce-200d-2640-fe0f' },
    { id: "person_with_probing_cane", cp: '1f9d1-200d-1f9af' },
    { id: "man_with_probing_cane", cp: '1f468-200d-1f9af' },
    { id: "woman_with_probing_cane", cp: '1f469-200d-1f9af' },
    { id: "person_in_motorized_wheelchair", cp: '1f9d1-200d-1f9bc' },
    { id: "man_in_motorized_wheelchair", cp: '1f468-200d-1f9bc' },
    { id: "woman_in_motorized_wheelchair", cp: '1f469-200d-1f9bc' },
    { id: "person_in_manual_wheelchair", cp: '1f9d1-200d-1f9bd' },
    { id: "man_in_manual_wheelchair", cp: '1f468-200d-1f9bd' },
    { id: "woman_in_manual_wheelchair", cp: '1f469-200d-1f9bd' },
    { id: "person_running", cp: '1f3c3' },
    { id: "man_running", cp: '1f3c3-200d-2642-fe0f' },
    { id: "woman_running", cp: '1f3c3-200d-2640-fe0f' },
    { id: "dancer", cp: '1f483' },
    { id: "man_dancing", cp: '1f57a' },
    { id: "levitate", cp: '1f574' },
    { id: "dancers", cp: '1f46f' },
    { id: "men_with_bunny_ears_partying", cp: '1f46f-200d-2642-fe0f' },
    { id: "women_with_bunny_ears_partying", cp: '1f46f-200d-2640-fe0f' },
    { id: "person_in_steamy_room", cp: '1f9d6' },
    { id: "man_in_steamy_room", cp: '1f9d6-200d-2642-fe0f' },
    { id: "woman_in_steamy_room", cp: '1f9d6-200d-2640-fe0f' },
    { id: "climbing", cp: '1f9d7' },
    { id: "man_climbing", cp: '1f9d7-200d-2642-fe0f' },
    { id: "woman_climbing", cp: '1f9d7-200d-2640-fe0f' },
    { id: "fencer", cp: '1f93a' },
    { id: "horse_racing", cp: '1f3c7' },
    { id: "person_skiing", cp: '26f7' },
    { id: "person_snowboarding", cp: '1f3c2' },
    { id: "golfer", cp: '1f3cc' },
    { id: "man_golfing", cp: '1f3cc-fe0f-200d-2642-fe0f' },
    { id: "woman_golfing", cp: '1f3cc-fe0f-200d-2640-fe0f' },
    { id: "person_surfing", cp: '1f3c4' },
    { id: "man_surfing", cp: '1f3c4-200d-2642-fe0f' },
    { id: "woman_surfing", cp: '1f3c4-200d-2640-fe0f' },
    { id: "person_rowing_boat", cp: '1f6a3' },
    { id: "man_rowing_boat", cp: '1f6a3-200d-2642-fe0f' },
    { id: "woman_rowing_boat", cp: '1f6a3-200d-2640-fe0f' },
    { id: "person_swimming", cp: '1f3ca' },
    { id: "man_swimming", cp: '1f3ca-200d-2642-fe0f' },
    { id: "woman_swimming", cp: '1f3ca-200d-2640-fe0f' },
    { id: "person_bouncing_ball", cp: '26f9' },
    { id: "man_bouncing_ball", cp: '26f9-fe0f-200d-2642-fe0f' },
    { id: "woman_bouncing_ball", cp: '26f9-fe0f-200d-2640-fe0f' },
    { id: "person_lifting_weights", cp: '1f3cb' },
    { id: "man_lifting_weights", cp: '1f3cb-fe0f-200d-2642-fe0f' },
    { id: "woman_lifting_weights", cp: '1f3cb-fe0f-200d-2640-fe0f' },
    { id: "bicyclist", cp: '1f6b4' },
    { id: "man_biking", cp: '1f6b4-200d-2642-fe0f' },
    { id: "woman_biking", cp: '1f6b4-200d-2640-fe0f' },
    { id: "mountain_bicyclist", cp: '1f6b5' },
    { id: "man_mountain_biking", cp: '1f6b5-200d-2642-fe0f' },
    { id: "woman_mountain_biking", cp: '1f6b5-200d-2640-fe0f' },
    { id: "cartwheeling", cp: '1f938' },
    { id: "man_cartwheeling", cp: '1f938-200d-2642-fe0f' },
    { id: "woman_cartwheeling", cp: '1f938-200d-2640-fe0f' },
    { id: "people_wrestling", cp: '1f93c' },
    { id: "men_wrestling", cp: '1f93c-200d-2642-fe0f' },
    { id: "women_wrestling", cp: '1f93c-200d-2640-fe0f' },
    { id: "person_playing_water_polo", cp: '1f93d' },
    { id: "man_playing_water_polo", cp: '1f93d-200d-2642-fe0f' },
    { id: "woman_playing_water_polo", cp: '1f93d-200d-2640-fe0f' },
    { id: "handball", cp: '1f93e' },
    { id: "man_playing_handball", cp: '1f93e-200d-2642-fe0f' },
    { id: "woman_playing_handball", cp: '1f93e-200d-2640-fe0f' },
    { id: "juggler", cp: '1f939' },
    { id: "man_juggling", cp: '1f939-200d-2642-fe0f' },
    { id: "woman_juggling", cp: '1f939-200d-2640-fe0f' },
    { id: "person_in_lotus_position", cp: '1f9d8' },
    { id: "man_in_lotus_position", cp: '1f9d8-200d-2642-fe0f' },
    { id: "woman_in_lotus_position", cp: '1f9d8-200d-2640-fe0f' },
    { id: "bath", cp: '1f6c0' },
    { id: "person_in_bed", cp: '1f6cc' },
    { id: "people_holding_hands", cp: '1f9d1-200d-1f91d-200d-1f9d1' },
    { id: "two_women_holding_hands", cp: '1f46d' },
    { id: "couple", cp: '1f46b' },
    { id: "two_men_holding_hands", cp: '1f46c' },
    { id: "couple_kiss", cp: '1f48f' },
    { id: "kiss_mw", cp: '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468' },
    { id: "kiss_mm", cp: '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468' },
    { id: "kiss_ww", cp: '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469' },
    { id: "couple_with_heart", cp: '1f491' },
    { id: "couple_with_heart_mw", cp: '1f469-200d-2764-fe0f-200d-1f468' },
    { id: "couple_with_heart_mm", cp: '1f468-200d-2764-fe0f-200d-1f468' },
    { id: "couple_with_heart_ww", cp: '1f469-200d-2764-fe0f-200d-1f469' },
    { id: "family_mwb", cp: '1f468-200d-1f469-200d-1f466' },
    { id: "family_mwg", cp: '1f468-200d-1f469-200d-1f467' },
    { id: "family_mwgb", cp: '1f468-200d-1f469-200d-1f467-200d-1f466' },
    { id: "family_mwbb", cp: '1f468-200d-1f469-200d-1f466-200d-1f466' },
    { id: "family_mwgg", cp: '1f468-200d-1f469-200d-1f467-200d-1f467' },
    { id: "family_mmb", cp: '1f468-200d-1f468-200d-1f466' },
    { id: "family_mmg", cp: '1f468-200d-1f468-200d-1f467' },
    { id: "family_mmgb", cp: '1f468-200d-1f468-200d-1f467-200d-1f466' },
    { id: "family_mmbb", cp: '1f468-200d-1f468-200d-1f466-200d-1f466' },
    { id: "family_mmgg", cp: '1f468-200d-1f468-200d-1f467-200d-1f467' },
    { id: "family_wwb", cp: '1f469-200d-1f469-200d-1f466' },
    { id: "family_wwg", cp: '1f469-200d-1f469-200d-1f467' },
    { id: "family_wwgb", cp: '1f469-200d-1f469-200d-1f467-200d-1f466' },
    { id: "family_wwbb", cp: '1f469-200d-1f469-200d-1f466-200d-1f466' },
    { id: "family_wwgg", cp: '1f469-200d-1f469-200d-1f467-200d-1f467' },
    { id: "family_mb", cp: '1f468-200d-1f466' },
    { id: "family_mbb", cp: '1f468-200d-1f466-200d-1f466' },
    { id: "family_mg", cp: '1f468-200d-1f467' },
    { id: "family_mgb", cp: '1f468-200d-1f467-200d-1f466' },
    { id: "family_mgg", cp: '1f468-200d-1f467-200d-1f467' },
    { id: "family_wb", cp: '1f469-200d-1f466' },
    { id: "family_wbb", cp: '1f469-200d-1f466-200d-1f466' },
    { id: "family_wg", cp: '1f469-200d-1f467' },
    { id: "family_wgb", cp: '1f469-200d-1f467-200d-1f466' },
    { id: "family_wgg", cp: '1f469-200d-1f467-200d-1f467' },
    { id: "speaking_head", cp: '1f5e3' },
    { id: "bust_in_silhouette", cp: '1f464' },
    { id: "busts_in_silhouette", cp: '1f465' },
    { id: "people_hugging", cp: '1fac2' },
    { id: "family", cp: '1f46a' },
    { id: "footprints", cp: '1f463' },
  ] },
  { key: 'animals', name: 'Animals & Nature', emojis: [
    { id: "monkey_face", cp: '1f435' },
    { id: "monkey", cp: '1f412' },
    { id: "gorilla", cp: '1f98d' },
    { id: "orangutan", cp: '1f9a7' },
    { id: "dog_face", cp: '1f436' },
    { id: "dog", cp: '1f415' },
    { id: "guide_dog", cp: '1f9ae' },
    { id: "service_dog", cp: '1f415-200d-1f9ba' },
    { id: "poodle", cp: '1f429' },
    { id: "wolf", cp: '1f43a' },
    { id: "fox", cp: '1f98a' },
    { id: "raccoon", cp: '1f99d' },
    { id: "cat_face", cp: '1f431' },
    { id: "cat", cp: '1f408' },
    { id: "black_cat", cp: '1f408-200d-2b1b' },
    { id: "lion", cp: '1f981' },
    { id: "tiger_face", cp: '1f42f' },
    { id: "tiger", cp: '1f405' },
    { id: "leopard", cp: '1f406' },
    { id: "horse_face", cp: '1f434' },
    { id: "horse", cp: '1f40e' },
    { id: "unicorn", cp: '1f984' },
    { id: "zebra", cp: '1f993' },
    { id: "deer", cp: '1f98c' },
    { id: "bison", cp: '1f9ac' },
    { id: "cow_face", cp: '1f42e' },
    { id: "ox", cp: '1f402' },
    { id: "water_buffalo", cp: '1f403' },
    { id: "cow", cp: '1f404' },
    { id: "pig_face", cp: '1f437' },
    { id: "pig", cp: '1f416' },
    { id: "boar", cp: '1f417' },
    { id: "pig_nose", cp: '1f43d' },
    { id: "ram", cp: '1f40f' },
    { id: "ewe", cp: '1f411' },
    { id: "goat", cp: '1f410' },
    { id: "dromedary_camel", cp: '1f42a' },
    { id: "camel", cp: '1f42b' },
    { id: "llama", cp: '1f999' },
    { id: "giraffe", cp: '1f992' },
    { id: "elephant", cp: '1f418' },
    { id: "mammoth", cp: '1f9a3' },
    { id: "rhino", cp: '1f98f' },
    { id: "hippo", cp: '1f99b' },
    { id: "mouse_face", cp: '1f42d' },
    { id: "mouse", cp: '1f401' },
    { id: "rat", cp: '1f400' },
    { id: "hamster", cp: '1f439' },
    { id: "rabbit_face", cp: '1f430' },
    { id: "rabbit", cp: '1f407' },
    { id: "chipmunk", cp: '1f43f' },
    { id: "beaver", cp: '1f9ab' },
    { id: "hedgehog", cp: '1f994' },
    { id: "bat", cp: '1f987' },
    { id: "bear", cp: '1f43b' },
    { id: "polar_bear", cp: '1f43b-200d-2744-fe0f' },
    { id: "koala", cp: '1f428' },
    { id: "panda", cp: '1f43c' },
    { id: "sloth", cp: '1f9a5' },
    { id: "otter", cp: '1f9a6' },
    { id: "skunk", cp: '1f9a8' },
    { id: "kangaroo", cp: '1f998' },
    { id: "badger", cp: '1f9a1' },
    { id: "paw_prints", cp: '1f43e' },
    { id: "turkey", cp: '1f983' },
    { id: "chicken", cp: '1f414' },
    { id: "rooster", cp: '1f413' },
    { id: "hatching_chick", cp: '1f423' },
    { id: "baby_chick", cp: '1f424' },
    { id: "hatched_chick", cp: '1f425' },
    { id: "bird", cp: '1f426' },
    { id: "penguin", cp: '1f427' },
    { id: "dove", cp: '1f54a' },
    { id: "eagle", cp: '1f985' },
    { id: "duck", cp: '1f986' },
    { id: "swan", cp: '1f9a2' },
    { id: "owl", cp: '1f989' },
    { id: "dodo", cp: '1f9a4' },
    { id: "feather", cp: '1fab6' },
    { id: "flamingo", cp: '1f9a9' },
    { id: "peacock", cp: '1f99a' },
    { id: "parrot", cp: '1f99c' },
    { id: "frog", cp: '1f438' },
    { id: "crocodile", cp: '1f40a' },
    { id: "turtle", cp: '1f422' },
    { id: "lizard", cp: '1f98e' },
    { id: "snake", cp: '1f40d' },
    { id: "dragon_face", cp: '1f432' },
    { id: "dragon", cp: '1f409' },
    { id: "sauropod", cp: '1f995' },
    { id: "t-rex", cp: '1f996' },
    { id: "spouting_whale", cp: '1f433' },
    { id: "whale", cp: '1f40b' },
    { id: "dolphin", cp: '1f42c' },
    { id: "seal", cp: '1f9ad' },
    { id: "fish", cp: '1f41f' },
    { id: "tropical_fish", cp: '1f420' },
    { id: "blowfish", cp: '1f421' },
    { id: "shark", cp: '1f988' },
    { id: "octopus", cp: '1f419' },
    { id: "shell", cp: '1f41a' },
    { id: "coral", cp: '1fab8' },
    { id: "crab", cp: '1f980' },
    { id: "lobster", cp: '1f99e' },
    { id: "shrimp", cp: '1f990' },
    { id: "squid", cp: '1f991' },
    { id: "oyster", cp: '1f9aa' },
    { id: "snail", cp: '1f40c' },
    { id: "butterfly", cp: '1f98b' },
    { id: "bug", cp: '1f41b' },
    { id: "ant", cp: '1f41c' },
    { id: "bee", cp: '1f41d' },
    { id: "beetle", cp: '1fab2' },
    { id: "lady_beetle", cp: '1f41e' },
    { id: "cricket", cp: '1f997' },
    { id: "cockroach", cp: '1fab3' },
    { id: "spider", cp: '1f577' },
    { id: "spider_web", cp: '1f578' },
    { id: "scorpion", cp: '1f982' },
    { id: "mosquito", cp: '1f99f' },
    { id: "fly", cp: '1fab0' },
    { id: "worm", cp: '1fab1' },
    { id: "microbe", cp: '1f9a0' },
    { id: "bouquet", cp: '1f490' },
    { id: "cherry_blossom", cp: '1f338' },
    { id: "white_flower", cp: '1f4ae' },
    { id: "lotus", cp: '1fab7' },
    { id: "rosette", cp: '1f3f5' },
    { id: "rose", cp: '1f339' },
    { id: "wilted_flower", cp: '1f940' },
    { id: "hibiscus", cp: '1f33a' },
    { id: "sunflower", cp: '1f33b' },
    { id: "blossom", cp: '1f33c' },
    { id: "tulip", cp: '1f337' },
    { id: "seedling", cp: '1f331' },
    { id: "potted_plant", cp: '1fab4' },
    { id: "evergreen_tree", cp: '1f332' },
    { id: "deciduous_tree", cp: '1f333' },
    { id: "palm_tree", cp: '1f334' },
    { id: "cactus", cp: '1f335' },
    { id: "ear_of_rice", cp: '1f33e' },
    { id: "herb", cp: '1f33f' },
    { id: "shamrock", cp: '2618' },
    { id: "four_leaf_clover", cp: '1f340' },
    { id: "maple_leaf", cp: '1f341' },
    { id: "fallen_leaf", cp: '1f342' },
    { id: "leaves", cp: '1f343' },
    { id: "empty_nest", cp: '1fab9' },
    { id: "nest_with_eggs", cp: '1faba' },
    { id: "mushroom", cp: '1f344' },
  ] },
  { key: 'food', name: 'Food & Drink', emojis: [
    { id: "grapes", cp: '1f347' },
    { id: "melon", cp: '1f348' },
    { id: "watermelon", cp: '1f349' },
    { id: "orange", cp: '1f34a' },
    { id: "lemon", cp: '1f34b' },
    { id: "banana", cp: '1f34c' },
    { id: "pineapple", cp: '1f34d' },
    { id: "mango", cp: '1f96d' },
    { id: "apple", cp: '1f34e' },
    { id: "green_apple", cp: '1f34f' },
    { id: "pear", cp: '1f350' },
    { id: "peach", cp: '1f351' },
    { id: "cherries", cp: '1f352' },
    { id: "strawberry", cp: '1f353' },
    { id: "blueberries", cp: '1fad0' },
    { id: "kiwi", cp: '1f95d' },
    { id: "tomato", cp: '1f345' },
    { id: "olive", cp: '1fad2' },
    { id: "coconut", cp: '1f965' },
    { id: "avocado", cp: '1f951' },
    { id: "eggplant", cp: '1f346' },
    { id: "potato", cp: '1f954' },
    { id: "carrot", cp: '1f955' },
    { id: "corn", cp: '1f33d' },
    { id: "hot_pepper", cp: '1f336' },
    { id: "bell_pepper", cp: '1fad1' },
    { id: "cucumber", cp: '1f952' },
    { id: "leafy_green", cp: '1f96c' },
    { id: "broccoli", cp: '1f966' },
    { id: "garlic", cp: '1f9c4' },
    { id: "onion", cp: '1f9c5' },
    { id: "peanuts", cp: '1f95c' },
    { id: "beans", cp: '1fad8' },
    { id: "chestnut", cp: '1f330' },
    { id: "bread", cp: '1f35e' },
    { id: "croissant", cp: '1f950' },
    { id: "baguette_bread", cp: '1f956' },
    { id: "flatbread", cp: '1fad3' },
    { id: "pretzel", cp: '1f968' },
    { id: "bagel", cp: '1f96f' },
    { id: "pancakes", cp: '1f95e' },
    { id: "waffle", cp: '1f9c7' },
    { id: "cheese", cp: '1f9c0' },
    { id: "meat_on_bone", cp: '1f356' },
    { id: "poultry_leg", cp: '1f357' },
    { id: "cut_of_meat", cp: '1f969' },
    { id: "bacon", cp: '1f953' },
    { id: "hamburger", cp: '1f354' },
    { id: "french_fries", cp: '1f35f' },
    { id: "pizza", cp: '1f355' },
    { id: "hotdog", cp: '1f32d' },
    { id: "sandwich", cp: '1f96a' },
    { id: "taco", cp: '1f32e' },
    { id: "burrito", cp: '1f32f' },
    { id: "tamale", cp: '1fad4' },
    { id: "stuffed_flatbread", cp: '1f959' },
    { id: "falafel", cp: '1f9c6' },
    { id: "egg", cp: '1f95a' },
    { id: "cooking", cp: '1f373' },
    { id: "shallow_pan_of_food", cp: '1f958' },
    { id: "pot_of_food", cp: '1f372' },
    { id: "fondue", cp: '1fad5' },
    { id: "bowl_with_spoon", cp: '1f963' },
    { id: "green_salad", cp: '1f957' },
    { id: "popcorn", cp: '1f37f' },
    { id: "butter", cp: '1f9c8' },
    { id: "salt", cp: '1f9c2' },
    { id: "canned_food", cp: '1f96b' },
    { id: "bento", cp: '1f371' },
    { id: "rice_cracker", cp: '1f358' },
    { id: "rice_ball", cp: '1f359' },
    { id: "cooked_rice", cp: '1f35a' },
    { id: "curry", cp: '1f35b' },
    { id: "ramen", cp: '1f35c' },
    { id: "spaghetti", cp: '1f35d' },
    { id: "sweet_potato", cp: '1f360' },
    { id: "oden", cp: '1f362' },
    { id: "sushi", cp: '1f363' },
    { id: "fried_shrimp", cp: '1f364' },
    { id: "fish_cake", cp: '1f365' },
    { id: "moon_cake", cp: '1f96e' },
    { id: "dango", cp: '1f361' },
    { id: "dumpling", cp: '1f95f' },
    { id: "fortune_cookie", cp: '1f960' },
    { id: "takeout_box", cp: '1f961' },
    { id: "icecream", cp: '1f366' },
    { id: "shaved_ice", cp: '1f367' },
    { id: "ice_cream", cp: '1f368' },
    { id: "doughnut", cp: '1f369' },
    { id: "cookie", cp: '1f36a' },
    { id: "birthday", cp: '1f382' },
    { id: "cake", cp: '1f370' },
    { id: "cupcake", cp: '1f9c1' },
    { id: "pie", cp: '1f967' },
    { id: "chocolate_bar", cp: '1f36b' },
    { id: "candy", cp: '1f36c' },
    { id: "lollipop", cp: '1f36d' },
    { id: "custard", cp: '1f36e' },
    { id: "honey_pot", cp: '1f36f' },
    { id: "baby_bottle", cp: '1f37c' },
    { id: "glass_of_milk", cp: '1f95b' },
    { id: "coffee", cp: '2615' },
    { id: "teapot", cp: '1fad6' },
    { id: "tea", cp: '1f375' },
    { id: "sake", cp: '1f376' },
    { id: "champagne", cp: '1f37e' },
    { id: "wine_glass", cp: '1f377' },
    { id: "cocktail", cp: '1f378' },
    { id: "tropical_drink", cp: '1f379' },
    { id: "beer", cp: '1f37a' },
    { id: "beers", cp: '1f37b' },
    { id: "clinking_glasses", cp: '1f942' },
    { id: "tumbler_glass", cp: '1f943' },
    { id: "pour", cp: '1fad7' },
    { id: "cup_with_straw", cp: '1f964' },
    { id: "boba_drink", cp: '1f9cb' },
    { id: "beverage_box", cp: '1f9c3' },
    { id: "mate", cp: '1f9c9' },
    { id: "ice", cp: '1f9ca' },
    { id: "chopsticks", cp: '1f962' },
    { id: "fork_knife_plate", cp: '1f37d' },
    { id: "fork_and_knife", cp: '1f374' },
    { id: "spoon", cp: '1f944' },
    { id: "knife", cp: '1f52a' },
    { id: "jar", cp: '1fad9' },
    { id: "amphora", cp: '1f3fa' },
  ] },
  { key: 'activities', name: 'Activities', emojis: [
    { id: "jack_o_lantern", cp: '1f383' },
    { id: "christmas_tree", cp: '1f384' },
    { id: "fireworks", cp: '1f386' },
    { id: "sparkler", cp: '1f387' },
    { id: "firecracker", cp: '1f9e8' },
    { id: "sparkles", cp: '2728' },
    { id: "balloon", cp: '1f388' },
    { id: "party", cp: '1f389' },
    { id: "confetti_ball", cp: '1f38a' },
    { id: "tanabata_tree", cp: '1f38b' },
    { id: "bamboo", cp: '1f38d' },
    { id: "dolls", cp: '1f38e' },
    { id: "carp_streamer", cp: '1f38f' },
    { id: "wind_chime", cp: '1f390' },
    { id: "moon_ceremony", cp: '1f391' },
    { id: "red_envelope", cp: '1f9e7' },
    { id: "ribbon", cp: '1f380' },
    { id: "gift", cp: '1f381' },
    { id: "reminder_ribbon", cp: '1f397' },
    { id: "admission_tickets", cp: '1f39f' },
    { id: "ticket", cp: '1f3ab' },
    { id: "military_medal", cp: '1f396' },
    { id: "trophy", cp: '1f3c6' },
    { id: "sports_medal", cp: '1f3c5' },
    { id: "1st", cp: '1f947' },
    { id: "2nd", cp: '1f948' },
    { id: "3rd", cp: '1f949' },
    { id: "soccer", cp: '26bd' },
    { id: "baseball", cp: '26be' },
    { id: "softball", cp: '1f94e' },
    { id: "basketball", cp: '1f3c0' },
    { id: "volleyball", cp: '1f3d0' },
    { id: "football", cp: '1f3c8' },
    { id: "rugby_football", cp: '1f3c9' },
    { id: "tennis", cp: '1f3be' },
    { id: "flying_disc", cp: '1f94f' },
    { id: "bowling", cp: '1f3b3' },
    { id: "cricket_game", cp: '1f3cf' },
    { id: "field_hockey", cp: '1f3d1' },
    { id: "hockey", cp: '1f3d2' },
    { id: "lacrosse", cp: '1f94d' },
    { id: "ping_pong", cp: '1f3d3' },
    { id: "badminton", cp: '1f3f8' },
    { id: "boxing_glove", cp: '1f94a' },
    { id: "martial_arts_uniform", cp: '1f94b' },
    { id: "goal_net", cp: '1f945' },
    { id: "golf", cp: '26f3' },
    { id: "ice_skate", cp: '26f8' },
    { id: "fishing_pole", cp: '1f3a3' },
    { id: "diving_mask", cp: '1f93f' },
    { id: "running_shirt", cp: '1f3bd' },
    { id: "ski", cp: '1f3bf' },
    { id: "sled", cp: '1f6f7' },
    { id: "curling_stone", cp: '1f94c' },
    { id: "bullseye", cp: '1f3af' },
    { id: "yo_yo", cp: '1fa80' },
    { id: "kite", cp: '1fa81' },
    { id: "gun", cp: '1f52b' },
    { id: "8ball", cp: '1f3b1' },
    { id: "crystal_ball", cp: '1f52e' },
    { id: "magic_wand", cp: '1fa84' },
    { id: "controller", cp: '1f3ae' },
    { id: "joystick", cp: '1f579' },
    { id: "slot_machine", cp: '1f3b0' },
    { id: "game_die", cp: '1f3b2' },
    { id: "jigsaw", cp: '1f9e9' },
    { id: "teddy_bear", cp: '1f9f8' },
    { id: "pinata", cp: '1fa85' },
    { id: "disco", cp: '1faa9' },
    { id: "nesting_dolls", cp: '1fa86' },
    { id: "spades", cp: '2660' },
    { id: "hearts", cp: '2665' },
    { id: "diamonds", cp: '2666' },
    { id: "clubs", cp: '2663' },
    { id: "chess_pawn", cp: '265f' },
    { id: "black_joker", cp: '1f0cf' },
    { id: "mahjong", cp: '1f004' },
    { id: "flower_playing_cards", cp: '1f3b4' },
    { id: "performing_arts", cp: '1f3ad' },
    { id: "frame_with_picture", cp: '1f5bc' },
    { id: "art", cp: '1f3a8' },
    { id: "thread", cp: '1f9f5' },
    { id: "sewing_needle", cp: '1faa1' },
    { id: "yarn", cp: '1f9f6' },
    { id: "knot", cp: '1faa2' },
  ] },
  { key: 'travel', name: 'Travel & Places', emojis: [
    { id: "earth_africa", cp: '1f30d' },
    { id: "earth_americas", cp: '1f30e' },
    { id: "earth_asia", cp: '1f30f' },
    { id: "globe_with_meridians", cp: '1f310' },
    { id: "world_map", cp: '1f5fa' },
    { id: "japan_map", cp: '1f5fe' },
    { id: "compass", cp: '1f9ed' },
    { id: "mountain_snow", cp: '1f3d4' },
    { id: "mountain", cp: '26f0' },
    { id: "volcano", cp: '1f30b' },
    { id: "mount_fuji", cp: '1f5fb' },
    { id: "camping", cp: '1f3d5' },
    { id: "beach", cp: '1f3d6' },
    { id: "desert", cp: '1f3dc' },
    { id: "desert_island", cp: '1f3dd' },
    { id: "national_park", cp: '1f3de' },
    { id: "stadium", cp: '1f3df' },
    { id: "classical_building", cp: '1f3db' },
    { id: "building_construction", cp: '1f3d7' },
    { id: "bricks", cp: '1f9f1' },
    { id: "rock", cp: '1faa8' },
    { id: "wood", cp: '1fab5' },
    { id: "hut", cp: '1f6d6' },
    { id: "homes", cp: '1f3d8' },
    { id: "derelict_house", cp: '1f3da' },
    { id: "house", cp: '1f3e0' },
    { id: "house_with_garden", cp: '1f3e1' },
    { id: "office", cp: '1f3e2' },
    { id: "post_office", cp: '1f3e3' },
    { id: "european_post_office", cp: '1f3e4' },
    { id: "hospital", cp: '1f3e5' },
    { id: "bank", cp: '1f3e6' },
    { id: "hotel", cp: '1f3e8' },
    { id: "love_hotel", cp: '1f3e9' },
    { id: "convenience_store", cp: '1f3ea' },
    { id: "school", cp: '1f3eb' },
    { id: "department_store", cp: '1f3ec' },
    { id: "factory", cp: '1f3ed' },
    { id: "japanese_castle", cp: '1f3ef' },
    { id: "castle", cp: '1f3f0' },
    { id: "wedding", cp: '1f492' },
    { id: "tokyo_tower", cp: '1f5fc' },
    { id: "statue_of_liberty", cp: '1f5fd' },
    { id: "church", cp: '26ea' },
    { id: "mosque", cp: '1f54c' },
    { id: "hindu_temple", cp: '1f6d5' },
    { id: "synagogue", cp: '1f54d' },
    { id: "shinto_shrine", cp: '26e9' },
    { id: "kaaba", cp: '1f54b' },
    { id: "fountain", cp: '26f2' },
    { id: "tent", cp: '26fa' },
    { id: "foggy", cp: '1f301' },
    { id: "night_with_stars", cp: '1f303' },
    { id: "cityscape", cp: '1f3d9' },
    { id: "sunrise_over_mountains", cp: '1f304' },
    { id: "sunrise", cp: '1f305' },
    { id: "city_dusk", cp: '1f306' },
    { id: "city_sunrise", cp: '1f307' },
    { id: "bridge_at_night", cp: '1f309' },
    { id: "hotsprings", cp: '2668' },
    { id: "carousel_horse", cp: '1f3a0' },
    { id: "playground_slide", cp: '1f6dd' },
    { id: "ferris_wheel", cp: '1f3a1' },
    { id: "roller_coaster", cp: '1f3a2' },
    { id: "barber", cp: '1f488' },
    { id: "circus_tent", cp: '1f3aa' },
    { id: "steam_locomotive", cp: '1f682' },
    { id: "railway_car", cp: '1f683' },
    { id: "bullettrain_side", cp: '1f684' },
    { id: "bullettrain_front", cp: '1f685' },
    { id: "train", cp: '1f686' },
    { id: "metro", cp: '1f687' },
    { id: "light_rail", cp: '1f688' },
    { id: "station", cp: '1f689' },
    { id: "tram", cp: '1f68a' },
    { id: "monorail", cp: '1f69d' },
    { id: "mountain_railway", cp: '1f69e' },
    { id: "tram_car", cp: '1f68b' },
    { id: "bus", cp: '1f68c' },
    { id: "oncoming_bus", cp: '1f68d' },
    { id: "trolleybus", cp: '1f68e' },
    { id: "minibus", cp: '1f690' },
    { id: "ambulance", cp: '1f691' },
    { id: "fire_engine", cp: '1f692' },
    { id: "police_car", cp: '1f693' },
    { id: "oncoming_police_car", cp: '1f694' },
    { id: "taxi", cp: '1f695' },
    { id: "oncoming_taxi", cp: '1f696' },
    { id: "car", cp: '1f697' },
    { id: "oncoming_automobile", cp: '1f698' },
    { id: "blue_car", cp: '1f699' },
    { id: "pickup_truck", cp: '1f6fb' },
    { id: "delivery_truck", cp: '1f69a' },
    { id: "articulated_lorry", cp: '1f69b' },
    { id: "tractor", cp: '1f69c' },
    { id: "racing_car", cp: '1f3ce' },
    { id: "motorcycle", cp: '1f3cd' },
    { id: "motor_scooter", cp: '1f6f5' },
    { id: "manual_wheelchair", cp: '1f9bd' },
    { id: "motorized_wheelchair", cp: '1f9bc' },
    { id: "auto_rickshaw", cp: '1f6fa' },
    { id: "bicycle", cp: '1f6b2' },
    { id: "scooter", cp: '1f6f4' },
    { id: "skateboard", cp: '1f6f9' },
    { id: "roller_skate", cp: '1f6fc' },
    { id: "busstop", cp: '1f68f' },
    { id: "motorway", cp: '1f6e3' },
    { id: "railway_track", cp: '1f6e4' },
    { id: "oil_drum", cp: '1f6e2' },
    { id: "fuelpump", cp: '26fd' },
    { id: "wheel", cp: '1f6de' },
    { id: "rotating_light", cp: '1f6a8' },
    { id: "traffic_light", cp: '1f6a5' },
    { id: "vertical_traffic_light", cp: '1f6a6' },
    { id: "octagonal_sign", cp: '1f6d1' },
    { id: "construction", cp: '1f6a7' },
    { id: "anchor", cp: '2693' },
    { id: "lifebuoy", cp: '1f6df' },
    { id: "sailboat", cp: '26f5' },
    { id: "canoe", cp: '1f6f6' },
    { id: "speedboat", cp: '1f6a4' },
    { id: "cruise_ship", cp: '1f6f3' },
    { id: "ferry", cp: '26f4' },
    { id: "motorboat", cp: '1f6e5' },
    { id: "ship", cp: '1f6a2' },
    { id: "airplane", cp: '2708' },
    { id: "small_airplane", cp: '1f6e9' },
    { id: "airplane_departure", cp: '1f6eb' },
    { id: "airplane_arriving", cp: '1f6ec' },
    { id: "parachute", cp: '1fa82' },
    { id: "seat", cp: '1f4ba' },
    { id: "helicopter", cp: '1f681' },
    { id: "suspension_railway", cp: '1f69f' },
    { id: "mountain_cableway", cp: '1f6a0' },
    { id: "aerial_tramway", cp: '1f6a1' },
    { id: "satellite", cp: '1f6f0' },
    { id: "rocket", cp: '1f680' },
    { id: "flying_saucer", cp: '1f6f8' },
    { id: "bellhop", cp: '1f6ce' },
    { id: "luggage", cp: '1f9f3' },
    { id: "hourglass", cp: '231b' },
    { id: "hourglass_flowing_sand", cp: '23f3' },
    { id: "watch", cp: '231a' },
    { id: "alarm_clock", cp: '23f0' },
    { id: "stopwatch", cp: '23f1' },
    { id: "timer_clock", cp: '23f2' },
    { id: "clock", cp: '1f570' },
    { id: "clock12", cp: '1f55b' },
    { id: "clock1230", cp: '1f567' },
    { id: "clock1", cp: '1f550' },
    { id: "clock130", cp: '1f55c' },
    { id: "clock2", cp: '1f551' },
    { id: "clock230", cp: '1f55d' },
    { id: "clock3", cp: '1f552' },
    { id: "clock330", cp: '1f55e' },
    { id: "clock4", cp: '1f553' },
    { id: "clock430", cp: '1f55f' },
    { id: "clock5", cp: '1f554' },
    { id: "clock530", cp: '1f560' },
    { id: "clock6", cp: '1f555' },
    { id: "clock630", cp: '1f561' },
    { id: "clock7", cp: '1f556' },
    { id: "clock730", cp: '1f562' },
    { id: "clock8", cp: '1f557' },
    { id: "clock830", cp: '1f563' },
    { id: "clock9", cp: '1f558' },
    { id: "clock930", cp: '1f564' },
    { id: "clock10", cp: '1f559' },
    { id: "clock1030", cp: '1f565' },
    { id: "clock11", cp: '1f55a' },
    { id: "clock1130", cp: '1f566' },
    { id: "new_moon", cp: '1f311' },
    { id: "waxing_crescent_moon", cp: '1f312' },
    { id: "first_quarter_moon", cp: '1f313' },
    { id: "waxing_gibbous_moon", cp: '1f314' },
    { id: "full_moon", cp: '1f315' },
    { id: "waning_gibbous_moon", cp: '1f316' },
    { id: "last_quarter_moon", cp: '1f317' },
    { id: "waning_crescent_moon", cp: '1f318' },
    { id: "crescent_moon", cp: '1f319' },
    { id: "new_moon_with_face", cp: '1f31a' },
    { id: "first_quarter_moon_with_face", cp: '1f31b' },
    { id: "last_quarter_moon_with_face", cp: '1f31c' },
    { id: "thermometer", cp: '1f321' },
    { id: "sun", cp: '2600' },
    { id: "full_moon_with_face", cp: '1f31d' },
    { id: "sun_with_face", cp: '1f31e' },
    { id: "ringed_planet", cp: '1fa90' },
    { id: "star", cp: '2b50' },
    { id: "glowing_star", cp: '1f31f' },
    { id: "shooting_star", cp: '1f320' },
    { id: "milky_way", cp: '1f30c' },
    { id: "cloud", cp: '2601' },
    { id: "partly_sunny", cp: '26c5' },
    { id: "stormy", cp: '26c8' },
    { id: "sun_behind_small_cloud", cp: '1f324' },
    { id: "cloudy", cp: '1f325' },
    { id: "sun_and_rain", cp: '1f326' },
    { id: "cloud_with_rain", cp: '1f327' },
    { id: "cloud_with_snow", cp: '1f328' },
    { id: "cloud_with_lightning", cp: '1f329' },
    { id: "tornado", cp: '1f32a' },
    { id: "fog", cp: '1f32b' },
    { id: "wind_blowing_face", cp: '1f32c' },
    { id: "cyclone", cp: '1f300' },
    { id: "rainbow", cp: '1f308' },
    { id: "closed_umbrella", cp: '1f302' },
    { id: "umbrella", cp: '2602' },
    { id: "umbrella_with_rain", cp: '2614' },
    { id: "beach_umbrella", cp: '26f1' },
    { id: "high_voltage", cp: '26a1' },
    { id: "snowflake", cp: '2744' },
    { id: "snowman2", cp: '2603' },
    { id: "snowman", cp: '26c4' },
    { id: "comet", cp: '2604' },
    { id: "fire", cp: '1f525' },
    { id: "droplet", cp: '1f4a7' },
    { id: "ocean", cp: '1f30a' },
  ] },
  { key: 'objects', name: 'Objects', emojis: [
    { id: "eyeglasses", cp: '1f453' },
    { id: "sunglasses", cp: '1f576' },
    { id: "goggles", cp: '1f97d' },
    { id: "lab_coat", cp: '1f97c' },
    { id: "safety_vest", cp: '1f9ba' },
    { id: "necktie", cp: '1f454' },
    { id: "shirt", cp: '1f455' },
    { id: "jeans", cp: '1f456' },
    { id: "scarf", cp: '1f9e3' },
    { id: "gloves", cp: '1f9e4' },
    { id: "coat", cp: '1f9e5' },
    { id: "socks", cp: '1f9e6' },
    { id: "dress", cp: '1f457' },
    { id: "kimono", cp: '1f458' },
    { id: "sari", cp: '1f97b' },
    { id: "one_piece_swimsuit", cp: '1fa71' },
    { id: "briefs", cp: '1fa72' },
    { id: "shorts", cp: '1fa73' },
    { id: "bikini", cp: '1f459' },
    { id: "womans_clothes", cp: '1f45a' },
    { id: "purse", cp: '1f45b' },
    { id: "handbag", cp: '1f45c' },
    { id: "clutch_bag", cp: '1f45d' },
    { id: "shopping_bags", cp: '1f6cd' },
    { id: "backpack", cp: '1f392' },
    { id: "thong_sandal", cp: '1fa74' },
    { id: "mans_shoe", cp: '1f45e' },
    { id: "athletic_shoe", cp: '1f45f' },
    { id: "hiking_boot", cp: '1f97e' },
    { id: "flat_shoe", cp: '1f97f' },
    { id: "high_heel", cp: '1f460' },
    { id: "sandal", cp: '1f461' },
    { id: "ballet_shoes", cp: '1fa70' },
    { id: "boot", cp: '1f462' },
    { id: "crown", cp: '1f451' },
    { id: "womans_hat", cp: '1f452' },
    { id: "top_hat", cp: '1f3a9' },
    { id: "graduation_cap", cp: '1f393' },
    { id: "billed_cap", cp: '1f9e2' },
    { id: "military_helmet", cp: '1fa96' },
    { id: "helmet_with_cross", cp: '26d1' },
    { id: "prayer_beads", cp: '1f4ff' },
    { id: "lipstick", cp: '1f484' },
    { id: "ring", cp: '1f48d' },
    { id: "gem", cp: '1f48e' },
    { id: "mute", cp: '1f507' },
    { id: "low_volume", cp: '1f508' },
    { id: "medium_volumne", cp: '1f509' },
    { id: "high_volume", cp: '1f50a' },
    { id: "loudspeaker", cp: '1f4e2' },
    { id: "mega", cp: '1f4e3' },
    { id: "postal_horn", cp: '1f4ef' },
    { id: "bell", cp: '1f514' },
    { id: "no_bell", cp: '1f515' },
    { id: "musical_score", cp: '1f3bc' },
    { id: "musical_note", cp: '1f3b5' },
    { id: "musical_notes", cp: '1f3b6' },
    { id: "studio_microphone", cp: '1f399' },
    { id: "level_slider", cp: '1f39a' },
    { id: "control_knobs", cp: '1f39b' },
    { id: "microphone", cp: '1f3a4' },
    { id: "headphones", cp: '1f3a7' },
    { id: "radio", cp: '1f4fb' },
    { id: "saxophone", cp: '1f3b7' },
    { id: "accordion", cp: '1fa97' },
    { id: "guitar", cp: '1f3b8' },
    { id: "musical_keyboard", cp: '1f3b9' },
    { id: "trumpet", cp: '1f3ba' },
    { id: "violin", cp: '1f3bb' },
    { id: "banjo", cp: '1fa95' },
    { id: "drum", cp: '1f941' },
    { id: "long_drum", cp: '1fa98' },
    { id: "android", cp: '1f4f1' },
    { id: "calling", cp: '1f4f2' },
    { id: "telephone", cp: '260e' },
    { id: "telephone_receiver", cp: '1f4de' },
    { id: "pager", cp: '1f4df' },
    { id: "fax", cp: '1f4e0' },
    { id: "battery", cp: '1f50b' },
    { id: "low_battery", cp: '1faab' },
    { id: "electric_plug", cp: '1f50c' },
    { id: "laptop", cp: '1f4bb' },
    { id: "computer", cp: '1f5a5' },
    { id: "printer", cp: '1f5a8' },
    { id: "keyboard", cp: '2328' },
    { id: "computer_mouse", cp: '1f5b1' },
    { id: "trackball", cp: '1f5b2' },
    { id: "computer_disk", cp: '1f4bd' },
    { id: "floppy_disk", cp: '1f4be' },
    { id: "cd", cp: '1f4bf' },
    { id: "dvd", cp: '1f4c0' },
    { id: "abacus", cp: '1f9ee' },
    { id: "movie_camera", cp: '1f3a5' },
    { id: "film_frames", cp: '1f39e' },
    { id: "film_projector", cp: '1f4fd' },
    { id: "clapper", cp: '1f3ac' },
    { id: "tv", cp: '1f4fa' },
    { id: "camera", cp: '1f4f7' },
    { id: "camera_with_flash", cp: '1f4f8' },
    { id: "video_camera", cp: '1f4f9' },
    { id: "vhs", cp: '1f4fc' },
    { id: "mag", cp: '1f50d' },
    { id: "mag_right", cp: '1f50e' },
    { id: "candle", cp: '1f56f' },
    { id: "bulb", cp: '1f4a1' },
    { id: "flashlight", cp: '1f526' },
    { id: "izakaya_lantern", cp: '1f3ee' },
    { id: "diya_lamp", cp: '1fa94' },
    { id: "notebook_with_decorative_cover", cp: '1f4d4' },
    { id: "closed_book", cp: '1f4d5' },
    { id: "book", cp: '1f4d6' },
    { id: "green_book", cp: '1f4d7' },
    { id: "blue_book", cp: '1f4d8' },
    { id: "orange_book", cp: '1f4d9' },
    { id: "books", cp: '1f4da' },
    { id: "notebook", cp: '1f4d3' },
    { id: "ledger", cp: '1f4d2' },
    { id: "page_with_curl", cp: '1f4c3' },
    { id: "scroll", cp: '1f4dc' },
    { id: "page_facing_up", cp: '1f4c4' },
    { id: "newspaper", cp: '1f4f0' },
    { id: "rolled_up_newspaper", cp: '1f5de' },
    { id: "bookmark_tabs", cp: '1f4d1' },
    { id: "bookmark", cp: '1f516' },
    { id: "label", cp: '1f3f7' },
    { id: "moneybag", cp: '1f4b0' },
    { id: "coin", cp: '1fa99' },
    { id: "yen", cp: '1f4b4' },
    { id: "dollar", cp: '1f4b5' },
    { id: "euro", cp: '1f4b6' },
    { id: "pound", cp: '1f4b7' },
    { id: "money_with_wings", cp: '1f4b8' },
    { id: "credit_card", cp: '1f4b3' },
    { id: "receipt", cp: '1f9fe' },
    { id: "chart", cp: '1f4b9' },
    { id: "envelope", cp: '2709' },
    { id: "e-mail", cp: '1f4e7' },
    { id: "incoming_envelope", cp: '1f4e8' },
    { id: "envelope_with_arrow", cp: '1f4e9' },
    { id: "outbox_tray", cp: '1f4e4' },
    { id: "inbox_tray", cp: '1f4e5' },
    { id: "package", cp: '1f4e6' },
    { id: "mailbox", cp: '1f4eb' },
    { id: "mailbox_closed", cp: '1f4ea' },
    { id: "mailbox_with_mail", cp: '1f4ec' },
    { id: "mailbox_with_no_mail", cp: '1f4ed' },
    { id: "postbox", cp: '1f4ee' },
    { id: "ballot_box", cp: '1f5f3' },
    { id: "pencil", cp: '270f' },
    { id: "black_nib", cp: '2712' },
    { id: "fountain_pen", cp: '1f58b' },
    { id: "pen", cp: '1f58a' },
    { id: "paintbrush", cp: '1f58c' },
    { id: "crayon", cp: '1f58d' },
    { id: "memo", cp: '1f4dd' },
    { id: "briefcase", cp: '1f4bc' },
    { id: "file_folder", cp: '1f4c1' },
    { id: "open_file_folder", cp: '1f4c2' },
    { id: "card_index_dividers", cp: '1f5c2' },
    { id: "date", cp: '1f4c5' },
    { id: "calendar", cp: '1f4c6' },
    { id: "notepad_spiral", cp: '1f5d2' },
    { id: "calendar_spiral", cp: '1f5d3' },
    { id: "card_index", cp: '1f4c7' },
    { id: "chart_increasing", cp: '1f4c8' },
    { id: "chart_decreasing", cp: '1f4c9' },
    { id: "bar_chart", cp: '1f4ca' },
    { id: "clipboard", cp: '1f4cb' },
    { id: "pushpin", cp: '1f4cc' },
    { id: "round_pushpin", cp: '1f4cd' },
    { id: "paperclip", cp: '1f4ce' },
    { id: "paperclips", cp: '1f587' },
    { id: "straight_ruler", cp: '1f4cf' },
    { id: "triangular_ruler", cp: '1f4d0' },
    { id: "scissors", cp: '2702' },
    { id: "card_file_box", cp: '1f5c3' },
    { id: "file_cabinet", cp: '1f5c4' },
    { id: "trashcan", cp: '1f5d1' },
    { id: "lock", cp: '1f512' },
    { id: "unlock", cp: '1f513' },
    { id: "lock_with_ink_pen", cp: '1f50f' },
    { id: "closed_lock_with_key", cp: '1f510' },
    { id: "key", cp: '1f511' },
    { id: "old_key", cp: '1f5dd' },
    { id: "hammer", cp: '1f528' },
    { id: "axe", cp: '1fa93' },
    { id: "pick", cp: '26cf' },
    { id: "hammer_and_pick", cp: '2692' },
    { id: "hammer_and_wrench", cp: '1f6e0' },
    { id: "dagger", cp: '1f5e1' },
    { id: "crossed_swords", cp: '2694' },
    { id: "bomb", cp: '1f4a3' },
    { id: "boomerang", cp: '1fa83' },
    { id: "bow_and_arrow", cp: '1f3f9' },
    { id: "shield", cp: '1f6e1' },
    { id: "carpentry_saw", cp: '1fa9a' },
    { id: "wrench", cp: '1f527' },
    { id: "screwdriver", cp: '1fa9b' },
    { id: "nut_and_bolt", cp: '1f529' },
    { id: "gear", cp: '2699' },
    { id: "clamp", cp: '1f5dc' },
    { id: "scales", cp: '2696' },
    { id: "probing_cane", cp: '1f9af' },
    { id: "link", cp: '1f517' },
    { id: "chains", cp: '26d3' },
    { id: "hook", cp: '1fa9d' },
    { id: "toolbox", cp: '1f9f0' },
    { id: "magnet", cp: '1f9f2' },
    { id: "ladder", cp: '1fa9c' },
    { id: "alembic", cp: '2697' },
    { id: "test_tube", cp: '1f9ea' },
    { id: "petri_dish", cp: '1f9eb' },
    { id: "dna", cp: '1f9ec' },
    { id: "microscope", cp: '1f52c' },
    { id: "telescope", cp: '1f52d' },
    { id: "satellite_antenna", cp: '1f4e1' },
    { id: "syringe", cp: '1f489' },
    { id: "drop_of_blood", cp: '1fa78' },
    { id: "pill", cp: '1f48a' },
    { id: "adhesive_bandage", cp: '1fa79' },
    { id: "crutch", cp: '1fa7c' },
    { id: "stethoscope", cp: '1fa7a' },
    { id: "x-ray", cp: '1fa7b' },
    { id: "door", cp: '1f6aa' },
    { id: "elevator", cp: '1f6d7' },
    { id: "mirror", cp: '1fa9e' },
    { id: "window", cp: '1fa9f' },
    { id: "bed", cp: '1f6cf' },
    { id: "couch_and_lamp", cp: '1f6cb' },
    { id: "chair", cp: '1fa91' },
    { id: "toilet", cp: '1f6bd' },
    { id: "plunger", cp: '1faa0' },
    { id: "shower", cp: '1f6bf' },
    { id: "bathtub", cp: '1f6c1' },
    { id: "mouse_trap", cp: '1faa4' },
    { id: "razor", cp: '1fa92' },
    { id: "lotion_bottle", cp: '1f9f4' },
    { id: "safety_pin", cp: '1f9f7' },
    { id: "broom", cp: '1f9f9' },
    { id: "basket", cp: '1f9fa' },
    { id: "roll_of_paper", cp: '1f9fb' },
    { id: "bucket", cp: '1faa3' },
    { id: "soap", cp: '1f9fc' },
    { id: "bubbles", cp: '1fae7' },
    { id: "toothbrush", cp: '1faa5' },
    { id: "sponge", cp: '1f9fd' },
    { id: "fire_extinguisher", cp: '1f9ef' },
    { id: "shopping_cart", cp: '1f6d2' },
    { id: "cigarette", cp: '1f6ac' },
    { id: "coffin", cp: '26b0' },
    { id: "headstone", cp: '1faa6' },
    { id: "funeral_urn", cp: '26b1' },
    { id: "nazar_amulet", cp: '1f9ff' },
    { id: "hamsa", cp: '1faac' },
    { id: "moai", cp: '1f5ff' },
    { id: "placard", cp: '1faa7' },
    { id: "id_card", cp: '1faaa' },
  ] },
  { key: 'symbols', name: 'Symbols', emojis: [
    { id: "atm", cp: '1f3e7' },
    { id: "litter_bin", cp: '1f6ae' },
    { id: "potable_water", cp: '1f6b0' },
    { id: "handicapped", cp: '267f' },
    { id: "mens", cp: '1f6b9' },
    { id: "womens", cp: '1f6ba' },
    { id: "bathroom", cp: '1f6bb' },
    { id: "baby_symbol", cp: '1f6bc' },
    { id: "water_closet", cp: '1f6be' },
    { id: "passport_control", cp: '1f6c2' },
    { id: "customs", cp: '1f6c3' },
    { id: "baggage_claim", cp: '1f6c4' },
    { id: "left_luggage", cp: '1f6c5' },
    { id: "warning", cp: '26a0' },
    { id: "children_crossing", cp: '1f6b8' },
    { id: "no_entry", cp: '26d4' },
    { id: "no_entry_sign", cp: '1f6ab' },
    { id: "no_bicycles", cp: '1f6b3' },
    { id: "no_smoking", cp: '1f6ad' },
    { id: "do_not_litter", cp: '1f6af' },
    { id: "non-potable_water", cp: '1f6b1' },
    { id: "no_pedestrians", cp: '1f6b7' },
    { id: "no_mobile_phones", cp: '1f4f5' },
    { id: "no_one_under_18", cp: '1f51e' },
    { id: "radioactive", cp: '2622' },
    { id: "biohazard", cp: '2623' },
    { id: "arrow_up", cp: '2b06' },
    { id: "arrow_upper_right", cp: '2197' },
    { id: "arrow_right", cp: '27a1' },
    { id: "arrow_lower_right", cp: '2198' },
    { id: "arrow_down", cp: '2b07' },
    { id: "arrow_lower_left", cp: '2199' },
    { id: "arrow_left", cp: '2b05' },
    { id: "arrow_upper_left", cp: '2196' },
    { id: "arrow_up_down", cp: '2195' },
    { id: "left_right_arrow", cp: '2194' },
    { id: "arrow_left_hook", cp: '21a9' },
    { id: "arrow_right_hook", cp: '21aa' },
    { id: "arrow_heading_up", cp: '2934' },
    { id: "arrow_heading_down", cp: '2935' },
    { id: "arrows_clockwise", cp: '1f503' },
    { id: "arrows_counterclockwise", cp: '1f504' },
    { id: "back", cp: '1f519' },
    { id: "end", cp: '1f51a' },
    { id: "on", cp: '1f51b' },
    { id: "soon", cp: '1f51c' },
    { id: "top", cp: '1f51d' },
    { id: "place_of_worship", cp: '1f6d0' },
    { id: "atom", cp: '269b' },
    { id: "om", cp: '1f549' },
    { id: "star_of_david", cp: '2721' },
    { id: "wheel_of_dharma", cp: '2638' },
    { id: "yin_yang", cp: '262f' },
    { id: "latin_cross", cp: '271d' },
    { id: "orthodox_cross", cp: '2626' },
    { id: "star_and_crescent", cp: '262a' },
    { id: "peace", cp: '262e' },
    { id: "menorah", cp: '1f54e' },
    { id: "six_pointed_star", cp: '1f52f' },
    { id: "aries", cp: '2648' },
    { id: "taurus", cp: '2649' },
    { id: "gemini", cp: '264a' },
    { id: "cancer", cp: '264b' },
    { id: "leo", cp: '264c' },
    { id: "virgo", cp: '264d' },
    { id: "libra", cp: '264e' },
    { id: "scorpius", cp: '264f' },
    { id: "sagittarius", cp: '2650' },
    { id: "capricorn", cp: '2651' },
    { id: "aquarius", cp: '2652' },
    { id: "pisces", cp: '2653' },
    { id: "ophiuchus", cp: '26ce' },
    { id: "shuffle", cp: '1f500' },
    { id: "repeat", cp: '1f501' },
    { id: "repeat_one", cp: '1f502' },
    { id: "arrow_forward", cp: '25b6' },
    { id: "fast_forward", cp: '23e9' },
    { id: "next_track", cp: '23ed' },
    { id: "play_pause", cp: '23ef' },
    { id: "arrow_backward", cp: '25c0' },
    { id: "fast_reverse", cp: '23ea' },
    { id: "previous_track", cp: '23ee' },
    { id: "arrow_up_small", cp: '1f53c' },
    { id: "arrow_double_up", cp: '23eb' },
    { id: "arrow_down_small", cp: '1f53d' },
    { id: "arrow_double_down", cp: '23ec' },
    { id: "pause", cp: '23f8' },
    { id: "stop", cp: '23f9' },
    { id: "record", cp: '23fa' },
    { id: "eject", cp: '23cf' },
    { id: "cinema", cp: '1f3a6' },
    { id: "dim_button", cp: '1f505' },
    { id: "bright_button", cp: '1f506' },
    { id: "antenna_bars", cp: '1f4f6' },
    { id: "vibration_mode", cp: '1f4f3' },
    { id: "mobile_phone_off", cp: '1f4f4' },
    { id: "female", cp: '2640' },
    { id: "male", cp: '2642' },
    { id: "transgender_symbol", cp: '26a7' },
    { id: "multiplication", cp: '2716' },
    { id: "plus", cp: '2795' },
    { id: "minus", cp: '2796' },
    { id: "divide", cp: '2797' },
    { id: "heavy_equals_sign", cp: '1f7f0' },
    { id: "infinity", cp: '267e' },
    { id: "bangbang", cp: '203c' },
    { id: "exclamation_question", cp: '2049' },
    { id: "question", cp: '2753' },
    { id: "white_question", cp: '2754' },
    { id: "white_exclamation", cp: '2755' },
    { id: "exclamation", cp: '2757' },
    { id: "wavy_dash", cp: '3030' },
    { id: "currency_exchange", cp: '1f4b1' },
    { id: "heavy_dollar_sign", cp: '1f4b2' },
    { id: "medical", cp: '2695' },
    { id: "recycle", cp: '267b' },
    { id: "fleur-de-lis", cp: '269c' },
    { id: "trident", cp: '1f531' },
    { id: "name_badge", cp: '1f4db' },
    { id: "beginner", cp: '1f530' },
    { id: "hollow_red_circle", cp: '2b55' },
    { id: "check_mark_button", cp: '2705' },
    { id: "ballot_box_with_check", cp: '2611' },
    { id: "check_mark", cp: '2714' },
    { id: "cross_mark", cp: '274c' },
    { id: "cross_mark_button", cp: '274e' },
    { id: "curly_loop", cp: '27b0' },
    { id: "double_curly_loop", cp: '27bf' },
    { id: "part_alternation_mark", cp: '303d' },
    { id: "eight_spoked_asterisk", cp: '2733' },
    { id: "eight_pointed_black_star", cp: '2734' },
    { id: "sparkle", cp: '2747' },
    { id: "copyright", cp: 'a9' },
    { id: "registered", cp: 'ae' },
    { id: "tm", cp: '2122' },
    { id: "hash", cp: '23-20e3' },
    { id: "asterisk", cp: '2a-20e3' },
    { id: "zero", cp: '30-20e3' },
    { id: "one", cp: '31-20e3' },
    { id: "two", cp: '32-20e3' },
    { id: "three", cp: '33-20e3' },
    { id: "four", cp: '34-20e3' },
    { id: "five", cp: '35-20e3' },
    { id: "six", cp: '36-20e3' },
    { id: "seven", cp: '37-20e3' },
    { id: "eight", cp: '38-20e3' },
    { id: "nine", cp: '39-20e3' },
    { id: "ten", cp: '1f51f' },
    { id: "capital_abcd", cp: '1f520' },
    { id: "abcd", cp: '1f521' },
    { id: "1234", cp: '1f522' },
    { id: "symbols", cp: '1f523' },
    { id: "abc", cp: '1f524' },
    { id: "a", cp: '1f170' },
    { id: "ab", cp: '1f18e' },
    { id: "b", cp: '1f171' },
    { id: "cl", cp: '1f191' },
    { id: "cool", cp: '1f192' },
    { id: "free", cp: '1f193' },
    { id: "info", cp: '2139' },
    { id: "id", cp: '1f194' },
    { id: "m", cp: '24c2' },
    { id: "new", cp: '1f195' },
    { id: "ng", cp: '1f196' },
    { id: "o", cp: '1f17e' },
    { id: "ok", cp: '1f197' },
    { id: "parking", cp: '1f17f' },
    { id: "sos", cp: '1f198' },
    { id: "up2", cp: '1f199' },
    { id: "vs", cp: '1f19a' },
    { id: "ja_here", cp: '1f201' },
    { id: "ja_service_charge", cp: '1f202' },
    { id: "ja_monthly_amount", cp: '1f237' },
    { id: "ja_not_free_of_carge", cp: '1f236' },
    { id: "ja_reserved", cp: '1f22f' },
    { id: "ideograph_advantage", cp: '1f250' },
    { id: "ja_discount", cp: '1f239' },
    { id: "ja_free_of_charge", cp: '1f21a' },
    { id: "ja_prohibited", cp: '1f232' },
    { id: "accept", cp: '1f251' },
    { id: "ja_application", cp: '1f238' },
    { id: "ja_passing_grade", cp: '1f234' },
    { id: "ja_vacancy", cp: '1f233' },
    { id: "congratulations", cp: '3297' },
    { id: "ja_secret", cp: '3299' },
    { id: "ja_open_for_business", cp: '1f23a' },
    { id: "ja_no_vacancy", cp: '1f235' },
    { id: "red_circle", cp: '1f534' },
    { id: "orange_circle", cp: '1f7e0' },
    { id: "yellow_circle", cp: '1f7e1' },
    { id: "green_circle", cp: '1f7e2' },
    { id: "blue_circle", cp: '1f535' },
    { id: "purple_circle", cp: '1f7e3' },
    { id: "brown_circle", cp: '1f7e4' },
    { id: "black_circle", cp: '26ab' },
    { id: "white_circle", cp: '26aa' },
    { id: "red_square", cp: '1f7e5' },
    { id: "orange_square", cp: '1f7e7' },
    { id: "yellow_square", cp: '1f7e8' },
    { id: "green_square", cp: '1f7e9' },
    { id: "blue_square", cp: '1f7e6' },
    { id: "purple_square", cp: '1f7ea' },
    { id: "brown_square", cp: '1f7eb' },
    { id: "black_large_square", cp: '2b1b' },
    { id: "white_large_square", cp: '2b1c' },
    { id: "black_medium_square", cp: '25fc' },
    { id: "white_medium_square", cp: '25fb' },
    { id: "black_medium_small_square", cp: '25fe' },
    { id: "white_medium_small_square", cp: '25fd' },
    { id: "black_small_square", cp: '25aa' },
    { id: "white_small_square", cp: '25ab' },
    { id: "large_orange_diamond", cp: '1f536' },
    { id: "large_blue_diamond", cp: '1f537' },
    { id: "small_orange_diamond", cp: '1f538' },
    { id: "small_blue_diamond", cp: '1f539' },
    { id: "small_red_triangle", cp: '1f53a' },
    { id: "small_red_triangle_down", cp: '1f53b' },
    { id: "diamond_shape_with_a_dot_inside", cp: '1f4a0' },
    { id: "radio_button", cp: '1f518' },
    { id: "white_square_button", cp: '1f533' },
    { id: "black_square_button", cp: '1f532' },
  ] },
  { key: 'flags', name: 'Flags', emojis: [
    { id: "checkered_flag", cp: '1f3c1' },
    { id: "triangular_flag", cp: '1f6a9' },
    { id: "crossed_flags", cp: '1f38c' },
    { id: "black_flag", cp: '1f3f4' },
    { id: "white_flag", cp: '1f3f3' },
    { id: "rainbow_flag", cp: '1f3f3-fe0f-200d-1f308' },
    { id: "transgender_flag", cp: '1f3f3-fe0f-200d-26a7-fe0f' },
    { id: "jolly_roger", cp: '1f3f4-200d-2620-fe0f' },
    { id: "ascension_island", cp: '1f1e6-1f1e8' },
    { id: "andorra", cp: '1f1e6-1f1e9' },
    { id: "flag_ae", cp: '1f1e6-1f1ea' },
    { id: "afghanistan", cp: '1f1e6-1f1eb' },
    { id: "antigua_barbuda", cp: '1f1e6-1f1ec' },
    { id: "anguilla", cp: '1f1e6-1f1ee' },
    { id: "albania", cp: '1f1e6-1f1f1' },
    { id: "armenia", cp: '1f1e6-1f1f2' },
    { id: "angola", cp: '1f1e6-1f1f4' },
    { id: "antarctica", cp: '1f1e6-1f1f6' },
    { id: "argentina", cp: '1f1e6-1f1f7' },
    { id: "american_samoa", cp: '1f1e6-1f1f8' },
    { id: "austria", cp: '1f1e6-1f1f9' },
    { id: "australia", cp: '1f1e6-1f1fa' },
    { id: "aruba", cp: '1f1e6-1f1fc' },
    { id: "aland_islands", cp: '1f1e6-1f1fd' },
    { id: "azerbaijan", cp: '1f1e6-1f1ff' },
    { id: "bosnia_herzegovina", cp: '1f1e7-1f1e6' },
    { id: "barbados", cp: '1f1e7-1f1e7' },
    { id: "bangladesh", cp: '1f1e7-1f1e9' },
    { id: "belgium", cp: '1f1e7-1f1ea' },
    { id: "burkina_faso", cp: '1f1e7-1f1eb' },
    { id: "bulgaria", cp: '1f1e7-1f1ec' },
    { id: "bahrain", cp: '1f1e7-1f1ed' },
    { id: "burundi", cp: '1f1e7-1f1ee' },
    { id: "benin", cp: '1f1e7-1f1ef' },
    { id: "flag_bl", cp: '1f1e7-1f1f1' },
    { id: "bermuda", cp: '1f1e7-1f1f2' },
    { id: "brunei", cp: '1f1e7-1f1f3' },
    { id: "bolivia", cp: '1f1e7-1f1f4' },
    { id: "caribbean_netherlands", cp: '1f1e7-1f1f6' },
    { id: "brazil", cp: '1f1e7-1f1f7' },
    { id: "bahamas", cp: '1f1e7-1f1f8' },
    { id: "bhutan", cp: '1f1e7-1f1f9' },
    { id: "bouvet_island", cp: '1f1e7-1f1fb' },
    { id: "botswana", cp: '1f1e7-1f1fc' },
    { id: "belarus", cp: '1f1e7-1f1fe' },
    { id: "belize", cp: '1f1e7-1f1ff' },
    { id: "canada", cp: '1f1e8-1f1e6' },
    { id: "cocos_islands", cp: '1f1e8-1f1e8' },
    { id: "congo_kinshasa", cp: '1f1e8-1f1e9' },
    { id: "central_african_republic", cp: '1f1e8-1f1eb' },
    { id: "congo_brazzaville", cp: '1f1e8-1f1ec' },
    { id: "flag_ch", cp: '1f1e8-1f1ed' },
    { id: "cote_divoire", cp: '1f1e8-1f1ee' },
    { id: "cook_islands", cp: '1f1e8-1f1f0' },
    { id: "chile", cp: '1f1e8-1f1f1' },
    { id: "cameroon", cp: '1f1e8-1f1f2' },
    { id: "china", cp: '1f1e8-1f1f3' },
    { id: "colombia", cp: '1f1e8-1f1f4' },
    { id: "clipperton_island", cp: '1f1e8-1f1f5' },
    { id: "costa_rica", cp: '1f1e8-1f1f7' },
    { id: "cuba", cp: '1f1e8-1f1fa' },
    { id: "cape_verde", cp: '1f1e8-1f1fb' },
    { id: "curacao", cp: '1f1e8-1f1fc' },
    { id: "christmas_island", cp: '1f1e8-1f1fd' },
    { id: "cyprus", cp: '1f1e8-1f1fe' },
    { id: "czech_republic", cp: '1f1e8-1f1ff' },
    { id: "flag_de", cp: '1f1e9-1f1ea' },
    { id: "diego_garcia", cp: '1f1e9-1f1ec' },
    { id: "djibouti", cp: '1f1e9-1f1ef' },
    { id: "denmark", cp: '1f1e9-1f1f0' },
    { id: "dominica", cp: '1f1e9-1f1f2' },
    { id: "dominican_republic", cp: '1f1e9-1f1f4' },
    { id: "algeria", cp: '1f1e9-1f1ff' },
    { id: "ceuta_melilla", cp: '1f1ea-1f1e6' },
    { id: "ecuador", cp: '1f1ea-1f1e8' },
    { id: "estonia", cp: '1f1ea-1f1ea' },
    { id: "egypt", cp: '1f1ea-1f1ec' },
    { id: "flag_eh", cp: '1f1ea-1f1ed' },
    { id: "eritrea", cp: '1f1ea-1f1f7' },
    { id: "flag_es", cp: '1f1ea-1f1f8' },
    { id: "ethiopia", cp: '1f1ea-1f1f9' },
    { id: "european_union", cp: '1f1ea-1f1fa' },
    { id: "finland", cp: '1f1eb-1f1ee' },
    { id: "fiji", cp: '1f1eb-1f1ef' },
    { id: "falkland_islands", cp: '1f1eb-1f1f0' },
    { id: "flag_fm", cp: '1f1eb-1f1f2' },
    { id: "faroe_islands", cp: '1f1eb-1f1f4' },
    { id: "flag_fr", cp: '1f1eb-1f1f7' },
    { id: "flag_ga", cp: '1f1ec-1f1e6' },
    { id: "flag_gb", cp: '1f1ec-1f1e7' },
    { id: "flag_gd", cp: '1f1ec-1f1e9' },
    { id: "flag_ge", cp: '1f1ec-1f1ea' },
    { id: "flag_gf", cp: '1f1ec-1f1eb' },
    { id: "flag_gg", cp: '1f1ec-1f1ec' },
    { id: "flag_gh", cp: '1f1ec-1f1ed' },
    { id: "flag_gi", cp: '1f1ec-1f1ee' },
    { id: "flag_gl", cp: '1f1ec-1f1f1' },
    { id: "flag_gm", cp: '1f1ec-1f1f2' },
    { id: "flag_gn", cp: '1f1ec-1f1f3' },
    { id: "flag_gp", cp: '1f1ec-1f1f5' },
    { id: "equatorial_guinea", cp: '1f1ec-1f1f6' },
    { id: "flag_gr", cp: '1f1ec-1f1f7' },
    { id: "flag_gs", cp: '1f1ec-1f1f8' },
    { id: "flag_gt", cp: '1f1ec-1f1f9' },
    { id: "flag_gu", cp: '1f1ec-1f1fa' },
    { id: "flag_gw", cp: '1f1ec-1f1fc' },
    { id: "flag_gy", cp: '1f1ec-1f1fe' },
    { id: "flag_hk", cp: '1f1ed-1f1f0' },
    { id: "flag_hm", cp: '1f1ed-1f1f2' },
    { id: "flag_hn", cp: '1f1ed-1f1f3' },
    { id: "croatia", cp: '1f1ed-1f1f7' },
    { id: "flag_ht", cp: '1f1ed-1f1f9' },
    { id: "flag_hu", cp: '1f1ed-1f1fa' },
    { id: "canary_islands", cp: '1f1ee-1f1e8' },
    { id: "flag_id", cp: '1f1ee-1f1e9' },
    { id: "flag_ie", cp: '1f1ee-1f1ea' },
    { id: "flag_il", cp: '1f1ee-1f1f1' },
    { id: "flag_im", cp: '1f1ee-1f1f2' },
    { id: "flag_in", cp: '1f1ee-1f1f3' },
    { id: "british_indian_ocean_territory", cp: '1f1ee-1f1f4' },
    { id: "flag_iq", cp: '1f1ee-1f1f6' },
    { id: "flag_ir", cp: '1f1ee-1f1f7' },
    { id: "flag_is", cp: '1f1ee-1f1f8' },
    { id: "flag_it", cp: '1f1ee-1f1f9' },
    { id: "flag_je", cp: '1f1ef-1f1ea' },
    { id: "flag_jm", cp: '1f1ef-1f1f2' },
    { id: "flag_jo", cp: '1f1ef-1f1f4' },
    { id: "flag_jp", cp: '1f1ef-1f1f5' },
    { id: "flag_ke", cp: '1f1f0-1f1ea' },
    { id: "flag_kg", cp: '1f1f0-1f1ec' },
    { id: "cambodia", cp: '1f1f0-1f1ed' },
    { id: "flag_ki", cp: '1f1f0-1f1ee' },
    { id: "comoros", cp: '1f1f0-1f1f2' },
    { id: "flag_kn", cp: '1f1f0-1f1f3' },
    { id: "flag_kp", cp: '1f1f0-1f1f5' },
    { id: "flag_kr", cp: '1f1f0-1f1f7' },
    { id: "flag_kw", cp: '1f1f0-1f1fc' },
    { id: "cayman_islands", cp: '1f1f0-1f1fe' },
    { id: "flag_kz", cp: '1f1f0-1f1ff' },
    { id: "flag_la", cp: '1f1f1-1f1e6' },
    { id: "flag_lb", cp: '1f1f1-1f1e7' },
    { id: "flag_lc", cp: '1f1f1-1f1e8' },
    { id: "flag_li", cp: '1f1f1-1f1ee' },
    { id: "flag_lk", cp: '1f1f1-1f1f0' },
    { id: "flag_lr", cp: '1f1f1-1f1f7' },
    { id: "flag_ls", cp: '1f1f1-1f1f8' },
    { id: "flag_lt", cp: '1f1f1-1f1f9' },
    { id: "flag_lu", cp: '1f1f1-1f1fa' },
    { id: "flag_lv", cp: '1f1f1-1f1fb' },
    { id: "flag_ly", cp: '1f1f1-1f1fe' },
    { id: "flag_ma", cp: '1f1f2-1f1e6' },
    { id: "flag_mc", cp: '1f1f2-1f1e8' },
    { id: "flag_md", cp: '1f1f2-1f1e9' },
    { id: "flag_me", cp: '1f1f2-1f1ea' },
    { id: "flag_mf", cp: '1f1f2-1f1eb' },
    { id: "flag_mg", cp: '1f1f2-1f1ec' },
    { id: "flag_mh", cp: '1f1f2-1f1ed' },
    { id: "flag_mk", cp: '1f1f2-1f1f0' },
    { id: "flag_ml", cp: '1f1f2-1f1f1' },
    { id: "burma", cp: '1f1f2-1f1f2' },
    { id: "flag_mn", cp: '1f1f2-1f1f3' },
    { id: "flag_mo", cp: '1f1f2-1f1f4' },
    { id: "flag_mp", cp: '1f1f2-1f1f5' },
    { id: "flag_mq", cp: '1f1f2-1f1f6' },
    { id: "flag_mr", cp: '1f1f2-1f1f7' },
    { id: "flag_ms", cp: '1f1f2-1f1f8' },
    { id: "flag_mt", cp: '1f1f2-1f1f9' },
    { id: "flag_mu", cp: '1f1f2-1f1fa' },
    { id: "flag_mv", cp: '1f1f2-1f1fb' },
    { id: "flag_mw", cp: '1f1f2-1f1fc' },
    { id: "flag_mx", cp: '1f1f2-1f1fd' },
    { id: "flag_my", cp: '1f1f2-1f1fe' },
    { id: "flag_mz", cp: '1f1f2-1f1ff' },
    { id: "flag_na", cp: '1f1f3-1f1e6' },
    { id: "flag_nc", cp: '1f1f3-1f1e8' },
    { id: "flag_ne", cp: '1f1f3-1f1ea' },
    { id: "flag_nf", cp: '1f1f3-1f1eb' },
    { id: "flag_ng", cp: '1f1f3-1f1ec' },
    { id: "flag_ni", cp: '1f1f3-1f1ee' },
    { id: "flag_nl", cp: '1f1f3-1f1f1' },
    { id: "flag_no", cp: '1f1f3-1f1f4' },
    { id: "flag_np", cp: '1f1f3-1f1f5' },
    { id: "flag_nr", cp: '1f1f3-1f1f7' },
    { id: "flag_nu", cp: '1f1f3-1f1fa' },
    { id: "flag_nz", cp: '1f1f3-1f1ff' },
    { id: "flag_om", cp: '1f1f4-1f1f2' },
    { id: "flag_pa", cp: '1f1f5-1f1e6' },
    { id: "flag_pe", cp: '1f1f5-1f1ea' },
    { id: "flag_pf", cp: '1f1f5-1f1eb' },
    { id: "flag_pg", cp: '1f1f5-1f1ec' },
    { id: "flag_ph", cp: '1f1f5-1f1ed' },
    { id: "flag_pk", cp: '1f1f5-1f1f0' },
    { id: "flag_pl", cp: '1f1f5-1f1f1' },
    { id: "flag_pm", cp: '1f1f5-1f1f2' },
    { id: "flag_pn", cp: '1f1f5-1f1f3' },
    { id: "flag_pr", cp: '1f1f5-1f1f7' },
    { id: "flag_ps", cp: '1f1f5-1f1f8' },
    { id: "flag_pt", cp: '1f1f5-1f1f9' },
    { id: "flag_pw", cp: '1f1f5-1f1fc' },
    { id: "flag_py", cp: '1f1f5-1f1fe' },
    { id: "flag_qa", cp: '1f1f6-1f1e6' },
    { id: "flag_re", cp: '1f1f7-1f1ea' },
    { id: "flag_ro", cp: '1f1f7-1f1f4' },
    { id: "flag_rs", cp: '1f1f7-1f1f8' },
    { id: "flag_ru", cp: '1f1f7-1f1fa' },
    { id: "flag_rw", cp: '1f1f7-1f1fc' },
    { id: "flag_sa", cp: '1f1f8-1f1e6' },
    { id: "flag_sb", cp: '1f1f8-1f1e7' },
    { id: "flag_sc", cp: '1f1f8-1f1e8' },
    { id: "flag_sd", cp: '1f1f8-1f1e9' },
    { id: "flag_se", cp: '1f1f8-1f1ea' },
    { id: "flag_sg", cp: '1f1f8-1f1ec' },
    { id: "flag_sh", cp: '1f1f8-1f1ed' },
    { id: "flag_si", cp: '1f1f8-1f1ee' },
    { id: "flag_sj", cp: '1f1f8-1f1ef' },
    { id: "flag_sk", cp: '1f1f8-1f1f0' },
    { id: "flag_sl", cp: '1f1f8-1f1f1' },
    { id: "flag_sm", cp: '1f1f8-1f1f2' },
    { id: "flag_sn", cp: '1f1f8-1f1f3' },
    { id: "flag_so", cp: '1f1f8-1f1f4' },
    { id: "flag_sr", cp: '1f1f8-1f1f7' },
    { id: "flag_ss", cp: '1f1f8-1f1f8' },
    { id: "flag_st", cp: '1f1f8-1f1f9' },
    { id: "el_salvador", cp: '1f1f8-1f1fb' },
    { id: "flag_sx", cp: '1f1f8-1f1fd' },
    { id: "flag_sy", cp: '1f1f8-1f1fe' },
    { id: "eswatini", cp: '1f1f8-1f1ff' },
    { id: "flag_ta", cp: '1f1f9-1f1e6' },
    { id: "flag_tc", cp: '1f1f9-1f1e8' },
    { id: "chad", cp: '1f1f9-1f1e9' },
    { id: "flag_tf", cp: '1f1f9-1f1eb' },
    { id: "flag_tg", cp: '1f1f9-1f1ec' },
    { id: "flag_th", cp: '1f1f9-1f1ed' },
    { id: "flag_tj", cp: '1f1f9-1f1ef' },
    { id: "flag_tk", cp: '1f1f9-1f1f0' },
    { id: "flag_tl", cp: '1f1f9-1f1f1' },
    { id: "flag_tm", cp: '1f1f9-1f1f2' },
    { id: "flag_tn", cp: '1f1f9-1f1f3' },
    { id: "flag_to", cp: '1f1f9-1f1f4' },
    { id: "flag_tr", cp: '1f1f9-1f1f7' },
    { id: "flag_tt", cp: '1f1f9-1f1f9' },
    { id: "flag_tv", cp: '1f1f9-1f1fb' },
    { id: "flag_tw", cp: '1f1f9-1f1fc' },
    { id: "flag_tz", cp: '1f1f9-1f1ff' },
    { id: "flag_ua", cp: '1f1fa-1f1e6' },
    { id: "flag_ug", cp: '1f1fa-1f1ec' },
    { id: "flag_um", cp: '1f1fa-1f1f2' },
    { id: "flag_un", cp: '1f1fa-1f1f3' },
    { id: "flag_us", cp: '1f1fa-1f1f8' },
    { id: "flag_uy", cp: '1f1fa-1f1fe' },
    { id: "flag_uz", cp: '1f1fa-1f1ff' },
    { id: "flag_va", cp: '1f1fb-1f1e6' },
    { id: "flag_vc", cp: '1f1fb-1f1e8' },
    { id: "flag_ve", cp: '1f1fb-1f1ea' },
    { id: "british_virgin_islands", cp: '1f1fb-1f1ec' },
    { id: "flag_vi", cp: '1f1fb-1f1ee' },
    { id: "flag_vn", cp: '1f1fb-1f1f3' },
    { id: "flag_vu", cp: '1f1fb-1f1fa' },
    { id: "flag_wf", cp: '1f1fc-1f1eb' },
    { id: "flag_ws", cp: '1f1fc-1f1f8' },
    { id: "flag_xk", cp: '1f1fd-1f1f0' },
    { id: "flag_ye", cp: '1f1fe-1f1ea' },
    { id: "flag_yt", cp: '1f1fe-1f1f9' },
    { id: "flag_za", cp: '1f1ff-1f1e6' },
    { id: "flag_zm", cp: '1f1ff-1f1f2' },
    { id: "flag_zw", cp: '1f1ff-1f1fc' },
    { id: "england", cp: '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f' },
    { id: "flag_gbsct", cp: '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f' },
    { id: "flag_gbwls", cp: '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f' },
  ] },
];

export const EMOJI_INDEX = {
  "+1": '1f44d',
  "-1": '1f44e',
  "100": '1f4af',
  "1234": '1f522',
  "1st": '1f947',
  "2nd": '1f948',
  "3rd": '1f949',
  "8ball": '1f3b1',
  "[object Object]": '76-61-72-69-61-6e-74-73',
  "a": '1f170',
  "a_blood": '1f170',
  "ab": '1f18e',
  "ab_blood": '1f18e',
  "abacus": '1f9ee',
  "abc": '1f524',
  "abcd": '1f521',
  "accept": '1f251',
  "accordion": '1fa97',
  "adhesive_bandage": '1fa79',
  "admission_tickets": '1f39f',
  "adult": '1f9d1',
  "aerial_tramway": '1f6a1',
  "afghanistan": '1f1e6-1f1eb',
  "airplane": '2708',
  "airplane_arriving": '1f6ec',
  "airplane_departure": '1f6eb',
  "aland_islands": '1f1e6-1f1fd',
  "alarm_clock": '23f0',
  "albania": '1f1e6-1f1f1',
  "alembic": '2697',
  "algeria": '1f1e9-1f1ff',
  "alien": '1f47d',
  "alien_monster": '1f47e',
  "all_good": '1f646',
  "ambulance": '1f691',
  "american_samoa": '1f1e6-1f1f8',
  "amphora": '1f3fa',
  "anatomical_heart": '1fac0',
  "anchor": '2693',
  "andorra": '1f1e6-1f1e9',
  "android": '1f4f1',
  "angel": '1f47c',
  "anger": '1f4a2',
  "angola": '1f1e6-1f1f4',
  "angry": '1f620',
  "angry_face": '1f620',
  "angry_imp": '1f47f',
  "anguilla": '1f1e6-1f1ee',
  "anguished": '1f627',
  "anguished_face": '1f627',
  "annoyed": '1f620',
  "ant": '1f41c',
  "antarctica": '1f1e6-1f1f6',
  "antenna_bars": '1f4f6',
  "antigua_barbuda": '1f1e6-1f1ec',
  "anxious": '1f630',
  "anxious_face": '1f630',
  "apple": '1f34e',
  "aquarius": '2652',
  "argentina": '1f1e6-1f1f7',
  "aries": '2648',
  "armenia": '1f1e6-1f1f2',
  "arrow_backward": '25c0',
  "arrow_double_down": '23ec',
  "arrow_double_up": '23eb',
  "arrow_down": '2b07',
  "arrow_down_small": '1f53d',
  "arrow_forward": '25b6',
  "arrow_heading_down": '2935',
  "arrow_heading_up": '2934',
  "arrow_left": '2b05',
  "arrow_left_hook": '21a9',
  "arrow_lower_left": '2199',
  "arrow_lower_right": '2198',
  "arrow_right": '27a1',
  "arrow_right_hook": '21aa',
  "arrow_up": '2b06',
  "arrow_up_down": '2195',
  "arrow_up_small": '1f53c',
  "arrow_upper_left": '2196',
  "arrow_upper_right": '2197',
  "arrows_clockwise": '1f503',
  "arrows_counterclockwise": '1f504',
  "art": '1f3a8',
  "articulated_lorry": '1f69b',
  "artist": '1f9d1-200d-1f3a8',
  "aruba": '1f1e6-1f1fc',
  "ascension_island": '1f1e6-1f1e8',
  "asterisk": '2a-20e3',
  "astonished": '1f632',
  "astonished_face": '1f632',
  "astronaut": '1f9d1-200d-1f680',
  "athletic_shoe": '1f45f',
  "atm": '1f3e7',
  "atom": '269b',
  "atom_symbol": '269b',
  "australia": '1f1e6-1f1fa',
  "austria": '1f1e6-1f1f9',
  "auto_rickshaw": '1f6fa',
  "avocado": '1f951',
  "axe": '1fa93',
  "azerbaijan": '1f1e6-1f1ff',
  "b": '1f171',
  "b_blood": '1f171',
  "baby": '1f476',
  "baby_bottle": '1f37c',
  "baby_chick": '1f424',
  "baby_symbol": '1f6bc',
  "back": '1f519',
  "backpack": '1f392',
  "bacon": '1f953',
  "badger": '1f9a1',
  "badminton": '1f3f8',
  "badminton_racquet_and_shuttlecock": '1f3f8',
  "bagel": '1f96f',
  "baggage_claim": '1f6c4',
  "baguette_bread": '1f956',
  "bahamas": '1f1e7-1f1f8',
  "bahrain": '1f1e7-1f1ed',
  "bald": '1f9d1-200d-1f9b2',
  "bald_man": '1f468-200d-1f9b2',
  "bald_person": '1f9d1-200d-1f9b2',
  "bald_woman": '1f469-200d-1f9b2',
  "ballet_shoes": '1fa70',
  "balloon": '1f388',
  "ballot_box": '1f5f3',
  "ballot_box_with_ballot": '1f5f3',
  "ballot_box_with_check": '2611',
  "bamboo": '1f38d',
  "banana": '1f34c',
  "bandaid": '1fa79',
  "bangbang": '203c',
  "bangladesh": '1f1e7-1f1e9',
  "banjo": '1fa95',
  "bank": '1f3e6',
  "bar_chart": '1f4ca',
  "barbados": '1f1e7-1f1e7',
  "barber": '1f488',
  "barber_pole": '1f488',
  "barely_sunny": '1f325',
  "baseball": '26be',
  "basket": '1f9fa',
  "basketball": '1f3c0',
  "bat": '1f987',
  "bath": '1f6c0',
  "bathroom": '1f6bb',
  "bathtub": '1f6c1',
  "battery": '1f50b',
  "beach": '1f3d6',
  "beach_umbrella": '26f1',
  "beach_with_umbrella": '1f3d6',
  "beaming_face": '1f601',
  "beans": '1fad8',
  "bear": '1f43b',
  "bear_face": '1f43b',
  "bearded_person": '1f9d4',
  "beating_heart": '1f493',
  "beaver": '1f9ab',
  "bed": '1f6cf',
  "bee": '1f41d',
  "beer": '1f37a',
  "beers": '1f37b',
  "beetle": '1fab2',
  "beginner": '1f530',
  "belarus": '1f1e7-1f1fe',
  "belgium": '1f1e7-1f1ea',
  "belize": '1f1e7-1f1ff',
  "bell": '1f514',
  "bell_pepper": '1fad1',
  "bellhop": '1f6ce',
  "bellhop_bell": '1f6ce',
  "benin": '1f1e7-1f1ef',
  "bento": '1f371',
  "bento_box": '1f371',
  "bermuda": '1f1e7-1f1f2',
  "beverage_box": '1f9c3',
  "bhutan": '1f1e7-1f1f9',
  "bicycle": '1f6b2',
  "bicyclist": '1f6b4',
  "bike": '1f6b2',
  "biking": '1f6b4',
  "bikini": '1f459',
  "billed_cap": '1f9e2',
  "billiards": '1f3b1',
  "biohazard": '2623',
  "biohazard_sign": '2623',
  "bird": '1f426',
  "bird_face": '1f426',
  "birthday": '1f382',
  "birthday_cake": '1f382',
  "bison": '1f9ac',
  "biting_lip": '1fae6',
  "black_bird": '1f426-200d-2b1b',
  "black_cat": '1f408-200d-2b1b',
  "black_circle": '26ab',
  "black_circle_for_record": '23fa',
  "black_flag": '1f3f4',
  "black_heart": '1f5a4',
  "black_joker": '1f0cf',
  "black_large_square": '2b1b',
  "black_left_pointing_double_triangle_with_vertical_bar": '23ee',
  "black_medium_small_square": '25fe',
  "black_medium_square": '25fc',
  "black_nib": '2712',
  "black_right_pointing_double_triangle_with_vertical_bar": '23ed',
  "black_right_pointing_triangle_with_double_vertical_bar": '23ef',
  "black_small_square": '25aa',
  "black_square_button": '1f532',
  "black_square_for_stop": '23f9',
  "blond-haired-man": '1f471-200d-2642-fe0f',
  "blond-haired-woman": '1f471-200d-2640-fe0f',
  "blond_haired": '1f471',
  "blossom": '1f33c',
  "blowfish": '1f421',
  "blowing_a_kiss": '1f618',
  "blue_book": '1f4d8',
  "blue_car": '1f699',
  "blue_circle": '1f535',
  "blue_heart": '1f499',
  "blue_square": '1f7e6',
  "blueberries": '1fad0',
  "blush": '1f60a',
  "boar": '1f417',
  "boat": '26f5',
  "boba_drink": '1f9cb',
  "bolivia": '1f1e7-1f1f4',
  "bomb": '1f4a3',
  "bone": '1f9b4',
  "book": '1f4d6',
  "bookmark": '1f516',
  "bookmark_tabs": '1f4d1',
  "books": '1f4da',
  "boom": '1f4a5',
  "boomerang": '1fa83',
  "boot": '1f462',
  "bosnia_herzegovina": '1f1e7-1f1e6',
  "botswana": '1f1e7-1f1fc',
  "bouquet": '1f490',
  "bouvet_island": '1f1e7-1f1fb',
  "bow": '1f647',
  "bow_and_arrow": '1f3f9',
  "bowl_with_spoon": '1f963',
  "bowling": '1f3b3',
  "boxing_glove": '1f94a',
  "boy": '1f466',
  "brain": '1f9e0',
  "brazil": '1f1e7-1f1f7',
  "bread": '1f35e',
  "breast-feeding": '1f931',
  "breast_feeding": '1f931',
  "bricks": '1f9f1',
  "bride_with_veil": '1f470',
  "bridge_at_night": '1f309',
  "briefcase": '1f4bc',
  "briefs": '1fa72',
  "bright_button": '1f506',
  "british_indian_ocean_territory": '1f1ee-1f1f4',
  "british_virgin_islands": '1f1fb-1f1ec',
  "broccoli": '1f966',
  "broken_chain": '26d3-fe0f-200d-1f4a5',
  "broken_heart": '1f494',
  "broom": '1f9f9',
  "brown_circle": '1f7e4',
  "brown_heart": '1f90e',
  "brown_mushroom": '1f344-200d-1f7eb',
  "brown_square": '1f7eb',
  "brunei": '1f1e7-1f1f3',
  "bubble_tea": '1f9cb',
  "bubbles": '1fae7',
  "bucket": '1faa3',
  "bug": '1f41b',
  "building_construction": '1f3d7',
  "bulb": '1f4a1',
  "bulgaria": '1f1e7-1f1ec',
  "bullettrain_front": '1f685',
  "bullettrain_side": '1f684',
  "bullseye": '1f3af',
  "burkina_faso": '1f1e7-1f1eb',
  "burma": '1f1f2-1f1f2',
  "burrito": '1f32f',
  "burundi": '1f1e7-1f1ee',
  "bus": '1f68c',
  "busstop": '1f68f',
  "bust_in_silhouette": '1f464',
  "busts_in_silhouette": '1f465',
  "butter": '1f9c8',
  "butterfly": '1f98b',
  "cactus": '1f335',
  "cake": '1f370',
  "calendar": '1f4c6',
  "calendar_spiral": '1f5d3',
  "call_me_hand": '1f919',
  "calling": '1f4f2',
  "cambodia": '1f1f0-1f1ed',
  "camel": '1f42b',
  "camera": '1f4f7',
  "camera_with_flash": '1f4f8',
  "cameroon": '1f1e8-1f1f2',
  "camping": '1f3d5',
  "canada": '1f1e8-1f1e6',
  "canary_islands": '1f1ee-1f1e8',
  "cancer": '264b',
  "candle": '1f56f',
  "candy": '1f36c',
  "canned_food": '1f96b',
  "canoe": '1f6f6',
  "cape_verde": '1f1e8-1f1fb',
  "capital_abcd": '1f520',
  "capricorn": '2651',
  "car": '1f697',
  "card_file_box": '1f5c3',
  "card_index": '1f4c7',
  "card_index_dividers": '1f5c2',
  "caribbean_netherlands": '1f1e7-1f1f6',
  "carousel_horse": '1f3a0',
  "carp_streamer": '1f38f',
  "carpentry_saw": '1fa9a',
  "carrot": '1f955',
  "cartwheeling": '1f938',
  "castle": '1f3f0',
  "cat": '1f408',
  "cat2": '1f408',
  "cat_face": '1f431',
  "cayman_islands": '1f1f0-1f1fe',
  "cd": '1f4bf',
  "censored": '1f92c',
  "central_african_republic": '1f1e8-1f1eb',
  "ceuta_melilla": '1f1ea-1f1e6',
  "chad": '1f1f9-1f1e9',
  "chains": '26d3',
  "chair": '1fa91',
  "champagne": '1f37e',
  "champagne_glass": '1f37e',
  "chart": '1f4b9',
  "chart_decreasing": '1f4c9',
  "chart_increasing": '1f4c8',
  "chart_with_downwards_trend": '1f4c9',
  "chart_with_upwards_trend": '1f4c8',
  "check_mark": '2714',
  "check_mark_button": '2705',
  "checkered_flag": '1f3c1',
  "cheese": '1f9c0',
  "cheese_wedge": '1f9c0',
  "cherries": '1f352',
  "cherry_blossom": '1f338',
  "chess_pawn": '265f',
  "chestnut": '1f330',
  "chicken": '1f414',
  "chicken_face": '1f414',
  "child": '1f9d2',
  "children_crossing": '1f6b8',
  "chile": '1f1e8-1f1f1',
  "china": '1f1e8-1f1f3',
  "chipmunk": '1f43f',
  "chocolate_bar": '1f36b',
  "chopsticks": '1f962',
  "christmas_island": '1f1e8-1f1fd',
  "christmas_tree": '1f384',
  "church": '26ea',
  "cigarette": '1f6ac',
  "cinema": '1f3a6',
  "circus_tent": '1f3aa',
  "city_dusk": '1f306',
  "city_sunrise": '1f307',
  "city_sunset": '1f307',
  "cityscape": '1f3d9',
  "cl": '1f191',
  "clamp": '1f5dc',
  "clap": '1f44f',
  "clapper": '1f3ac',
  "clapping_hands": '1f44f',
  "classical_building": '1f3db',
  "climbing": '1f9d7',
  "clinking_glasses": '1f942',
  "clipboard": '1f4cb',
  "clipperton_island": '1f1e8-1f1f5',
  "clock": '1f570',
  "clock1": '1f550',
  "clock10": '1f559',
  "clock1030": '1f565',
  "clock11": '1f55a',
  "clock1130": '1f566',
  "clock12": '1f55b',
  "clock1230": '1f567',
  "clock130": '1f55c',
  "clock2": '1f551',
  "clock230": '1f55d',
  "clock3": '1f552',
  "clock330": '1f55e',
  "clock4": '1f553',
  "clock430": '1f55f',
  "clock5": '1f554',
  "clock530": '1f560',
  "clock6": '1f555',
  "clock630": '1f561',
  "clock7": '1f556',
  "clock730": '1f562',
  "clock8": '1f557',
  "clock830": '1f563',
  "clock9": '1f558',
  "clock930": '1f564',
  "clockwise": '1f503',
  "closed_book": '1f4d5',
  "closed_lock_with_key": '1f510',
  "closed_umbrella": '1f302',
  "cloud": '2601',
  "cloud_with_lightning": '1f329',
  "cloud_with_rain": '1f327',
  "cloud_with_snow": '1f328',
  "cloudy": '1f325',
  "clown": '1f921',
  "clown_face": '1f921',
  "clubs": '2663',
  "clutch_bag": '1f45d',
  "cn": '1f1e8-1f1f3',
  "coat": '1f9e5',
  "cockroach": '1fab3',
  "cocktail": '1f378',
  "coconut": '1f965',
  "cocos_islands": '1f1e8-1f1e8',
  "coffee": '2615',
  "coffin": '26b0',
  "coin": '1fa99',
  "cold": '1f976',
  "cold_face": '1f976',
  "cold_sweat": '1f630',
  "collision": '1f4a5',
  "colombia": '1f1e8-1f1f4',
  "comet": '2604',
  "comoros": '1f1f0-1f1f2',
  "compass": '1f9ed',
  "compression": '1f5dc',
  "computer": '1f5a5',
  "computer_disk": '1f4bd',
  "computer_mouse": '1f5b1',
  "confetti_ball": '1f38a',
  "confident": '1f60e',
  "confounded": '1f616',
  "confounded_face": '1f616',
  "confused": '1f615',
  "confused_face": '1f615',
  "congo_brazzaville": '1f1e8-1f1ec',
  "congo_kinshasa": '1f1e8-1f1e9',
  "congratulations": '3297',
  "construction": '1f6a7',
  "construction_site": '1f3d7',
  "construction_worker": '1f477',
  "control_knobs": '1f39b',
  "controller": '1f3ae',
  "convenience_store": '1f3ea',
  "cook": '1f9d1-200d-1f373',
  "cook_islands": '1f1e8-1f1f0',
  "cooked_rice": '1f35a',
  "cookie": '1f36a',
  "cooking": '1f373',
  "cool": '1f192',
  "cop": '1f46e',
  "copyright": 'a9',
  "coral": '1fab8',
  "corn": '1f33d',
  "costa_rica": '1f1e8-1f1f7',
  "cote_divoire": '1f1e8-1f1ee',
  "couch_and_lamp": '1f6cb',
  "counterclockwise": '1f504',
  "couple": '1f46b',
  "couple_kiss": '1f48f',
  "couple_with_heart": '1f491',
  "couple_with_heart_mm": '1f468-200d-2764-fe0f-200d-1f468',
  "couple_with_heart_mw": '1f469-200d-2764-fe0f-200d-1f468',
  "couple_with_heart_wm": '1f469-200d-2764-fe0f-200d-1f468',
  "couple_with_heart_ww": '1f469-200d-2764-fe0f-200d-1f469',
  "couplekiss": '1f48f',
  "cow": '1f404',
  "cow2": '1f404',
  "cow_face": '1f42e',
  "cowboy": '1f920',
  "cowboy_face": '1f920',
  "crab": '1f980',
  "crayon": '1f58d',
  "credit_card": '1f4b3',
  "crescent_moon": '1f319',
  "cricket": '1f997',
  "cricket_bat_and_ball": '1f3cf',
  "cricket_game": '1f3cf',
  "croatia": '1f1ed-1f1f7',
  "crocodile": '1f40a',
  "croissant": '1f950',
  "cross_mark": '274c',
  "cross_mark_button": '274e',
  "crossed_fingers": '1f91e',
  "crossed_flags": '1f38c',
  "crossed_swords": '2694',
  "crown": '1f451',
  "cruise_ship": '1f6f3',
  "crutch": '1fa7c',
  "cry": '1f622',
  "crying_cat": '1f63f',
  "crying_cat_face": '1f63f',
  "crying_face": '1f622',
  "crystal_ball": '1f52e',
  "cuba": '1f1e8-1f1fa',
  "cucumber": '1f952',
  "cup_with_straw": '1f964',
  "cupcake": '1f9c1',
  "cupid": '1f498',
  "curacao": '1f1e8-1f1fc',
  "curling_stone": '1f94c',
  "curly_hair": '1f9b1',
  "curly_haired": '1f9d1-200d-1f9b1',
  "curly_haired_man": '1f468-200d-1f9b1',
  "curly_haired_person": '1f9d1-200d-1f9b1',
  "curly_haired_woman": '1f469-200d-1f9b1',
  "curly_loop": '27b0',
  "currency_exchange": '1f4b1',
  "curry": '1f35b',
  "curry_rice": '1f35b',
  "custard": '1f36e',
  "customs": '1f6c3',
  "cut_of_meat": '1f969',
  "cyclone": '1f300',
  "cyprus": '1f1e8-1f1fe',
  "czech_republic": '1f1e8-1f1ff',
  "czechia": '1f1e8-1f1ff',
  "dagger": '1f5e1',
  "dagger_knife": '1f5e1',
  "dancer": '1f483',
  "dancers": '1f46f',
  "dango": '1f361',
  "dark_sunglasses": '1f576',
  "dart": '1f3af',
  "dash": '1f4a8',
  "dashing_away": '1f4a8',
  "date": '1f4c5',
  "de": '1f1e9-1f1ea',
  "deaf_man": '1f9cf-200d-2642-fe0f',
  "deaf_person": '1f9cf',
  "deaf_woman": '1f9cf-200d-2640-fe0f',
  "deciduous_tree": '1f333',
  "deer": '1f98c',
  "delivery_truck": '1f69a',
  "denmark": '1f1e9-1f1f0',
  "department_store": '1f3ec',
  "derelict_house": '1f3da',
  "derelict_house_building": '1f3da',
  "desert": '1f3dc',
  "desert_island": '1f3dd',
  "desktop_computer": '1f5a5',
  "detective": '1f575',
  "diamond_shape_with_a_dot_inside": '1f4a0',
  "diamond_with_a_dot": '1f4a0',
  "diamonds": '2666',
  "diego_garcia": '1f1e9-1f1ec',
  "dim_button": '1f505',
  "direct_hit": '1f3af',
  "disappointed": '1f61e',
  "disappointed_face": '1f61e',
  "disappointed_relieved": '1f625',
  "disbelief": '1f928',
  "disco": '1faa9',
  "disco_ball": '1faa9',
  "disguised": '1f978',
  "disguised_face": '1f978',
  "divide": '2797',
  "diving_mask": '1f93f',
  "division": '2797',
  "diya_lamp": '1fa94',
  "dizzy": '1f4ab',
  "dizzy_eyes": '1f635-200d-1f4ab',
  "dizzy_face": '1f635',
  "dizzy_star": '1f31f',
  "djibouti": '1f1e9-1f1ef',
  "dna": '1f9ec',
  "do_not_litter": '1f6af',
  "dodo": '1f9a4',
  "dog": '1f415',
  "dog2": '1f415',
  "dog_face": '1f436',
  "dollar": '1f4b5',
  "dolls": '1f38e',
  "dolphin": '1f42c',
  "dominica": '1f1e9-1f1f2',
  "dominican_republic": '1f1e9-1f1f4',
  "donkey": '1facf',
  "door": '1f6aa',
  "dotted_line_face": '1fae5',
  "double_curly_loop": '27bf',
  "double_exclamation": '203c',
  "double_helix": '1f9ec',
  "double_vertical_bar": '23f8',
  "doughnut": '1f369',
  "dove": '1f54a',
  "dove_of_peace": '1f54a',
  "down": '1f53d',
  "downcast_face": '1f613',
  "dragon": '1f409',
  "dragon_face": '1f432',
  "dress": '1f457',
  "dromedary_camel": '1f42a',
  "drooling": '1f924',
  "drooling_face": '1f924',
  "drop_of_blood": '1fa78',
  "droplet": '1f4a7',
  "drum": '1f941',
  "drum_with_drumsticks": '1f941',
  "duck": '1f986',
  "dumpling": '1f95f',
  "dvd": '1f4c0',
  "e-mail": '1f4e7',
  "eagle": '1f985',
  "ear": '1f442',
  "ear_of_corn": '1f33d',
  "ear_of_rice": '1f33e',
  "ear_with_hearing_aid": '1f9bb',
  "earth_africa": '1f30d',
  "earth_americas": '1f30e',
  "earth_asia": '1f30f',
  "earth_europe": '1f30d',
  "ecstatic": '1f604',
  "ecuador": '1f1ea-1f1e8',
  "egg": '1f95a',
  "eggplant": '1f346',
  "egypt": '1f1ea-1f1ec',
  "eight": '38-20e3',
  "eight_pointed_black_star": '2734',
  "eight_spoked_asterisk": '2733',
  "eject": '23cf',
  "el_salvador": '1f1f8-1f1fb',
  "electric_plug": '1f50c',
  "elephant": '1f418',
  "elevator": '1f6d7',
  "elf": '1f9dd',
  "email": '1f4e7',
  "empty_nest": '1fab9',
  "end": '1f51a',
  "england": '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f',
  "enraged": '1f621',
  "envelope": '2709',
  "envelope_with_arrow": '1f4e9',
  "equatorial_guinea": '1f1ec-1f1f6',
  "eritrea": '1f1ea-1f1f7',
  "es": '1f1ea-1f1f8',
  "estonia": '1f1ea-1f1ea',
  "eswatini": '1f1f8-1f1ff',
  "ethiopia": '1f1ea-1f1f9',
  "euro": '1f4b6',
  "european_castle": '1f3f0',
  "european_post_office": '1f3e4',
  "european_union": '1f1ea-1f1fa',
  "evergreen_tree": '1f332',
  "ewe": '1f411',
  "exclamation": '2757',
  "exclamation_question": '2049',
  "exhale": '1f62e-200d-1f4a8',
  "exhaling": '1f62e-200d-1f4a8',
  "exhausted": '1f62b',
  "exploding_head": '1f92f',
  "expressionless": '1f611',
  "expressionless_face": '1f611',
  "eye": '1f441',
  "eye-in-speech-bubble": '1f441-200d-1f5e8',
  "eye_in_speech_bubble": '1f441-200d-1f5e8',
  "eyeglasses": '1f453',
  "eyes": '1f440',
  "face_exhaling": '1f62e-200d-1f4a8',
  "face_holding_back_tears": '1f979',
  "face_in_clouds": '1f636-200d-1f32b-fe0f',
  "face_palm": '1f926',
  "face_vomiting": '1f92e',
  "face_with_bags_under_eyes": '1fae9',
  "face_with_cowboy_hat": '1f920',
  "face_with_diagonal_mouth": '1fae4',
  "face_with_finger_covering_closed_lips": '1f92b',
  "face_with_hand_over_mouth": '1f92d',
  "face_with_head_bandage": '1f915',
  "face_with_monocle": '1f9d0',
  "face_with_one_eyebrow_raised": '1f928',
  "face_with_open_eyes_and_hand_over_mouth": '1fae2',
  "face_with_open_eyes_hand_over_mouth": '1fae2',
  "face_with_open_mouth": '1f62e',
  "face_with_open_mouth_vomiting": '1f92e',
  "face_with_peeking_eye": '1fae3',
  "face_with_raised_eyebrow": '1f928',
  "face_with_rolling_eyes": '1f644',
  "face_with_spiral_eyes": '1f635-200d-1f4ab',
  "face_with_symbols_on_mouth": '1f92c',
  "face_with_thermometer": '1f912',
  "face_with_tongue": '1f61b',
  "facepalm": '1f926',
  "facepunch": '1f44a',
  "factory": '1f3ed',
  "factory_worker": '1f9d1-200d-1f3ed',
  "fairy": '1f9da',
  "falafel": '1f9c6',
  "falkland_islands": '1f1eb-1f1f0',
  "fallen_leaf": '1f342',
  "family": '1f46a',
  "family_adult_adult_child": '1f9d1-200d-1f9d1-200d-1f9d2',
  "family_adult_adult_child_child": '1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2',
  "family_adult_child": '1f9d1-200d-1f9d2',
  "family_adult_child_child": '1f9d1-200d-1f9d2-200d-1f9d2',
  "family_mb": '1f468-200d-1f466',
  "family_mbb": '1f468-200d-1f466-200d-1f466',
  "family_mg": '1f468-200d-1f467',
  "family_mgb": '1f468-200d-1f467-200d-1f466',
  "family_mgg": '1f468-200d-1f467-200d-1f467',
  "family_mmb": '1f468-200d-1f468-200d-1f466',
  "family_mmbb": '1f468-200d-1f468-200d-1f466-200d-1f466',
  "family_mmg": '1f468-200d-1f468-200d-1f467',
  "family_mmgb": '1f468-200d-1f468-200d-1f467-200d-1f466',
  "family_mmgg": '1f468-200d-1f468-200d-1f467-200d-1f467',
  "family_mwb": '1f468-200d-1f469-200d-1f466',
  "family_mwbb": '1f468-200d-1f469-200d-1f466-200d-1f466',
  "family_mwg": '1f468-200d-1f469-200d-1f467',
  "family_mwgb": '1f468-200d-1f469-200d-1f467-200d-1f466',
  "family_mwgg": '1f468-200d-1f469-200d-1f467-200d-1f467',
  "family_wb": '1f469-200d-1f466',
  "family_wbb": '1f469-200d-1f466-200d-1f466',
  "family_wg": '1f469-200d-1f467',
  "family_wgb": '1f469-200d-1f467-200d-1f466',
  "family_wgg": '1f469-200d-1f467-200d-1f467',
  "family_wwb": '1f469-200d-1f469-200d-1f466',
  "family_wwbb": '1f469-200d-1f469-200d-1f466-200d-1f466',
  "family_wwg": '1f469-200d-1f469-200d-1f467',
  "family_wwgb": '1f469-200d-1f469-200d-1f467-200d-1f466',
  "family_wwgg": '1f469-200d-1f469-200d-1f467-200d-1f467',
  "farmer": '1f9d1-200d-1f33e',
  "faroe_islands": '1f1eb-1f1f4',
  "fast_down": '23ec',
  "fast_forward": '23e9',
  "fast_reverse": '23ea',
  "fast_up": '23eb',
  "fax": '1f4e0',
  "fax_machine": '1f4e0',
  "fearful": '1f628',
  "fearful_face": '1f628',
  "feather": '1fab6',
  "feet": '1f43e',
  "female": '2640',
  "female-artist": '1f469-200d-1f3a8',
  "female-astronaut": '1f469-200d-1f680',
  "female-construction-worker": '1f477-200d-2640-fe0f',
  "female-cook": '1f469-200d-1f373',
  "female-detective": '1f575-fe0f-200d-2640-fe0f',
  "female-doctor": '1f469-200d-2695-fe0f',
  "female-factory-worker": '1f469-200d-1f3ed',
  "female-farmer": '1f469-200d-1f33e',
  "female-firefighter": '1f469-200d-1f692',
  "female-guard": '1f482-200d-2640-fe0f',
  "female-judge": '1f469-200d-2696-fe0f',
  "female-mechanic": '1f469-200d-1f527',
  "female-office-worker": '1f469-200d-1f4bc',
  "female-pilot": '1f469-200d-2708-fe0f',
  "female-police-officer": '1f46e-200d-2640-fe0f',
  "female-scientist": '1f469-200d-1f52c',
  "female-singer": '1f469-200d-1f3a4',
  "female-student": '1f469-200d-1f393',
  "female-teacher": '1f469-200d-1f3eb',
  "female-technologist": '1f469-200d-1f4bb',
  "female_elf": '1f9dd-200d-2640-fe0f',
  "female_fairy": '1f9da-200d-2640-fe0f',
  "female_genie": '1f9de-200d-2640-fe0f',
  "female_mage": '1f9d9-200d-2640-fe0f',
  "female_sign": '2640',
  "female_superhero": '1f9b8-200d-2640-fe0f',
  "female_supervillain": '1f9b9-200d-2640-fe0f',
  "female_vampire": '1f9db-200d-2640-fe0f',
  "female_zombie": '1f9df-200d-2640-fe0f',
  "fencer": '1f93a',
  "fencing": '1f93a',
  "ferris_wheel": '1f3a1',
  "ferry": '26f4',
  "field_hockey": '1f3d1',
  "field_hockey_stick_and_ball": '1f3d1',
  "fiji": '1f1eb-1f1ef',
  "file_cabinet": '1f5c4',
  "file_folder": '1f4c1',
  "film_frames": '1f39e',
  "film_projector": '1f4fd',
  "fingerprint": '1fac6',
  "fingers_crossed": '1f91e',
  "finland": '1f1eb-1f1ee',
  "fire": '1f525',
  "fire_engine": '1f692',
  "fire_extinguisher": '1f9ef',
  "firecracker": '1f9e8',
  "firefighter": '1f9d1-200d-1f692',
  "fireworks": '1f386',
  "first_place_medal": '1f947',
  "first_quarter_moon": '1f313',
  "first_quarter_moon_with_face": '1f31b',
  "fish": '1f41f',
  "fish_cake": '1f365',
  "fishing_pole": '1f3a3',
  "fishing_pole_and_fish": '1f3a3',
  "fist": '270a',
  "five": '35-20e3',
  "flag-ac": '1f1e6-1f1e8',
  "flag-ad": '1f1e6-1f1e9',
  "flag-ae": '1f1e6-1f1ea',
  "flag-af": '1f1e6-1f1eb',
  "flag-ag": '1f1e6-1f1ec',
  "flag-ai": '1f1e6-1f1ee',
  "flag-al": '1f1e6-1f1f1',
  "flag-am": '1f1e6-1f1f2',
  "flag-ao": '1f1e6-1f1f4',
  "flag-aq": '1f1e6-1f1f6',
  "flag-ar": '1f1e6-1f1f7',
  "flag-as": '1f1e6-1f1f8',
  "flag-at": '1f1e6-1f1f9',
  "flag-au": '1f1e6-1f1fa',
  "flag-aw": '1f1e6-1f1fc',
  "flag-ax": '1f1e6-1f1fd',
  "flag-az": '1f1e6-1f1ff',
  "flag-ba": '1f1e7-1f1e6',
  "flag-bb": '1f1e7-1f1e7',
  "flag-bd": '1f1e7-1f1e9',
  "flag-be": '1f1e7-1f1ea',
  "flag-bf": '1f1e7-1f1eb',
  "flag-bg": '1f1e7-1f1ec',
  "flag-bh": '1f1e7-1f1ed',
  "flag-bi": '1f1e7-1f1ee',
  "flag-bj": '1f1e7-1f1ef',
  "flag-bl": '1f1e7-1f1f1',
  "flag-bm": '1f1e7-1f1f2',
  "flag-bn": '1f1e7-1f1f3',
  "flag-bo": '1f1e7-1f1f4',
  "flag-bq": '1f1e7-1f1f6',
  "flag-br": '1f1e7-1f1f7',
  "flag-bs": '1f1e7-1f1f8',
  "flag-bt": '1f1e7-1f1f9',
  "flag-bv": '1f1e7-1f1fb',
  "flag-bw": '1f1e7-1f1fc',
  "flag-by": '1f1e7-1f1fe',
  "flag-bz": '1f1e7-1f1ff',
  "flag-ca": '1f1e8-1f1e6',
  "flag-cc": '1f1e8-1f1e8',
  "flag-cd": '1f1e8-1f1e9',
  "flag-cf": '1f1e8-1f1eb',
  "flag-cg": '1f1e8-1f1ec',
  "flag-ch": '1f1e8-1f1ed',
  "flag-ci": '1f1e8-1f1ee',
  "flag-ck": '1f1e8-1f1f0',
  "flag-cl": '1f1e8-1f1f1',
  "flag-cm": '1f1e8-1f1f2',
  "flag-cn": '1f1e8-1f1f3',
  "flag-co": '1f1e8-1f1f4',
  "flag-cp": '1f1e8-1f1f5',
  "flag-cr": '1f1e8-1f1f7',
  "flag-cu": '1f1e8-1f1fa',
  "flag-cv": '1f1e8-1f1fb',
  "flag-cw": '1f1e8-1f1fc',
  "flag-cx": '1f1e8-1f1fd',
  "flag-cy": '1f1e8-1f1fe',
  "flag-cz": '1f1e8-1f1ff',
  "flag-de": '1f1e9-1f1ea',
  "flag-dg": '1f1e9-1f1ec',
  "flag-dj": '1f1e9-1f1ef',
  "flag-dk": '1f1e9-1f1f0',
  "flag-dm": '1f1e9-1f1f2',
  "flag-do": '1f1e9-1f1f4',
  "flag-dz": '1f1e9-1f1ff',
  "flag-ea": '1f1ea-1f1e6',
  "flag-ec": '1f1ea-1f1e8',
  "flag-ee": '1f1ea-1f1ea',
  "flag-eg": '1f1ea-1f1ec',
  "flag-eh": '1f1ea-1f1ed',
  "flag-england": '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f',
  "flag-er": '1f1ea-1f1f7',
  "flag-es": '1f1ea-1f1f8',
  "flag-et": '1f1ea-1f1f9',
  "flag-eu": '1f1ea-1f1fa',
  "flag-fi": '1f1eb-1f1ee',
  "flag-fj": '1f1eb-1f1ef',
  "flag-fk": '1f1eb-1f1f0',
  "flag-fm": '1f1eb-1f1f2',
  "flag-fo": '1f1eb-1f1f4',
  "flag-fr": '1f1eb-1f1f7',
  "flag-ga": '1f1ec-1f1e6',
  "flag-gb": '1f1ec-1f1e7',
  "flag-gd": '1f1ec-1f1e9',
  "flag-ge": '1f1ec-1f1ea',
  "flag-gf": '1f1ec-1f1eb',
  "flag-gg": '1f1ec-1f1ec',
  "flag-gh": '1f1ec-1f1ed',
  "flag-gi": '1f1ec-1f1ee',
  "flag-gl": '1f1ec-1f1f1',
  "flag-gm": '1f1ec-1f1f2',
  "flag-gn": '1f1ec-1f1f3',
  "flag-gp": '1f1ec-1f1f5',
  "flag-gq": '1f1ec-1f1f6',
  "flag-gr": '1f1ec-1f1f7',
  "flag-gs": '1f1ec-1f1f8',
  "flag-gt": '1f1ec-1f1f9',
  "flag-gu": '1f1ec-1f1fa',
  "flag-gw": '1f1ec-1f1fc',
  "flag-gy": '1f1ec-1f1fe',
  "flag-hk": '1f1ed-1f1f0',
  "flag-hm": '1f1ed-1f1f2',
  "flag-hn": '1f1ed-1f1f3',
  "flag-hr": '1f1ed-1f1f7',
  "flag-ht": '1f1ed-1f1f9',
  "flag-hu": '1f1ed-1f1fa',
  "flag-ic": '1f1ee-1f1e8',
  "flag-id": '1f1ee-1f1e9',
  "flag-ie": '1f1ee-1f1ea',
  "flag-il": '1f1ee-1f1f1',
  "flag-im": '1f1ee-1f1f2',
  "flag-in": '1f1ee-1f1f3',
  "flag-io": '1f1ee-1f1f4',
  "flag-iq": '1f1ee-1f1f6',
  "flag-ir": '1f1ee-1f1f7',
  "flag-is": '1f1ee-1f1f8',
  "flag-it": '1f1ee-1f1f9',
  "flag-je": '1f1ef-1f1ea',
  "flag-jm": '1f1ef-1f1f2',
  "flag-jo": '1f1ef-1f1f4',
  "flag-jp": '1f1ef-1f1f5',
  "flag-ke": '1f1f0-1f1ea',
  "flag-kg": '1f1f0-1f1ec',
  "flag-kh": '1f1f0-1f1ed',
  "flag-ki": '1f1f0-1f1ee',
  "flag-km": '1f1f0-1f1f2',
  "flag-kn": '1f1f0-1f1f3',
  "flag-kp": '1f1f0-1f1f5',
  "flag-kr": '1f1f0-1f1f7',
  "flag-kw": '1f1f0-1f1fc',
  "flag-ky": '1f1f0-1f1fe',
  "flag-kz": '1f1f0-1f1ff',
  "flag-la": '1f1f1-1f1e6',
  "flag-lb": '1f1f1-1f1e7',
  "flag-lc": '1f1f1-1f1e8',
  "flag-li": '1f1f1-1f1ee',
  "flag-lk": '1f1f1-1f1f0',
  "flag-lr": '1f1f1-1f1f7',
  "flag-ls": '1f1f1-1f1f8',
  "flag-lt": '1f1f1-1f1f9',
  "flag-lu": '1f1f1-1f1fa',
  "flag-lv": '1f1f1-1f1fb',
  "flag-ly": '1f1f1-1f1fe',
  "flag-ma": '1f1f2-1f1e6',
  "flag-mc": '1f1f2-1f1e8',
  "flag-md": '1f1f2-1f1e9',
  "flag-me": '1f1f2-1f1ea',
  "flag-mf": '1f1f2-1f1eb',
  "flag-mg": '1f1f2-1f1ec',
  "flag-mh": '1f1f2-1f1ed',
  "flag-mk": '1f1f2-1f1f0',
  "flag-ml": '1f1f2-1f1f1',
  "flag-mm": '1f1f2-1f1f2',
  "flag-mn": '1f1f2-1f1f3',
  "flag-mo": '1f1f2-1f1f4',
  "flag-mp": '1f1f2-1f1f5',
  "flag-mq": '1f1f2-1f1f6',
  "flag-mr": '1f1f2-1f1f7',
  "flag-ms": '1f1f2-1f1f8',
  "flag-mt": '1f1f2-1f1f9',
  "flag-mu": '1f1f2-1f1fa',
  "flag-mv": '1f1f2-1f1fb',
  "flag-mw": '1f1f2-1f1fc',
  "flag-mx": '1f1f2-1f1fd',
  "flag-my": '1f1f2-1f1fe',
  "flag-mz": '1f1f2-1f1ff',
  "flag-na": '1f1f3-1f1e6',
  "flag-nc": '1f1f3-1f1e8',
  "flag-ne": '1f1f3-1f1ea',
  "flag-nf": '1f1f3-1f1eb',
  "flag-ng": '1f1f3-1f1ec',
  "flag-ni": '1f1f3-1f1ee',
  "flag-nl": '1f1f3-1f1f1',
  "flag-no": '1f1f3-1f1f4',
  "flag-np": '1f1f3-1f1f5',
  "flag-nr": '1f1f3-1f1f7',
  "flag-nu": '1f1f3-1f1fa',
  "flag-nz": '1f1f3-1f1ff',
  "flag-om": '1f1f4-1f1f2',
  "flag-pa": '1f1f5-1f1e6',
  "flag-pe": '1f1f5-1f1ea',
  "flag-pf": '1f1f5-1f1eb',
  "flag-pg": '1f1f5-1f1ec',
  "flag-ph": '1f1f5-1f1ed',
  "flag-pk": '1f1f5-1f1f0',
  "flag-pl": '1f1f5-1f1f1',
  "flag-pm": '1f1f5-1f1f2',
  "flag-pn": '1f1f5-1f1f3',
  "flag-pr": '1f1f5-1f1f7',
  "flag-ps": '1f1f5-1f1f8',
  "flag-pt": '1f1f5-1f1f9',
  "flag-pw": '1f1f5-1f1fc',
  "flag-py": '1f1f5-1f1fe',
  "flag-qa": '1f1f6-1f1e6',
  "flag-re": '1f1f7-1f1ea',
  "flag-ro": '1f1f7-1f1f4',
  "flag-rs": '1f1f7-1f1f8',
  "flag-ru": '1f1f7-1f1fa',
  "flag-rw": '1f1f7-1f1fc',
  "flag-sa": '1f1f8-1f1e6',
  "flag-sark": '1f1e8-1f1f6',
  "flag-sb": '1f1f8-1f1e7',
  "flag-sc": '1f1f8-1f1e8',
  "flag-scotland": '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f',
  "flag-sd": '1f1f8-1f1e9',
  "flag-se": '1f1f8-1f1ea',
  "flag-sg": '1f1f8-1f1ec',
  "flag-sh": '1f1f8-1f1ed',
  "flag-si": '1f1f8-1f1ee',
  "flag-sj": '1f1f8-1f1ef',
  "flag-sk": '1f1f8-1f1f0',
  "flag-sl": '1f1f8-1f1f1',
  "flag-sm": '1f1f8-1f1f2',
  "flag-sn": '1f1f8-1f1f3',
  "flag-so": '1f1f8-1f1f4',
  "flag-sr": '1f1f8-1f1f7',
  "flag-ss": '1f1f8-1f1f8',
  "flag-st": '1f1f8-1f1f9',
  "flag-sv": '1f1f8-1f1fb',
  "flag-sx": '1f1f8-1f1fd',
  "flag-sy": '1f1f8-1f1fe',
  "flag-sz": '1f1f8-1f1ff',
  "flag-ta": '1f1f9-1f1e6',
  "flag-tc": '1f1f9-1f1e8',
  "flag-td": '1f1f9-1f1e9',
  "flag-tf": '1f1f9-1f1eb',
  "flag-tg": '1f1f9-1f1ec',
  "flag-th": '1f1f9-1f1ed',
  "flag-tj": '1f1f9-1f1ef',
  "flag-tk": '1f1f9-1f1f0',
  "flag-tl": '1f1f9-1f1f1',
  "flag-tm": '1f1f9-1f1f2',
  "flag-tn": '1f1f9-1f1f3',
  "flag-to": '1f1f9-1f1f4',
  "flag-tr": '1f1f9-1f1f7',
  "flag-tt": '1f1f9-1f1f9',
  "flag-tv": '1f1f9-1f1fb',
  "flag-tw": '1f1f9-1f1fc',
  "flag-tz": '1f1f9-1f1ff',
  "flag-ua": '1f1fa-1f1e6',
  "flag-ug": '1f1fa-1f1ec',
  "flag-um": '1f1fa-1f1f2',
  "flag-un": '1f1fa-1f1f3',
  "flag-us": '1f1fa-1f1f8',
  "flag-uy": '1f1fa-1f1fe',
  "flag-uz": '1f1fa-1f1ff',
  "flag-va": '1f1fb-1f1e6',
  "flag-vc": '1f1fb-1f1e8',
  "flag-ve": '1f1fb-1f1ea',
  "flag-vg": '1f1fb-1f1ec',
  "flag-vi": '1f1fb-1f1ee',
  "flag-vn": '1f1fb-1f1f3',
  "flag-vu": '1f1fb-1f1fa',
  "flag-wales": '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f',
  "flag-wf": '1f1fc-1f1eb',
  "flag-ws": '1f1fc-1f1f8',
  "flag-xk": '1f1fd-1f1f0',
  "flag-ye": '1f1fe-1f1ea',
  "flag-yt": '1f1fe-1f1f9',
  "flag-za": '1f1ff-1f1e6',
  "flag-zm": '1f1ff-1f1f2',
  "flag-zw": '1f1ff-1f1fc',
  "flag_ac": '1f1e6-1f1e8',
  "flag_ad": '1f1e6-1f1e9',
  "flag_ae": '1f1e6-1f1ea',
  "flag_af": '1f1e6-1f1eb',
  "flag_ag": '1f1e6-1f1ec',
  "flag_ai": '1f1e6-1f1ee',
  "flag_al": '1f1e6-1f1f1',
  "flag_am": '1f1e6-1f1f2',
  "flag_ao": '1f1e6-1f1f4',
  "flag_aq": '1f1e6-1f1f6',
  "flag_ar": '1f1e6-1f1f7',
  "flag_as": '1f1e6-1f1f8',
  "flag_at": '1f1e6-1f1f9',
  "flag_au": '1f1e6-1f1fa',
  "flag_aw": '1f1e6-1f1fc',
  "flag_ax": '1f1e6-1f1fd',
  "flag_az": '1f1e6-1f1ff',
  "flag_ba": '1f1e7-1f1e6',
  "flag_bb": '1f1e7-1f1e7',
  "flag_bd": '1f1e7-1f1e9',
  "flag_be": '1f1e7-1f1ea',
  "flag_bf": '1f1e7-1f1eb',
  "flag_bg": '1f1e7-1f1ec',
  "flag_bh": '1f1e7-1f1ed',
  "flag_bi": '1f1e7-1f1ee',
  "flag_bj": '1f1e7-1f1ef',
  "flag_bl": '1f1e7-1f1f1',
  "flag_bm": '1f1e7-1f1f2',
  "flag_bn": '1f1e7-1f1f3',
  "flag_bo": '1f1e7-1f1f4',
  "flag_bq": '1f1e7-1f1f6',
  "flag_br": '1f1e7-1f1f7',
  "flag_bs": '1f1e7-1f1f8',
  "flag_bt": '1f1e7-1f1f9',
  "flag_bv": '1f1e7-1f1fb',
  "flag_bw": '1f1e7-1f1fc',
  "flag_by": '1f1e7-1f1fe',
  "flag_bz": '1f1e7-1f1ff',
  "flag_ca": '1f1e8-1f1e6',
  "flag_cc": '1f1e8-1f1e8',
  "flag_cd": '1f1e8-1f1e9',
  "flag_cf": '1f1e8-1f1eb',
  "flag_cg": '1f1e8-1f1ec',
  "flag_ch": '1f1e8-1f1ed',
  "flag_ci": '1f1e8-1f1ee',
  "flag_ck": '1f1e8-1f1f0',
  "flag_cl": '1f1e8-1f1f1',
  "flag_cm": '1f1e8-1f1f2',
  "flag_cn": '1f1e8-1f1f3',
  "flag_co": '1f1e8-1f1f4',
  "flag_cp": '1f1e8-1f1f5',
  "flag_cr": '1f1e8-1f1f7',
  "flag_cu": '1f1e8-1f1fa',
  "flag_cv": '1f1e8-1f1fb',
  "flag_cw": '1f1e8-1f1fc',
  "flag_cx": '1f1e8-1f1fd',
  "flag_cy": '1f1e8-1f1fe',
  "flag_cz": '1f1e8-1f1ff',
  "flag_de": '1f1e9-1f1ea',
  "flag_dg": '1f1e9-1f1ec',
  "flag_dj": '1f1e9-1f1ef',
  "flag_dk": '1f1e9-1f1f0',
  "flag_dm": '1f1e9-1f1f2',
  "flag_do": '1f1e9-1f1f4',
  "flag_dz": '1f1e9-1f1ff',
  "flag_ea": '1f1ea-1f1e6',
  "flag_ec": '1f1ea-1f1e8',
  "flag_ee": '1f1ea-1f1ea',
  "flag_eg": '1f1ea-1f1ec',
  "flag_eh": '1f1ea-1f1ed',
  "flag_er": '1f1ea-1f1f7',
  "flag_es": '1f1ea-1f1f8',
  "flag_et": '1f1ea-1f1f9',
  "flag_eu": '1f1ea-1f1fa',
  "flag_fi": '1f1eb-1f1ee',
  "flag_fj": '1f1eb-1f1ef',
  "flag_fk": '1f1eb-1f1f0',
  "flag_fm": '1f1eb-1f1f2',
  "flag_fo": '1f1eb-1f1f4',
  "flag_fr": '1f1eb-1f1f7',
  "flag_ga": '1f1ec-1f1e6',
  "flag_gb": '1f1ec-1f1e7',
  "flag_gbeng": '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f',
  "flag_gbsct": '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f',
  "flag_gbwls": '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f',
  "flag_gd": '1f1ec-1f1e9',
  "flag_ge": '1f1ec-1f1ea',
  "flag_gf": '1f1ec-1f1eb',
  "flag_gg": '1f1ec-1f1ec',
  "flag_gh": '1f1ec-1f1ed',
  "flag_gi": '1f1ec-1f1ee',
  "flag_gl": '1f1ec-1f1f1',
  "flag_gm": '1f1ec-1f1f2',
  "flag_gn": '1f1ec-1f1f3',
  "flag_gp": '1f1ec-1f1f5',
  "flag_gq": '1f1ec-1f1f6',
  "flag_gr": '1f1ec-1f1f7',
  "flag_gs": '1f1ec-1f1f8',
  "flag_gt": '1f1ec-1f1f9',
  "flag_gu": '1f1ec-1f1fa',
  "flag_gw": '1f1ec-1f1fc',
  "flag_gy": '1f1ec-1f1fe',
  "flag_hk": '1f1ed-1f1f0',
  "flag_hm": '1f1ed-1f1f2',
  "flag_hn": '1f1ed-1f1f3',
  "flag_hr": '1f1ed-1f1f7',
  "flag_ht": '1f1ed-1f1f9',
  "flag_hu": '1f1ed-1f1fa',
  "flag_ic": '1f1ee-1f1e8',
  "flag_id": '1f1ee-1f1e9',
  "flag_ie": '1f1ee-1f1ea',
  "flag_il": '1f1ee-1f1f1',
  "flag_im": '1f1ee-1f1f2',
  "flag_in": '1f1ee-1f1f3',
  "flag_io": '1f1ee-1f1f4',
  "flag_iq": '1f1ee-1f1f6',
  "flag_ir": '1f1ee-1f1f7',
  "flag_is": '1f1ee-1f1f8',
  "flag_it": '1f1ee-1f1f9',
  "flag_je": '1f1ef-1f1ea',
  "flag_jm": '1f1ef-1f1f2',
  "flag_jo": '1f1ef-1f1f4',
  "flag_jp": '1f1ef-1f1f5',
  "flag_ke": '1f1f0-1f1ea',
  "flag_kg": '1f1f0-1f1ec',
  "flag_kh": '1f1f0-1f1ed',
  "flag_ki": '1f1f0-1f1ee',
  "flag_km": '1f1f0-1f1f2',
  "flag_kn": '1f1f0-1f1f3',
  "flag_kp": '1f1f0-1f1f5',
  "flag_kr": '1f1f0-1f1f7',
  "flag_kw": '1f1f0-1f1fc',
  "flag_ky": '1f1f0-1f1fe',
  "flag_kz": '1f1f0-1f1ff',
  "flag_la": '1f1f1-1f1e6',
  "flag_lb": '1f1f1-1f1e7',
  "flag_lc": '1f1f1-1f1e8',
  "flag_li": '1f1f1-1f1ee',
  "flag_lk": '1f1f1-1f1f0',
  "flag_lr": '1f1f1-1f1f7',
  "flag_ls": '1f1f1-1f1f8',
  "flag_lt": '1f1f1-1f1f9',
  "flag_lu": '1f1f1-1f1fa',
  "flag_lv": '1f1f1-1f1fb',
  "flag_ly": '1f1f1-1f1fe',
  "flag_ma": '1f1f2-1f1e6',
  "flag_mc": '1f1f2-1f1e8',
  "flag_md": '1f1f2-1f1e9',
  "flag_me": '1f1f2-1f1ea',
  "flag_mf": '1f1f2-1f1eb',
  "flag_mg": '1f1f2-1f1ec',
  "flag_mh": '1f1f2-1f1ed',
  "flag_mk": '1f1f2-1f1f0',
  "flag_ml": '1f1f2-1f1f1',
  "flag_mm": '1f1f2-1f1f2',
  "flag_mn": '1f1f2-1f1f3',
  "flag_mo": '1f1f2-1f1f4',
  "flag_mp": '1f1f2-1f1f5',
  "flag_mq": '1f1f2-1f1f6',
  "flag_mr": '1f1f2-1f1f7',
  "flag_ms": '1f1f2-1f1f8',
  "flag_mt": '1f1f2-1f1f9',
  "flag_mu": '1f1f2-1f1fa',
  "flag_mv": '1f1f2-1f1fb',
  "flag_mw": '1f1f2-1f1fc',
  "flag_mx": '1f1f2-1f1fd',
  "flag_my": '1f1f2-1f1fe',
  "flag_mz": '1f1f2-1f1ff',
  "flag_na": '1f1f3-1f1e6',
  "flag_nc": '1f1f3-1f1e8',
  "flag_ne": '1f1f3-1f1ea',
  "flag_nf": '1f1f3-1f1eb',
  "flag_ng": '1f1f3-1f1ec',
  "flag_ni": '1f1f3-1f1ee',
  "flag_nl": '1f1f3-1f1f1',
  "flag_no": '1f1f3-1f1f4',
  "flag_np": '1f1f3-1f1f5',
  "flag_nr": '1f1f3-1f1f7',
  "flag_nu": '1f1f3-1f1fa',
  "flag_nz": '1f1f3-1f1ff',
  "flag_om": '1f1f4-1f1f2',
  "flag_pa": '1f1f5-1f1e6',
  "flag_pe": '1f1f5-1f1ea',
  "flag_pf": '1f1f5-1f1eb',
  "flag_pg": '1f1f5-1f1ec',
  "flag_ph": '1f1f5-1f1ed',
  "flag_pk": '1f1f5-1f1f0',
  "flag_pl": '1f1f5-1f1f1',
  "flag_pm": '1f1f5-1f1f2',
  "flag_pn": '1f1f5-1f1f3',
  "flag_pr": '1f1f5-1f1f7',
  "flag_ps": '1f1f5-1f1f8',
  "flag_pt": '1f1f5-1f1f9',
  "flag_pw": '1f1f5-1f1fc',
  "flag_py": '1f1f5-1f1fe',
  "flag_qa": '1f1f6-1f1e6',
  "flag_re": '1f1f7-1f1ea',
  "flag_ro": '1f1f7-1f1f4',
  "flag_rs": '1f1f7-1f1f8',
  "flag_ru": '1f1f7-1f1fa',
  "flag_rw": '1f1f7-1f1fc',
  "flag_sa": '1f1f8-1f1e6',
  "flag_sb": '1f1f8-1f1e7',
  "flag_sc": '1f1f8-1f1e8',
  "flag_sd": '1f1f8-1f1e9',
  "flag_se": '1f1f8-1f1ea',
  "flag_sg": '1f1f8-1f1ec',
  "flag_sh": '1f1f8-1f1ed',
  "flag_si": '1f1f8-1f1ee',
  "flag_sj": '1f1f8-1f1ef',
  "flag_sk": '1f1f8-1f1f0',
  "flag_sl": '1f1f8-1f1f1',
  "flag_sm": '1f1f8-1f1f2',
  "flag_sn": '1f1f8-1f1f3',
  "flag_so": '1f1f8-1f1f4',
  "flag_sr": '1f1f8-1f1f7',
  "flag_ss": '1f1f8-1f1f8',
  "flag_st": '1f1f8-1f1f9',
  "flag_sv": '1f1f8-1f1fb',
  "flag_sx": '1f1f8-1f1fd',
  "flag_sy": '1f1f8-1f1fe',
  "flag_sz": '1f1f8-1f1ff',
  "flag_ta": '1f1f9-1f1e6',
  "flag_tc": '1f1f9-1f1e8',
  "flag_td": '1f1f9-1f1e9',
  "flag_tf": '1f1f9-1f1eb',
  "flag_tg": '1f1f9-1f1ec',
  "flag_th": '1f1f9-1f1ed',
  "flag_tj": '1f1f9-1f1ef',
  "flag_tk": '1f1f9-1f1f0',
  "flag_tl": '1f1f9-1f1f1',
  "flag_tm": '1f1f9-1f1f2',
  "flag_tn": '1f1f9-1f1f3',
  "flag_to": '1f1f9-1f1f4',
  "flag_tr": '1f1f9-1f1f7',
  "flag_tt": '1f1f9-1f1f9',
  "flag_tv": '1f1f9-1f1fb',
  "flag_tw": '1f1f9-1f1fc',
  "flag_tz": '1f1f9-1f1ff',
  "flag_ua": '1f1fa-1f1e6',
  "flag_ug": '1f1fa-1f1ec',
  "flag_um": '1f1fa-1f1f2',
  "flag_un": '1f1fa-1f1f3',
  "flag_us": '1f1fa-1f1f8',
  "flag_uy": '1f1fa-1f1fe',
  "flag_uz": '1f1fa-1f1ff',
  "flag_va": '1f1fb-1f1e6',
  "flag_vc": '1f1fb-1f1e8',
  "flag_ve": '1f1fb-1f1ea',
  "flag_vg": '1f1fb-1f1ec',
  "flag_vi": '1f1fb-1f1ee',
  "flag_vn": '1f1fb-1f1f3',
  "flag_vu": '1f1fb-1f1fa',
  "flag_wf": '1f1fc-1f1eb',
  "flag_ws": '1f1fc-1f1f8',
  "flag_xk": '1f1fd-1f1f0',
  "flag_ye": '1f1fe-1f1ea',
  "flag_yt": '1f1fe-1f1f9',
  "flag_za": '1f1ff-1f1e6',
  "flag_zm": '1f1ff-1f1f2',
  "flag_zw": '1f1ff-1f1fc',
  "flags": '1f38f',
  "flamingo": '1f9a9',
  "flashlight": '1f526',
  "flat_shoe": '1f97f',
  "flatbread": '1fad3',
  "fleur-de-lis": '269c',
  "fleur_de_lis": '269c',
  "flipper": '1f42c',
  "flirty": '1f609',
  "floppy_disk": '1f4be',
  "flower_playing_cards": '1f3b4',
  "flushed": '1f633',
  "flushed_face": '1f633',
  "flute": '1fa88',
  "fly": '1fab0',
  "flying_disc": '1f94f',
  "flying_saucer": '1f6f8',
  "fog": '1f32b',
  "foggy": '1f301',
  "folded_hands": '1f64f',
  "folding_hand_fan": '1faad',
  "fondue": '1fad5',
  "foot": '1f9b6',
  "football": '1f3c8',
  "footprints": '1f463',
  "fork_and_knife": '1f374',
  "fork_knife_plate": '1f37d',
  "fortune_cookie": '1f960',
  "fountain": '26f2',
  "fountain_pen": '1f58b',
  "four": '34-20e3',
  "four_leaf_clover": '1f340',
  "fox": '1f98a',
  "fox_face": '1f98a',
  "fr": '1f1eb-1f1f7',
  "frame_with_picture": '1f5bc',
  "framed_picture": '1f5bc',
  "france": '1f1eb-1f1f7',
  "free": '1f193',
  "french_fries": '1f35f',
  "french_guiana": '1f1ec-1f1eb',
  "french_polynesia": '1f1f5-1f1eb',
  "french_southern_territories": '1f1f9-1f1eb',
  "fried_egg": '1f373',
  "fried_shrimp": '1f364',
  "fries": '1f35f',
  "frog": '1f438',
  "frog_face": '1f438',
  "frowning": '1f626',
  "frowning_face": '1f626',
  "fuelpump": '26fd',
  "full_moon": '1f315',
  "full_moon_with_face": '1f31d',
  "funeral_urn": '26b1',
  "gabon": '1f1ec-1f1e6',
  "gambia": '1f1ec-1f1f2',
  "game_die": '1f3b2',
  "garlic": '1f9c4',
  "gasp": '1fae2',
  "gb": '1f1ec-1f1e7',
  "gear": '2699',
  "gem": '1f48e',
  "gemini": '264a',
  "genie": '1f9de',
  "georgia": '1f1ec-1f1ea',
  "germany": '1f1e9-1f1ea',
  "ghana": '1f1ec-1f1ed',
  "ghost": '1f47b',
  "gibraltar": '1f1ec-1f1ee',
  "gift": '1f381',
  "gift_heart": '1f49d',
  "ginger_root": '1fada',
  "giraffe": '1f992',
  "giraffe_face": '1f992',
  "girl": '1f467',
  "glass_of_milk": '1f95b',
  "glasses": '1f453',
  "gleeful": '1f601',
  "globe_with_meridians": '1f310',
  "gloves": '1f9e4',
  "glowing_star": '1f31f',
  "goal_net": '1f945',
  "goat": '1f410',
  "goblin": '1f47a',
  "goggles": '1f97d',
  "golf": '26f3',
  "golfer": '1f3cc',
  "golfing": '1f3cc',
  "goose": '1fabf',
  "gorilla": '1f98d',
  "graduation_cap": '1f393',
  "grapes": '1f347',
  "greece": '1f1ec-1f1f7',
  "green_apple": '1f34f',
  "green_book": '1f4d7',
  "green_circle": '1f7e2',
  "green_heart": '1f49a',
  "green_salad": '1f957',
  "green_square": '1f7e9',
  "greenland": '1f1ec-1f1f1',
  "grenada": '1f1ec-1f1e9',
  "grey_exclamation": '2755',
  "grey_heart": '1fa76',
  "grey_question": '2754',
  "grimaced": '1f62c',
  "grimacing": '1f62c',
  "grimacing_face": '1f62c',
  "grin": '1f601',
  "grinning": '1f600',
  "grinning_cat": '1f63a',
  "grinning_cat_with_closed_eyes": '1f638',
  "grinning_face": '1f600',
  "grinning_face_with_big_eyes": '1f603',
  "grinning_face_with_closed_eyes": '1f604',
  "grinning_face_with_one_large_and_one_small_eye": '1f92a',
  "grinning_face_with_star_eyes": '1f929',
  "grinning_face_with_sweat": '1f605',
  "growing_heart": '1f497',
  "guadeloupe": '1f1ec-1f1f5',
  "guam": '1f1ec-1f1fa',
  "guard": '1f482',
  "guardsman": '1f482',
  "guatemala": '1f1ec-1f1f9',
  "guernsey": '1f1ec-1f1ec',
  "guide_dog": '1f9ae',
  "guinea": '1f1ec-1f1f3',
  "guinea_bissau": '1f1ec-1f1fc',
  "guitar": '1f3b8',
  "gun": '1f52b',
  "guyana": '1f1ec-1f1fe',
  "haha": '1f602',
  "hair_pick": '1faae',
  "haircut": '1f487',
  "haiti": '1f1ed-1f1f9',
  "halo": '1f607',
  "hamburger": '1f354',
  "hammer": '1f528',
  "hammer_and_pick": '2692',
  "hammer_and_wrench": '1f6e0',
  "hamsa": '1faac',
  "hamster": '1f439',
  "hamster_face": '1f439',
  "hand": '270b',
  "hand_over_mouth": '1f92d',
  "hand_with_index_and_middle_fingers_crossed": '1f91e',
  "hand_with_index_finger_and_thumb_crossed": '1faf0',
  "handbag": '1f45c',
  "handball": '1f93e',
  "handicapped": '267f',
  "handshake": '1f91d',
  "hankey": '1f4a9',
  "happy": '1f600',
  "harp": '1fa89',
  "hash": '23-20e3',
  "hatched_chick": '1f425',
  "hatching_chick": '1f423',
  "head_shaking_horizontally": '1f642-200d-2194-fe0f',
  "head_shaking_vertically": '1f642-200d-2195-fe0f',
  "headphones": '1f3a7',
  "headstone": '1faa6',
  "health_worker": '1f9d1-200d-2695-fe0f',
  "hear_no_evil": '1f649',
  "heard_mcdonald_islands": '1f1ed-1f1f2',
  "hearing_aid": '1f9bb',
  "heart": '2764',
  "heart_decoration": '1f49f',
  "heart_exclamation": '2763',
  "heart_eyes": '1f60d',
  "heart_eyes_cat": '1f63b',
  "heart_hands": '1faf6',
  "heart_on_fire": '2764-fe0f-200d-1f525',
  "heart_with_arrow": '1f498',
  "heart_with_ribbon": '1f49d',
  "heartbeat": '1f493',
  "heartpulse": '1f497',
  "hearts": '2665',
  "heavy_check_mark": '2714',
  "heavy_division_sign": '2797',
  "heavy_dollar_sign": '1f4b2',
  "heavy_equals_sign": '1f7f0',
  "heavy_exclamation_mark": '2757',
  "heavy_heart_exclamation_mark_ornament": '2763',
  "heavy_minus_sign": '2796',
  "heavy_multiplication_x": '2716',
  "heavy_plus_sign": '2795',
  "hedgehog": '1f994',
  "helicopter": '1f681',
  "helmet_with_cross": '26d1',
  "helmet_with_white_cross": '26d1',
  "herb": '1f33f',
  "hibiscus": '1f33a',
  "high_brightness": '1f506',
  "high_five": '270b',
  "high_heel": '1f460',
  "high_voltage": '26a1',
  "high_volume": '1f50a',
  "hiking_boot": '1f97e',
  "hindu_temple": '1f6d5',
  "hippo": '1f99b',
  "hippopotamus": '1f99b',
  "hocho": '1f52a',
  "hockey": '1f3d2',
  "hole": '1f573',
  "hollow_red_circle": '2b55',
  "homes": '1f3d8',
  "honduras": '1f1ed-1f1f3',
  "honey_pot": '1f36f',
  "honeybee": '1f41d',
  "hong_kong": '1f1ed-1f1f0',
  "hook": '1fa9d',
  "hooray": '1f973',
  "horse": '1f40e',
  "horse_face": '1f434',
  "horse_racing": '1f3c7',
  "hospital": '1f3e5',
  "hot": '1f975',
  "hot_face": '1f975',
  "hot_pepper": '1f336',
  "hotdog": '1f32d',
  "hotel": '1f3e8',
  "hotsprings": '2668',
  "hourglass": '231b',
  "hourglass_flowing_sand": '23f3',
  "house": '1f3e0',
  "house_abandoned": '1f3da',
  "house_buildings": '1f3d8',
  "house_with_garden": '1f3e1',
  "houses": '1f3d8',
  "hug": '1f917',
  "hugging": '1f917',
  "hugging_face": '1f917',
  "hungary": '1f1ed-1f1fa',
  "hushed": '1f62f',
  "hushed_face": '1f62f',
  "hut": '1f6d6',
  "hyacinth": '1fabb',
  "i_love_you_hand_sign": '1f91f',
  "ice": '1f9ca',
  "ice_cream": '1f368',
  "ice_cube": '1f9ca',
  "ice_hockey_stick_and_puck": '1f3d2',
  "ice_skate": '26f8',
  "icecream": '1f366',
  "iceland": '1f1ee-1f1f8',
  "id": '1f194',
  "id_card": '1faaa',
  "identification_card": '1faaa',
  "ideograph_advantage": '1f250',
  "ill": '1f912',
  "imp": '1f47f',
  "in_clouds": '1f636-200d-1f32b-fe0f',
  "inbox_tray": '1f4e5',
  "incoming_envelope": '1f4e8',
  "index_pointing_at_the_viewer": '1faf5',
  "india": '1f1ee-1f1f3',
  "indonesia": '1f1ee-1f1e9',
  "infinity": '267e',
  "info": '2139',
  "information_desk_person": '1f481',
  "information_source": '2139',
  "innocent": '1f607',
  "interrobang": '2049',
  "iphone": '1f4f1',
  "iran": '1f1ee-1f1f7',
  "iraq": '1f1ee-1f1f6',
  "ireland": '1f1ee-1f1ea',
  "island": '1f3dd',
  "isle_of_man": '1f1ee-1f1f2',
  "israel": '1f1ee-1f1f1',
  "it": '1f1ee-1f1f9',
  "italy": '1f1ee-1f1f9',
  "izakaya_lantern": '1f3ee',
  "ja_acceptable": '1f251',
  "ja_application": '1f238',
  "ja_bargain": '1f250',
  "ja_congratulations": '3297',
  "ja_discount": '1f239',
  "ja_free_of_charge": '1f21a',
  "ja_here": '1f201',
  "ja_monthly_amount": '1f237',
  "ja_no_vacancy": '1f235',
  "ja_not_free_of_carge": '1f236',
  "ja_open_for_business": '1f23a',
  "ja_passing_grade": '1f234',
  "ja_prohibited": '1f232',
  "ja_reserved": '1f22f',
  "ja_secret": '3299',
  "ja_service_charge": '1f202',
  "ja_vacancy": '1f233',
  "jack_o_lantern": '1f383',
  "jamaica": '1f1ef-1f1f2',
  "japan": '1f1ef-1f1f5',
  "japan_map": '1f5fe',
  "japanese_castle": '1f3ef',
  "japanese_goblin": '1f47a',
  "japanese_ogre": '1f479',
  "jar": '1fad9',
  "jeans": '1f456',
  "jellyfish": '1fabc',
  "jersey": '1f1ef-1f1ea',
  "jigsaw": '1f9e9',
  "jolly_roger": '1f3f4-200d-2620-fe0f',
  "jordan": '1f1ef-1f1f4',
  "joy": '1f602',
  "joy_cat": '1f639',
  "joystick": '1f579',
  "jp": '1f1ef-1f1f5',
  "judge": '1f9d1-200d-2696-fe0f',
  "juggler": '1f939',
  "juggling": '1f939',
  "juice_box": '1f9c3',
  "kaaba": '1f54b',
  "kangaroo": '1f998',
  "kazakhstan": '1f1f0-1f1ff',
  "kenya": '1f1f0-1f1ea',
  "key": '1f511',
  "keyboard": '2328',
  "keycap_star": '2a-20e3',
  "keycap_ten": '1f51f',
  "khanda": '1faaf',
  "kimono": '1f458',
  "kiribati": '1f1f0-1f1ee',
  "kiss": '1f48b',
  "kiss_mm": '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
  "kiss_mw": '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468',
  "kiss_wm": '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468',
  "kiss_ww": '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
  "kissing": '1f617',
  "kissing_cat": '1f63d',
  "kissing_closed_eyes": '1f61a',
  "kissing_face": '1f617',
  "kissing_face_with_closed_eyes": '1f61a',
  "kissing_face_with_smiling_eyes": '1f619',
  "kissing_heart": '1f618',
  "kissing_smiling_eyes": '1f619',
  "kite": '1fa81',
  "kiwi": '1f95d',
  "kiwifruit": '1f95d',
  "kneeling": '1f9ce',
  "kneeling_person": '1f9ce',
  "knife": '1f52a',
  "knife_fork_plate": '1f37d',
  "knocked_out": '1f635',
  "knot": '1faa2',
  "koala": '1f428',
  "koala_face": '1f428',
  "koko": '1f201',
  "kosovo": '1f1fd-1f1f0',
  "kr": '1f1f0-1f1f7',
  "kuwait": '1f1f0-1f1fc',
  "kyrgyzstan": '1f1f0-1f1ec',
  "lab_coat": '1f97c',
  "label": '1f3f7',
  "lacrosse": '1f94d',
  "ladder": '1fa9c',
  "lady_beetle": '1f41e',
  "ladybug": '1f41e',
  "lantern": '1f3ee',
  "laos": '1f1f1-1f1e6',
  "laptop": '1f4bb',
  "large_blue_circle": '1f535',
  "large_blue_diamond": '1f537',
  "large_blue_square": '1f7e6',
  "large_brown_circle": '1f7e4',
  "large_brown_square": '1f7eb',
  "large_green_circle": '1f7e2',
  "large_green_square": '1f7e9',
  "large_orange_circle": '1f7e0',
  "large_orange_diamond": '1f536',
  "large_orange_square": '1f7e7',
  "large_purple_circle": '1f7e3',
  "large_purple_square": '1f7ea',
  "large_red_square": '1f7e5',
  "large_yellow_circle": '1f7e1',
  "large_yellow_square": '1f7e8',
  "last_quarter_moon": '1f317',
  "last_quarter_moon_with_face": '1f31c',
  "latin_cross": '271d',
  "latvia": '1f1f1-1f1fb',
  "laughing": '1f606',
  "leafless_tree": '1fabe',
  "leafy_green": '1f96c',
  "leaves": '1f343',
  "lebanon": '1f1f1-1f1e7',
  "ledger": '1f4d2',
  "left-facing_fist": '1f91b',
  "left_facing_fist": '1f91b',
  "left_luggage": '1f6c5',
  "left_right_arrow": '2194',
  "left_speech_bubble": '1f5e8',
  "leftwards_arrow_with_hook": '21a9',
  "leftwards_hand": '1faf2',
  "leftwards_pushing_hand": '1faf7',
  "leg": '1f9b5',
  "lemon": '1f34b',
  "leo": '264c',
  "leopard": '1f406',
  "lesotho": '1f1f1-1f1f8',
  "level_slider": '1f39a',
  "levitate": '1f574',
  "levitating": '1f574',
  "liberia": '1f1f1-1f1f7',
  "libra": '264e',
  "libya": '1f1f1-1f1fe',
  "liechtenstein": '1f1f1-1f1ee',
  "lifebuoy": '1f6df',
  "light_blue_heart": '1fa75',
  "light_bulb": '1f4a1',
  "light_rail": '1f688',
  "lightning": '1f329',
  "lightning_cloud": '1f329',
  "lime": '1f34b-200d-1f7e9',
  "link": '1f517',
  "linked_paperclips": '1f587',
  "lion": '1f981',
  "lion_face": '1f981',
  "lips": '1f444',
  "lipstick": '1f484',
  "lithuania": '1f1f1-1f1f9',
  "litter_bin": '1f6ae',
  "lizard": '1f98e',
  "llama": '1f999',
  "lmao": '1f602',
  "lobster": '1f99e',
  "lock": '1f512',
  "lock_with_ink_pen": '1f50f',
  "locked": '1f512',
  "locked_with_key": '1f510',
  "locked_with_pen": '1f50f',
  "lol": '1f606',
  "lollipop": '1f36d',
  "long_drum": '1fa98',
  "loop": '27bf',
  "lotion_bottle": '1f9f4',
  "lotus": '1fab7',
  "loud_sound": '1f50a',
  "loudly_crying_face": '1f62d',
  "loudspeaker": '1f4e2',
  "love_hotel": '1f3e9',
  "love_letter": '1f48c',
  "love_you_gesture": '1f91f',
  "lovestruck": '1f60d',
  "lovestruck_cat": '1f63b',
  "loving_kiss": '1f618',
  "low_battery": '1faab',
  "low_brightness": '1f505',
  "low_volume": '1f508',
  "lower_left_ballpoint_pen": '1f58a',
  "lower_left_crayon": '1f58d',
  "lower_left_fountain_pen": '1f58b',
  "lower_left_paintbrush": '1f58c',
  "luggage": '1f9f3',
  "lungs": '1fac1',
  "luxembourg": '1f1f1-1f1fa',
  "lying": '1f925',
  "lying_face": '1f925',
  "m": '24c2',
  "macao": '1f1f2-1f1f4',
  "macau": '1f1f2-1f1f4',
  "macedonia": '1f1f2-1f1f0',
  "madagascar": '1f1f2-1f1ec',
  "mag": '1f50d',
  "mag_right": '1f50e',
  "mage": '1f9d9',
  "magic_wand": '1fa84',
  "magnet": '1f9f2',
  "mahjong": '1f004',
  "mailbox": '1f4eb',
  "mailbox_closed": '1f4ea',
  "mailbox_with_mail": '1f4ec',
  "mailbox_with_no_mail": '1f4ed',
  "malawi": '1f1f2-1f1fc',
  "malaysia": '1f1f2-1f1fe',
  "maldives": '1f1f2-1f1fb',
  "male": '2642',
  "male-artist": '1f468-200d-1f3a8',
  "male-astronaut": '1f468-200d-1f680',
  "male-construction-worker": '1f477-200d-2642-fe0f',
  "male-cook": '1f468-200d-1f373',
  "male-detective": '1f575-fe0f-200d-2642-fe0f',
  "male-doctor": '1f468-200d-2695-fe0f',
  "male-factory-worker": '1f468-200d-1f3ed',
  "male-farmer": '1f468-200d-1f33e',
  "male-firefighter": '1f468-200d-1f692',
  "male-guard": '1f482-200d-2642-fe0f',
  "male-judge": '1f468-200d-2696-fe0f',
  "male-mechanic": '1f468-200d-1f527',
  "male-office-worker": '1f468-200d-1f4bc',
  "male-pilot": '1f468-200d-2708-fe0f',
  "male-police-officer": '1f46e-200d-2642-fe0f',
  "male-scientist": '1f468-200d-1f52c',
  "male-singer": '1f468-200d-1f3a4',
  "male-student": '1f468-200d-1f393',
  "male-teacher": '1f468-200d-1f3eb',
  "male-technologist": '1f468-200d-1f4bb',
  "male_elf": '1f9dd-200d-2642-fe0f',
  "male_fairy": '1f9da-200d-2642-fe0f',
  "male_genie": '1f9de-200d-2642-fe0f',
  "male_mage": '1f9d9-200d-2642-fe0f',
  "male_sign": '2642',
  "male_superhero": '1f9b8-200d-2642-fe0f',
  "male_supervillain": '1f9b9-200d-2642-fe0f',
  "male_vampire": '1f9db-200d-2642-fe0f',
  "male_zombie": '1f9df-200d-2642-fe0f',
  "mali": '1f1f2-1f1f1',
  "malta": '1f1f2-1f1f9',
  "mammoth": '1f9a3',
  "man": '1f468',
  "man-biking": '1f6b4-200d-2642-fe0f',
  "man-bouncing-ball": '26f9-fe0f-200d-2642-fe0f',
  "man-bowing": '1f647-200d-2642-fe0f',
  "man-boy": '1f468-200d-1f466',
  "man-boy-boy": '1f468-200d-1f466-200d-1f466',
  "man-cartwheeling": '1f938-200d-2642-fe0f',
  "man-facepalming": '1f926-200d-2642-fe0f',
  "man-frowning": '1f64d-200d-2642-fe0f',
  "man-gesturing-no": '1f645-200d-2642-fe0f',
  "man-gesturing-ok": '1f646-200d-2642-fe0f',
  "man-getting-haircut": '1f487-200d-2642-fe0f',
  "man-getting-massage": '1f486-200d-2642-fe0f',
  "man-girl": '1f468-200d-1f467',
  "man-girl-boy": '1f468-200d-1f467-200d-1f466',
  "man-girl-girl": '1f468-200d-1f467-200d-1f467',
  "man-golfing": '1f3cc-fe0f-200d-2642-fe0f',
  "man-heart-man": '1f468-200d-2764-fe0f-200d-1f468',
  "man-juggling": '1f939-200d-2642-fe0f',
  "man-kiss-man": '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
  "man-lifting-weights": '1f3cb-fe0f-200d-2642-fe0f',
  "man-man-boy": '1f468-200d-1f468-200d-1f466',
  "man-man-boy-boy": '1f468-200d-1f468-200d-1f466-200d-1f466',
  "man-man-girl": '1f468-200d-1f468-200d-1f467',
  "man-man-girl-boy": '1f468-200d-1f468-200d-1f467-200d-1f466',
  "man-man-girl-girl": '1f468-200d-1f468-200d-1f467-200d-1f467',
  "man-mountain-biking": '1f6b5-200d-2642-fe0f',
  "man-playing-handball": '1f93e-200d-2642-fe0f',
  "man-playing-water-polo": '1f93d-200d-2642-fe0f',
  "man-pouting": '1f64e-200d-2642-fe0f',
  "man-raising-hand": '1f64b-200d-2642-fe0f',
  "man-rowing-boat": '1f6a3-200d-2642-fe0f',
  "man-running": '1f3c3-200d-2642-fe0f',
  "man-shrugging": '1f937-200d-2642-fe0f',
  "man-surfing": '1f3c4-200d-2642-fe0f',
  "man-swimming": '1f3ca-200d-2642-fe0f',
  "man-tipping-hand": '1f481-200d-2642-fe0f',
  "man-walking": '1f6b6-200d-2642-fe0f',
  "man-wearing-turban": '1f473-200d-2642-fe0f',
  "man-with-bunny-ears-partying": '1f46f-200d-2642-fe0f',
  "man-woman-boy": '1f468-200d-1f469-200d-1f466',
  "man-woman-boy-boy": '1f468-200d-1f469-200d-1f466-200d-1f466',
  "man-woman-girl": '1f468-200d-1f469-200d-1f467',
  "man-woman-girl-boy": '1f468-200d-1f469-200d-1f467-200d-1f466',
  "man-woman-girl-girl": '1f468-200d-1f469-200d-1f467-200d-1f467',
  "man-wrestling": '1f93c-200d-2642-fe0f',
  "man_and_woman_holding_hands": '1f46b',
  "man_artist": '1f468-200d-1f3a8',
  "man_astronaut": '1f468-200d-1f680',
  "man_bald": '1f468-200d-1f9b2',
  "man_bearded": '1f9d4-200d-2642-fe0f',
  "man_biking": '1f6b4-200d-2642-fe0f',
  "man_blond_haired": '1f471-200d-2642-fe0f',
  "man_bouncing_ball": '26f9-fe0f-200d-2642-fe0f',
  "man_bowing": '1f647-200d-2642-fe0f',
  "man_cartwheeling": '1f938-200d-2642-fe0f',
  "man_climbing": '1f9d7-200d-2642-fe0f',
  "man_construction_worker": '1f477-200d-2642-fe0f',
  "man_cook": '1f468-200d-1f373',
  "man_curly_haired": '1f468-200d-1f9b1',
  "man_dancing": '1f57a',
  "man_detective": '1f575-fe0f-200d-2642-fe0f',
  "man_elf": '1f9dd-200d-2642-fe0f',
  "man_facepalming": '1f926-200d-2642-fe0f',
  "man_factory_worker": '1f468-200d-1f3ed',
  "man_fairy": '1f9da-200d-2642-fe0f',
  "man_farmer": '1f468-200d-1f33e',
  "man_feeding_baby": '1f468-200d-1f37c',
  "man_firefighter": '1f468-200d-1f692',
  "man_frowning": '1f64d-200d-2642-fe0f',
  "man_genie": '1f9de-200d-2642-fe0f',
  "man_gesturing_no": '1f645-200d-2642-fe0f',
  "man_gesturing_ok": '1f646-200d-2642-fe0f',
  "man_getting_haircut": '1f487-200d-2642-fe0f',
  "man_getting_massage": '1f486-200d-2642-fe0f',
  "man_golfing": '1f3cc-fe0f-200d-2642-fe0f',
  "man_guard": '1f482-200d-2642-fe0f',
  "man_health_worker": '1f468-200d-2695-fe0f',
  "man_in_business_suit_levitating": '1f574',
  "man_in_lotus_position": '1f9d8-200d-2642-fe0f',
  "man_in_manual_wheelchair": '1f468-200d-1f9bd',
  "man_in_manual_wheelchair_facing_right": '1f468-200d-1f9bd-200d-27a1-fe0f',
  "man_in_motorized_wheelchair": '1f468-200d-1f9bc',
  "man_in_motorized_wheelchair_facing_right": '1f468-200d-1f9bc-200d-27a1-fe0f',
  "man_in_steamy_room": '1f9d6-200d-2642-fe0f',
  "man_in_tuxedo": '1f935-200d-2642-fe0f',
  "man_judge": '1f468-200d-2696-fe0f',
  "man_juggling": '1f939-200d-2642-fe0f',
  "man_kneeling": '1f9ce-200d-2642-fe0f',
  "man_kneeling_facing_right": '1f9ce-200d-2642-fe0f-200d-27a1-fe0f',
  "man_lifting_weights": '1f3cb-fe0f-200d-2642-fe0f',
  "man_mage": '1f9d9-200d-2642-fe0f',
  "man_mechanic": '1f468-200d-1f527',
  "man_mountain_biking": '1f6b5-200d-2642-fe0f',
  "man_office_worker": '1f468-200d-1f4bc',
  "man_pilot": '1f468-200d-2708-fe0f',
  "man_playing_handball": '1f93e-200d-2642-fe0f',
  "man_playing_water_polo": '1f93d-200d-2642-fe0f',
  "man_police_officer": '1f46e-200d-2642-fe0f',
  "man_pouting": '1f64e-200d-2642-fe0f',
  "man_raising_hand": '1f64b-200d-2642-fe0f',
  "man_red_haired": '1f468-200d-1f9b0',
  "man_rowing_boat": '1f6a3-200d-2642-fe0f',
  "man_running": '1f3c3-200d-2642-fe0f',
  "man_running_facing_right": '1f3c3-200d-2642-fe0f-200d-27a1-fe0f',
  "man_scientist": '1f468-200d-1f52c',
  "man_shrugging": '1f937-200d-2642-fe0f',
  "man_singer": '1f468-200d-1f3a4',
  "man_standing": '1f9cd-200d-2642-fe0f',
  "man_student": '1f468-200d-1f393',
  "man_superhero": '1f9b8-200d-2642-fe0f',
  "man_supervillain": '1f9b9-200d-2642-fe0f',
  "man_surfing": '1f3c4-200d-2642-fe0f',
  "man_swimming": '1f3ca-200d-2642-fe0f',
  "man_teacher": '1f468-200d-1f3eb',
  "man_technologist": '1f468-200d-1f4bb',
  "man_tipping_hand": '1f481-200d-2642-fe0f',
  "man_vampire": '1f9db-200d-2642-fe0f',
  "man_walking": '1f6b6-200d-2642-fe0f',
  "man_walking_facing_right": '1f6b6-200d-2642-fe0f-200d-27a1-fe0f',
  "man_wearing_turban": '1f473-200d-2642-fe0f',
  "man_white_haired": '1f468-200d-1f9b3',
  "man_with_beard": '1f9d4-200d-2642-fe0f',
  "man_with_gua_pi_mao": '1f472',
  "man_with_probing_cane": '1f468-200d-1f9af',
  "man_with_turban": '1f473',
  "man_with_veil": '1f470-200d-2642-fe0f',
  "man_with_white_cane": '1f468-200d-1f9af',
  "man_with_white_cane_facing_right": '1f468-200d-1f9af-200d-27a1-fe0f',
  "man_zombie": '1f9df-200d-2642-fe0f',
  "mango": '1f96d',
  "mans_shoe": '1f45e',
  "mantelpiece_clock": '1f570',
  "manual_wheelchair": '1f9bd',
  "maple_leaf": '1f341',
  "maracas": '1fa87',
  "marshall_islands": '1f1f2-1f1ed',
  "martial_arts_uniform": '1f94b',
  "martinique": '1f1f2-1f1f6',
  "mask": '1f637',
  "massage": '1f486',
  "mate": '1f9c9',
  "mate_drink": '1f9c9',
  "mauritania": '1f1f2-1f1f7',
  "mauritius": '1f1f2-1f1fa',
  "mayotte": '1f1fe-1f1f9',
  "meat_on_bone": '1f356',
  "mechanic": '1f9d1-200d-1f527',
  "mechanical_arm": '1f9be',
  "mechanical_leg": '1f9bf',
  "medal": '1f396',
  "medical": '2695',
  "medical_mask": '1f637',
  "medical_symbol": '2695',
  "medium_volumne": '1f509',
  "mega": '1f4e3',
  "megaphone": '1f4e3',
  "melon": '1f348',
  "melt": '1fae0',
  "melting_face": '1fae0',
  "memo": '1f4dd',
  "men-with-bunny-ears-partying": '1f46f-200d-2642-fe0f',
  "men_holding_hands": '1f46c',
  "men_with_bunny_ears_partying": '1f46f-200d-2642-fe0f',
  "men_wrestling": '1f93c-200d-2642-fe0f',
  "mending_heart": '2764-fe0f-200d-1fa79',
  "menorah": '1f54e',
  "menorah_with_nine_branches": '1f54e',
  "mens": '1f6b9',
  "mermaid": '1f9dc-200d-2640-fe0f',
  "merman": '1f9dc-200d-2642-fe0f',
  "merperson": '1f9dc',
  "metal": '1f918',
  "metro": '1f687',
  "mexico": '1f1f2-1f1fd',
  "microbe": '1f9a0',
  "micronesia": '1f1eb-1f1f2',
  "microphone": '1f3a4',
  "microscope": '1f52c',
  "middle_finger": '1f595',
  "military_helmet": '1fa96',
  "military_medal": '1f396',
  "milk": '1f95b',
  "milky_way": '1f30c',
  "minibus": '1f690',
  "minidisc": '1f4bd',
  "minus": '2796',
  "mirror": '1fa9e',
  "mirror_ball": '1faa9',
  "mischievous": '1f61f',
  "moai": '1f5ff',
  "mobile_phone": '1f4f1',
  "mobile_phone_arrow": '1f4f2',
  "mobile_phone_off": '1f4f4',
  "moldova": '1f1f2-1f1e9',
  "monaco": '1f1f2-1f1e8',
  "money_mouth_face": '1f911',
  "money_with_wings": '1f4b8',
  "moneybag": '1f4b0',
  "mongolia": '1f1f2-1f1f3',
  "monkey": '1f412',
  "monkey_face": '1f435',
  "monorail": '1f69d',
  "montenegro": '1f1f2-1f1ea',
  "montserrat": '1f1f2-1f1f8',
  "moon": '1f314',
  "moon_cake": '1f96e',
  "moon_ceremony": '1f391',
  "moose": '1face',
  "morocco": '1f1f2-1f1e6',
  "mortar_board": '1f393',
  "mosque": '1f54c',
  "mosquito": '1f99f',
  "mostly_sunny": '1f324',
  "mother_christmas": '1f936',
  "motor_boat": '1f6e5',
  "motor_scooter": '1f6f5',
  "motorboat": '1f6e5',
  "motorcycle": '1f3cd',
  "motorized_wheelchair": '1f9bc',
  "motorway": '1f6e3',
  "mount_fuji": '1f5fb',
  "mountain": '26f0',
  "mountain_bicyclist": '1f6b5',
  "mountain_biking": '1f6b5',
  "mountain_cableway": '1f6a0',
  "mountain_railway": '1f69e',
  "mountain_snow": '1f3d4',
  "mouse": '1f401',
  "mouse2": '1f401',
  "mouse_face": '1f42d',
  "mouse_trap": '1faa4',
  "mouth": '1f444',
  "movie_camera": '1f3a5',
  "moyai": '1f5ff',
  "mozambique": '1f1f2-1f1ff',
  "mrs_claus": '1f936',
  "multiplication": '2716',
  "multiply": '2716',
  "muscle": '1f4aa',
  "mushroom": '1f344',
  "musical_keyboard": '1f3b9',
  "musical_note": '1f3b5',
  "musical_notes": '1f3b6',
  "musical_score": '1f3bc',
  "mute": '1f507',
  "mx_claus": '1f9d1-200d-1f384',
  "myanmar": '1f1f2-1f1f2',
  "nail_care": '1f485',
  "nail_polish": '1f485',
  "name_badge": '1f4db',
  "namibia": '1f1f3-1f1e6',
  "national_park": '1f3de',
  "nauru": '1f1f3-1f1f7',
  "nauseated": '1f922',
  "nauseated_face": '1f922',
  "nazar_amulet": '1f9ff',
  "necktie": '1f454',
  "negative_squared_cross_mark": '274e',
  "nepal": '1f1f3-1f1f5',
  "nerd": '1f913',
  "nerd_face": '1f913',
  "nest": '1fab9',
  "nest_with_eggs": '1faba',
  "nesting_dolls": '1fa86',
  "netherlands": '1f1f3-1f1f1',
  "neutral": '1f610',
  "neutral_face": '1f610',
  "new": '1f195',
  "new_caledonia": '1f1f3-1f1e8',
  "new_moon": '1f311',
  "new_moon_with_face": '1f31a',
  "new_zealand": '1f1f3-1f1ff',
  "newspaper": '1f4f0',
  "next_track": '23ed',
  "ng": '1f196',
  "nicaragua": '1f1f3-1f1ee',
  "niger": '1f1f3-1f1ea',
  "nigeria": '1f1f3-1f1ec',
  "night_with_stars": '1f303',
  "nine": '39-20e3',
  "ninja": '1f977',
  "niue": '1f1f3-1f1fa',
  "no": '1f44e',
  "no_bell": '1f515',
  "no_bicycles": '1f6b3',
  "no_entry": '26d4',
  "no_entry_sign": '1f6ab',
  "no_good": '1f645',
  "no_hair": '1f9b2',
  "no_littering": '1f6af',
  "no_mobile_phones": '1f4f5',
  "no_mouth": '1f636',
  "no_one_under_18": '1f51e',
  "no_pedestrians": '1f6b7',
  "no_smoking": '1f6ad',
  "no_sound": '1f507',
  "non-potable_water": '1f6b1',
  "norfolk_island": '1f1f3-1f1eb',
  "north_korea": '1f1f0-1f1f5',
  "northern_mariana_islands": '1f1f2-1f1f5',
  "norway": '1f1f3-1f1f4',
  "nose": '1f443',
  "nose_steam": '1f624',
  "notebook": '1f4d3',
  "notebook_with_decorative_cover": '1f4d4',
  "notepad_spiral": '1f5d2',
  "notes": '1f3b6',
  "number_sign": '23-20e3',
  "nut_and_bolt": '1f529',
  "o": '1f17e',
  "o2": '1f17e',
  "o_blood": '1f17e',
  "ocean": '1f30a',
  "octagonal_sign": '1f6d1',
  "octopus": '1f419',
  "oden": '1f362',
  "office": '1f3e2',
  "office_worker": '1f9d1-200d-1f4bc',
  "ogre": '1f479',
  "oil_drum": '1f6e2',
  "ok": '1f197',
  "ok_hand": '1f44c',
  "ok_woman": '1f646',
  "old_key": '1f5dd',
  "older_adult": '1f9d3',
  "older_man": '1f474',
  "older_woman": '1f475',
  "olive": '1fad2',
  "om": '1f549',
  "om_symbol": '1f549',
  "oman": '1f1f4-1f1f2',
  "on": '1f51b',
  "oncoming_automobile": '1f698',
  "oncoming_bus": '1f68d',
  "oncoming_police_car": '1f694',
  "oncoming_taxi": '1f696',
  "one": '31-20e3',
  "one-piece_swimsuit": '1fa71',
  "one_piece_swimsuit": '1fa71',
  "onion": '1f9c5',
  "open_book": '1f4d6',
  "open_file_folder": '1f4c2',
  "open_hands": '1f450',
  "open_mouth": '1f62e',
  "ophiuchus": '26ce',
  "optical_disk": '1f4bf',
  "orange": '1f34a',
  "orange_book": '1f4d9',
  "orange_circle": '1f7e0',
  "orange_heart": '1f9e1',
  "orange_square": '1f7e7',
  "orangutan": '1f9a7',
  "orthodox_cross": '2626',
  "otter": '1f9a6',
  "outbox_tray": '1f4e4',
  "owl": '1f989',
  "ox": '1f402',
  "oyster": '1f9aa',
  "package": '1f4e6',
  "page_facing_up": '1f4c4',
  "page_with_curl": '1f4c3',
  "pager": '1f4df',
  "paintbrush": '1f58c',
  "pakistan": '1f1f5-1f1f0',
  "palau": '1f1f5-1f1fc',
  "palestinian_territories": '1f1f5-1f1f8',
  "palette": '1f3a8',
  "palm_down": '1faf3',
  "palm_down_hand": '1faf3',
  "palm_tree": '1f334',
  "palm_up": '1faf4',
  "palm_up_hand": '1faf4',
  "palms_up_together": '1f932',
  "panama": '1f1f5-1f1e6',
  "pancakes": '1f95e',
  "panda": '1f43c',
  "panda_face": '1f43c',
  "paperclip": '1f4ce',
  "paperclips": '1f587',
  "papua_new_guinea": '1f1f5-1f1ec',
  "parachute": '1fa82',
  "paraguay": '1f1f5-1f1fe',
  "parking": '1f17f',
  "parrot": '1f99c',
  "part_alternation_mark": '303d',
  "partly_sunny": '26c5',
  "partly_sunny_rain": '1f326',
  "party": '1f389',
  "party_popper": '1f389',
  "partying": '1f973',
  "partying_face": '1f973',
  "passenger_ship": '1f6f3',
  "passport_control": '1f6c2',
  "pause": '23f8',
  "paw_prints": '1f43e',
  "pea_pod": '1fadb',
  "peace": '262e',
  "peace_symbol": '262e',
  "peach": '1f351',
  "peacock": '1f99a',
  "peanuts": '1f95c',
  "pear": '1f350',
  "peek": '1fae3',
  "pen": '1f58a',
  "pencil": '270f',
  "pencil2": '270f',
  "penguin": '1f427',
  "penguin_face": '1f427',
  "pensive": '1f614',
  "pensive_face": '1f614',
  "people_holding_hands": '1f9d1-200d-1f91d-200d-1f9d1',
  "people_hugging": '1fac2',
  "people_with_bunny_ears_partying": '1f46f',
  "people_wrestling": '1f93c',
  "performing_arts": '1f3ad',
  "persevere": '1f623',
  "persevering_face": '1f623',
  "person_bearded": '1f9d4',
  "person_biking": '1f6b4',
  "person_bouncing_ball": '26f9',
  "person_bowing": '1f647',
  "person_cartwheel": '1f938',
  "person_climbing": '1f9d7',
  "person_doing_cartwheel": '1f938',
  "person_facepalming": '1f926',
  "person_feeding_baby": '1f9d1-200d-1f37c',
  "person_fencing": '1f93a',
  "person_frowning": '1f64d',
  "person_gesturing_no": '1f645',
  "person_gesturing_ok": '1f646',
  "person_getting_haircut": '1f487',
  "person_getting_massage": '1f486',
  "person_golfing": '1f3cc',
  "person_in_bed": '1f6cc',
  "person_in_lotus_position": '1f9d8',
  "person_in_manual_wheelchair": '1f9d1-200d-1f9bd',
  "person_in_manual_wheelchair_facing_right": '1f9d1-200d-1f9bd-200d-27a1-fe0f',
  "person_in_motorized_wheelchair": '1f9d1-200d-1f9bc',
  "person_in_motorized_wheelchair_facing_right": '1f9d1-200d-1f9bc-200d-27a1-fe0f',
  "person_in_steamy_room": '1f9d6',
  "person_in_suit_levitating": '1f574',
  "person_in_tuxedo": '1f935',
  "person_juggling": '1f939',
  "person_kneeling": '1f9ce',
  "person_kneeling_facing_right": '1f9ce-200d-27a1-fe0f',
  "person_lifting_weights": '1f3cb',
  "person_mountain_biking": '1f6b5',
  "person_playing_handball": '1f93e',
  "person_playing_water_polo": '1f93d',
  "person_pouting": '1f64e',
  "person_raising_hand": '1f64b',
  "person_rowing_boat": '1f6a3',
  "person_running": '1f3c3',
  "person_running_facing_right": '1f3c3-200d-27a1-fe0f',
  "person_shrugging": '1f937',
  "person_skiing": '26f7',
  "person_snowboarding": '1f3c2',
  "person_standing": '1f9cd',
  "person_surfing": '1f3c4',
  "person_swimming": '1f3ca',
  "person_taking_bath": '1f6c0',
  "person_tipping_hand": '1f481',
  "person_walking": '1f6b6',
  "person_walking_facing_right": '1f6b6-200d-27a1-fe0f',
  "person_wearing_turban": '1f473',
  "person_with_ball": '26f9',
  "person_with_blond_hair": '1f471',
  "person_with_crown": '1fac5',
  "person_with_headscarf": '1f9d5',
  "person_with_pouting_face": '1f64e',
  "person_with_probing_cane": '1f9d1-200d-1f9af',
  "person_with_skullcap": '1f472',
  "person_with_veil": '1f470',
  "person_with_white_cane": '1f9d1-200d-1f9af',
  "person_with_white_cane_facing_right": '1f9d1-200d-1f9af-200d-27a1-fe0f',
  "peru": '1f1f5-1f1ea',
  "petri_dish": '1f9eb',
  "philippines": '1f1f5-1f1ed',
  "phoenix": '1f426-200d-1f525',
  "phone": '260e',
  "pick": '26cf',
  "pickup_truck": '1f6fb',
  "pie": '1f967',
  "pig": '1f416',
  "pig2": '1f416',
  "pig_face": '1f437',
  "pig_nose": '1f43d',
  "pill": '1f48a',
  "pilot": '1f9d1-200d-2708-fe0f',
  "pinata": '1fa85',
  "pinch": '1f90c',
  "pinched_fingers": '1f90c',
  "pinching_hand": '1f90f',
  "pineapple": '1f34d',
  "ping_pong": '1f3d3',
  "pink_heart": '1fa77',
  "pirate_flag": '1f3f4-200d-2620-fe0f',
  "pisces": '2653',
  "pistol": '1f52b',
  "pitcairn_islands": '1f1f5-1f1f3',
  "pizza": '1f355',
  "placard": '1faa7',
  "place_of_worship": '1f6d0',
  "play": '25b6',
  "play_pause": '23ef',
  "playful": '1f61c',
  "playground_slide": '1f6dd',
  "pleading": '1f97a',
  "pleading_face": '1f97a',
  "plunger": '1faa0',
  "plus": '2795',
  "point_down": '1f447',
  "point_forward": '1faf5',
  "point_left": '1f448',
  "point_right": '1f449',
  "point_up": '1f446',
  "point_up_2": '261d',
  "poland": '1f1f5-1f1f1',
  "polar_bear": '1f43b-200d-2744-fe0f',
  "polar_bear_face": '1f43b-200d-2744-fe0f',
  "police_car": '1f693',
  "police_officer": '1f46e',
  "poodle": '1f429',
  "poop": '1f4a9',
  "popcorn": '1f37f',
  "portugal": '1f1f5-1f1f9',
  "post_office": '1f3e3',
  "postal_horn": '1f4ef',
  "postbox": '1f4ee',
  "pot_of_food": '1f372',
  "potable_water": '1f6b0',
  "potato": '1f954',
  "potted_plant": '1fab4',
  "pouch": '1f45d',
  "poultry_leg": '1f357',
  "pound": '1f4b7',
  "pour": '1fad7',
  "pouring_liquid": '1fad7',
  "pout": '1f621',
  "pouting": '1f64e',
  "pouting_cat": '1f63e',
  "pouting_face": '1f621',
  "pray": '1f64f',
  "prayer_beads": '1f4ff',
  "pregnant_man": '1fac3',
  "pregnant_person": '1fac4',
  "pregnant_woman": '1f930',
  "pretzel": '1f968',
  "previous_track": '23ee',
  "prince": '1f934',
  "princess": '1f478',
  "printer": '1f5a8',
  "probing_cane": '1f9af',
  "puerto_rico": '1f1f5-1f1f7',
  "punch": '1f44a',
  "purple_circle": '1f7e3',
  "purple_heart": '1f49c',
  "purple_square": '1f7ea',
  "purse": '1f45b',
  "pushpin": '1f4cc',
  "put_litter_in_its_place": '1f6ae',
  "puzzle_piece": '1f9e9',
  "qatar": '1f1f6-1f1e6',
  "question": '2753',
  "quiet_sound": '1f508',
  "rabbit": '1f407',
  "rabbit2": '1f407',
  "rabbit_face": '1f430',
  "raccoon": '1f99d',
  "racehorse": '1f40e',
  "racing_car": '1f3ce',
  "racing_motorcycle": '1f3cd',
  "radio": '1f4fb',
  "radio_button": '1f518',
  "radioactive": '2622',
  "radioactive_sign": '2622',
  "rage": '1f621',
  "railway_car": '1f683',
  "railway_track": '1f6e4',
  "rain_cloud": '1f327',
  "rainbow": '1f308',
  "rainbow-flag": '1f3f3-fe0f-200d-1f308',
  "rainbow_flag": '1f3f3-fe0f-200d-1f308',
  "rainy": '1f327',
  "raised_back_of_hand": '1f91a',
  "raised_eyebrow": '1f928',
  "raised_hand": '270b',
  "raised_hand_with_fingers_splayed": '1f590',
  "raised_hands": '1f64c',
  "raising_hand": '1f64b',
  "ram": '1f40f',
  "ramen": '1f35c',
  "rat": '1f400',
  "razor": '1fa92',
  "receipt": '1f9fe',
  "record": '23fa',
  "recycle": '267b',
  "recycling_symbol": '267b',
  "red_apple": '1f34e',
  "red_car": '1f697',
  "red_circle": '1f534',
  "red_envelope": '1f9e7',
  "red_hair": '1f9b0',
  "red_haired": '1f9d1-200d-1f9b0',
  "red_haired_man": '1f468-200d-1f9b0',
  "red_haired_person": '1f9d1-200d-1f9b0',
  "red_haired_woman": '1f469-200d-1f9b0',
  "red_heart": '2764',
  "red_o": '2b55',
  "red_paper_lantern": '1f3ee',
  "red_square": '1f7e5',
  "regional_indicator_a": '1f1e6',
  "regional_indicator_b": '1f1e7',
  "regional_indicator_c": '1f1e8',
  "regional_indicator_d": '1f1e9',
  "regional_indicator_e": '1f1ea',
  "regional_indicator_f": '1f1eb',
  "regional_indicator_g": '1f1ec',
  "regional_indicator_h": '1f1ed',
  "regional_indicator_i": '1f1ee',
  "regional_indicator_j": '1f1ef',
  "regional_indicator_k": '1f1f0',
  "regional_indicator_l": '1f1f1',
  "regional_indicator_m": '1f1f2',
  "regional_indicator_n": '1f1f3',
  "regional_indicator_o": '1f1f4',
  "regional_indicator_p": '1f1f5',
  "regional_indicator_q": '1f1f6',
  "regional_indicator_r": '1f1f7',
  "regional_indicator_s": '1f1f8',
  "regional_indicator_t": '1f1f9',
  "regional_indicator_u": '1f1fa',
  "regional_indicator_v": '1f1fb',
  "regional_indicator_w": '1f1fc',
  "regional_indicator_x": '1f1fd',
  "regional_indicator_y": '1f1fe',
  "regional_indicator_z": '1f1ff',
  "registered": 'ae',
  "relaxed": '263a',
  "relieved": '1f60c',
  "relieved_face": '1f60c',
  "reminder_ribbon": '1f397',
  "repeat": '1f501',
  "repeat_one": '1f502',
  "rescue_worker_helmet": '26d1',
  "restroom": '1f6bb',
  "reunion": '1f1f7-1f1ea',
  "reverse": '25c0',
  "reversed_hand_with_middle_finger_extended": '1f595',
  "revolving_hearts": '1f49e',
  "rewind": '23ea',
  "rhino": '1f98f',
  "rhinoceros": '1f98f',
  "ribbon": '1f380',
  "rice": '1f35a',
  "rice_ball": '1f359',
  "rice_cracker": '1f358',
  "rice_scene": '1f391',
  "right-facing_fist": '1f91c',
  "right_anger_bubble": '1f5ef',
  "right_bicep": '1f4aa',
  "right_facing_fist": '1f91c',
  "rightwards_arrow_with_hook": '21aa',
  "rightwards_hand": '1faf1',
  "rightwards_pushing_hand": '1faf8',
  "ring": '1f48d',
  "ring_buoy": '1f6df',
  "ringed_planet": '1fa90',
  "robot": '1f916',
  "robot_face": '1f916',
  "rock": '1faa8',
  "rocket": '1f680',
  "rofl": '1f923',
  "roll_of_paper": '1f9fb',
  "rolled_up_newspaper": '1f5de',
  "roller_coaster": '1f3a2',
  "roller_skate": '1f6fc',
  "rolling_eyes": '1f644',
  "rolling_on_the_floor_laughing": '1f923',
  "romania": '1f1f7-1f1f4',
  "rooster": '1f413',
  "root_vegetable": '1fadc',
  "rose": '1f339',
  "rosette": '1f3f5',
  "rotating_light": '1f6a8',
  "round_pushpin": '1f4cd',
  "rowboat": '1f6a3',
  "royalty": '1fac5',
  "ru": '1f1f7-1f1fa',
  "rugby_football": '1f3c9',
  "runner": '1f3c3',
  "running": '1f3c3',
  "running_shirt": '1f3bd',
  "running_shirt_with_sash": '1f3bd',
  "russia": '1f1f7-1f1fa',
  "rwanda": '1f1f7-1f1fc',
  "sa": '1f202',
  "sad_relieved_face": '1f625',
  "safety_pin": '1f9f7',
  "safety_vest": '1f9ba',
  "sagittarius": '2650',
  "sailboat": '26f5',
  "sake": '1f376',
  "salad": '1f957',
  "salt": '1f9c2',
  "salute": '1fae1',
  "saluting_face": '1fae1',
  "samoa": '1f1fc-1f1f8',
  "san_marino": '1f1f8-1f1f2',
  "sandal": '1f461',
  "sandwich": '1f96a',
  "santa": '1f385',
  "sao_tome_principe": '1f1f8-1f1f9',
  "sari": '1f97b',
  "satellite": '1f6f0',
  "satellite_antenna": '1f4e1',
  "satisfied": '1f606',
  "saturn": '1fa90',
  "saudi_arabia": '1f1f8-1f1e6',
  "sauropod": '1f995',
  "savoring_food": '1f60b',
  "saxophone": '1f3b7',
  "scales": '2696',
  "scarf": '1f9e3',
  "school": '1f3eb',
  "school_satchel": '1f392',
  "scientist": '1f9d1-200d-1f52c',
  "scissors": '2702',
  "scooter": '1f6f4',
  "scorpion": '1f982',
  "scorpius": '264f',
  "scotland": '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f',
  "scream": '1f631',
  "scream_cat": '1f640',
  "screaming_in_fear": '1f631',
  "screwdriver": '1fa9b',
  "scroll": '1f4dc',
  "seal": '1f9ad',
  "seat": '1f4ba',
  "second_place_medal": '1f948',
  "secret": '3299',
  "see_no_evil": '1f648',
  "seedling": '1f331',
  "selfie": '1f933',
  "senegal": '1f1f8-1f1f3',
  "serbia": '1f1f7-1f1f8',
  "serious_face_with_symbols_covering_mouth": '1f92c',
  "service_dog": '1f415-200d-1f9ba',
  "seven": '37-20e3',
  "sewing_needle": '1faa1',
  "seychelles": '1f1f8-1f1e8',
  "shaking_face": '1fae8',
  "shallow_pan_of_food": '1f958',
  "shamed": '1f633',
  "shamrock": '2618',
  "shark": '1f988',
  "shaved_ice": '1f367',
  "sheaf_of_rice": '1f33e',
  "sheep": '1f411',
  "shell": '1f41a',
  "shield": '1f6e1',
  "shinto_shrine": '26e9',
  "ship": '1f6a2',
  "shirt": '1f455',
  "shit": '1f4a9',
  "shocked_face_with_exploding_head": '1f92f',
  "shoe": '1f45e',
  "shooting_star": '1f320',
  "shopping_bags": '1f6cd',
  "shopping_cart": '1f6d2',
  "shopping_trolley": '1f6d2',
  "shortcake": '1f370',
  "shorts": '1fa73',
  "shovel": '1fa8f',
  "shower": '1f6bf',
  "shrimp": '1f990',
  "shrug": '1f937',
  "shuffle": '1f500',
  "shush": '1f92b',
  "shushing_face": '1f92b',
  "sierra_leone": '1f1f8-1f1f1',
  "sign_of_the_horns": '1f918',
  "signal_strength": '1f4f6',
  "singapore": '1f1f8-1f1ec',
  "singer": '1f9d1-200d-1f3a4',
  "sint_maarten": '1f1f8-1f1fd',
  "six": '36-20e3',
  "six_pointed_star": '1f52f',
  "skateboard": '1f6f9',
  "ski": '1f3bf',
  "skier": '26f7',
  "skiing": '26f7',
  "skull": '1f480',
  "skull_and_crossbones": '2620',
  "skunk": '1f9a8',
  "sled": '1f6f7',
  "sleeping": '1f634',
  "sleeping_accommodation": '1f6cc',
  "sleeping_face": '1f634',
  "sleepy": '1f62a',
  "sleepy_face": '1f62a',
  "sleuth_or_spy": '1f575',
  "slide": '1f6dd',
  "slightly_frowning_face": '1f641',
  "slightly_smiling_face": '1f642',
  "slot_machine": '1f3b0',
  "sloth": '1f9a5',
  "slovakia": '1f1f8-1f1f0',
  "slovenia": '1f1f8-1f1ee',
  "small_airplane": '1f6e9',
  "small_blue_diamond": '1f539',
  "small_orange_diamond": '1f538',
  "small_red_triangle": '1f53a',
  "small_red_triangle_down": '1f53b',
  "smile": '1f604',
  "smile_cat": '1f638',
  "smiley": '1f603',
  "smiley_cat": '1f63a',
  "smiling_cat": '1f638',
  "smiling_cat_with_heart_eyes": '1f63b',
  "smiling_face": '263a',
  "smiling_face_with_3_hearts": '1f970',
  "smiling_face_with_closed_eyes": '1f60a',
  "smiling_face_with_heart_eyes": '1f60d',
  "smiling_face_with_smiling_eyes_and_hand_covering_mouth": '1f92d',
  "smiling_face_with_sunglasses": '1f60e',
  "smiling_face_with_tear": '1f972',
  "smiling_imp": '1f608',
  "smirk": '1f60f',
  "smirk_cat": '1f63c',
  "smirking": '1f60f',
  "smirking_face": '1f60f',
  "smoking": '1f6ac',
  "snail": '1f40c',
  "snake": '1f40d',
  "sneaker": '1f45f',
  "sneezing": '1f927',
  "sneezing_face": '1f927',
  "snow_capped_mountain": '1f3d4',
  "snow_cloud": '1f328',
  "snowboarder": '1f3c2',
  "snowboarding": '1f3c2',
  "snowflake": '2744',
  "snowman": '26c4',
  "snowman2": '2603',
  "snowman_without_snow": '26c4',
  "snowy": '1f328',
  "soap": '1f9fc',
  "sob": '1f62d',
  "soccer": '26bd',
  "socks": '1f9e6',
  "soft_serve": '1f366',
  "softball": '1f94e',
  "solomon_islands": '1f1f8-1f1e7',
  "somalia": '1f1f8-1f1f4',
  "soon": '1f51c',
  "sos": '1f198',
  "sound": '1f509',
  "south_africa": '1f1ff-1f1e6',
  "south_georgia_south_sandwich_islands": '1f1ec-1f1f8',
  "south_korea": '1f1f0-1f1f7',
  "south_sudan": '1f1f8-1f1f8',
  "space_invader": '1f47e',
  "spades": '2660',
  "spaghetti": '1f35d',
  "spain": '1f1ea-1f1f8',
  "sparkle": '2747',
  "sparkler": '1f387',
  "sparkles": '2728',
  "sparkling_heart": '1f496',
  "speak_no_evil": '1f64a',
  "speaker": '1f508',
  "speaking_head": '1f5e3',
  "speaking_head_in_silhouette": '1f5e3',
  "speech_balloon": '1f4ac',
  "speedboat": '1f6a4',
  "spider": '1f577',
  "spider_web": '1f578',
  "spiral_calendar_pad": '1f5d3',
  "spiral_note_pad": '1f5d2',
  "splatter": '1fadf',
  "spock-hand": '1f596',
  "sponge": '1f9fd',
  "spoon": '1f944',
  "sports_medal": '1f3c5',
  "spouting_whale": '1f433',
  "squid": '1f991',
  "squinting_face": '1f606',
  "sri_lanka": '1f1f1-1f1f0',
  "st_barthelemy": '1f1e7-1f1f1',
  "st_helena": '1f1f8-1f1ed',
  "st_kitts_nevis": '1f1f0-1f1f3',
  "st_lucia": '1f1f1-1f1e8',
  "st_martin": '1f1f2-1f1eb',
  "st_pierre_miquelon": '1f1f5-1f1f2',
  "st_vincent_grenadines": '1f1fb-1f1e8',
  "stadium": '1f3df',
  "staff_of_aesculapius": '2695',
  "standing": '1f9cd',
  "standing_person": '1f9cd',
  "star": '2b50',
  "star-struck": '1f929',
  "star2": '1f31f',
  "star_and_crescent": '262a',
  "star_of_david": '2721',
  "star_struck": '1f929',
  "stars": '1f320',
  "station": '1f689',
  "statue_of_liberty": '1f5fd',
  "steam_locomotive": '1f682',
  "steaming_bowl": '1f35c',
  "stethoscope": '1fa7a',
  "stew": '1f372',
  "stop": '23f9',
  "stop_sign": '1f6d1',
  "stopwatch": '23f1',
  "stormy": '26c8',
  "straight_ruler": '1f4cf',
  "strawberry": '1f353',
  "stuck_out_tongue": '1f61b',
  "stuck_out_tongue_closed_eyes": '1f61d',
  "stuck_out_tongue_winking_eye": '1f61c',
  "student": '1f9d1-200d-1f393',
  "studio_microphone": '1f399',
  "stuffed_flatbread": '1f959',
  "sudan": '1f1f8-1f1e9',
  "sun": '2600',
  "sun_and_rain": '1f326',
  "sun_behind_cloud": '26c5',
  "sun_behind_large_cloud": '1f325',
  "sun_behind_rain_cloud": '1f326',
  "sun_behind_small_cloud": '1f324',
  "sun_small_cloud": '1f324',
  "sun_with_face": '1f31e',
  "sunflower": '1f33b',
  "sunglasses": '1f576',
  "sunglasses_cool": '1f60e',
  "sunny": '1f324',
  "sunrise": '1f305',
  "sunrise_over_mountains": '1f304',
  "superhero": '1f9b8',
  "supervillain": '1f9b9',
  "surfer": '1f3c4',
  "surfing": '1f3c4',
  "suriname": '1f1f8-1f1f7',
  "surprised": '1f62e',
  "sushi": '1f363',
  "suspension_railway": '1f69f',
  "suv": '1f699',
  "svalbard_jan_mayen": '1f1f8-1f1ef',
  "swan": '1f9a2',
  "swaziland": '1f1f8-1f1ff',
  "sweat": '1f613',
  "sweat_drops": '1f4a6',
  "sweat_smile": '1f605',
  "sweden": '1f1f8-1f1ea',
  "sweet_potato": '1f360',
  "swimmer": '1f3ca',
  "swimming": '1f3ca',
  "switzerland": '1f1e8-1f1ed',
  "symbols": '1f523',
  "synagogue": '1f54d',
  "syria": '1f1f8-1f1fe',
  "syringe": '1f489',
  "t-rex": '1f996',
  "table_tennis_paddle_and_ball": '1f3d3',
  "taco": '1f32e',
  "tada": '1f389',
  "taiwan": '1f1f9-1f1fc',
  "tajikistan": '1f1f9-1f1ef',
  "takeout_box": '1f961',
  "tamale": '1fad4',
  "tanabata_tree": '1f38b',
  "tangerine": '1f34a',
  "tanzania": '1f1f9-1f1ff',
  "taurus": '2649',
  "taxi": '1f695',
  "tea": '1f375',
  "teacher": '1f9d1-200d-1f3eb',
  "teapot": '1fad6',
  "tears_of_joy": '1f602',
  "tears_of_joy_cat": '1f639',
  "technologist": '1f9d1-200d-1f4bb',
  "teddy_bear": '1f9f8',
  "telephone": '260e',
  "telephone_receiver": '1f4de',
  "telescope": '1f52d',
  "ten": '1f51f',
  "tennis": '1f3be',
  "tent": '26fa',
  "test_tube": '1f9ea',
  "thailand": '1f1f9-1f1ed',
  "the_horns": '1f918',
  "thermometer": '1f321',
  "thinking": '1f914',
  "thinking_face": '1f914',
  "third_place_medal": '1f949',
  "thong_sandal": '1fa74',
  "thought_balloon": '1f4ad',
  "thread": '1f9f5',
  "three": '33-20e3',
  "three_button_mouse": '1f5b1',
  "thumbsdown": '1f44e',
  "thumbsup": '1f44d',
  "thunder_cloud_and_rain": '26c8',
  "ticket": '1f3ab',
  "tickets": '1f39f',
  "tiger": '1f405',
  "tiger2": '1f405',
  "tiger_face": '1f42f',
  "timer_clock": '23f2',
  "timor_leste": '1f1f9-1f1f1',
  "tired": '1f62b',
  "tired_face": '1f62b',
  "tm": '2122',
  "togo": '1f1f9-1f1ec',
  "toilet": '1f6bd',
  "toilet_paper": '1f9fb',
  "tokelau": '1f1f9-1f1f0',
  "tokyo_tower": '1f5fc',
  "tomato": '1f345',
  "tone1": '1f3fb',
  "tone2": '1f3fc',
  "tone3": '1f3fd',
  "tone4": '1f3fe',
  "tone5": '1f3ff',
  "tone_dark": '1f3ff',
  "tone_light": '1f3fb',
  "tone_medium": '1f3fd',
  "tone_medium_dark": '1f3fe',
  "tone_medium_light": '1f3fc',
  "tonga": '1f1f9-1f1f4',
  "tongue": '1f445',
  "too_cool": '1f60e',
  "toolbox": '1f9f0',
  "tooth": '1f9b7',
  "toothbrush": '1faa5',
  "top": '1f51d',
  "top_hat": '1f3a9',
  "tophat": '1f3a9',
  "tornado": '1f32a',
  "tornado_cloud": '1f32a',
  "trackball": '1f5b2',
  "tractor": '1f69c',
  "trade_mark": '2122',
  "traffic_light": '1f6a5',
  "train": '1f686',
  "train2": '1f686',
  "tram": '1f68a',
  "tram_car": '1f68b',
  "transgender_flag": '1f3f3-fe0f-200d-26a7-fe0f',
  "transgender_symbol": '26a7',
  "trashcan": '1f5d1',
  "trex": '1f996',
  "triangular_flag": '1f6a9',
  "triangular_flag_on_post": '1f6a9',
  "triangular_ruler": '1f4d0',
  "trident": '1f531',
  "trinidad_tobago": '1f1f9-1f1f9',
  "tristan_da_cunha": '1f1f9-1f1e6',
  "triumph": '1f624',
  "troll": '1f9cc',
  "trolleybus": '1f68e',
  "trophy": '1f3c6',
  "tropical_drink": '1f379',
  "tropical_fish": '1f420',
  "truck": '1f69a',
  "trumpet": '1f3ba',
  "tshirt": '1f455',
  "tulip": '1f337',
  "tumbler_glass": '1f943',
  "tunisia": '1f1f9-1f1f3',
  "turkey": '1f983',
  "turkey_tr": '1f1f9-1f1f7',
  "turkmenistan": '1f1f9-1f1f2',
  "turks_caicos_islands": '1f1f9-1f1e8',
  "turtle": '1f422',
  "tuvalu": '1f1f9-1f1fb',
  "tv": '1f4fa',
  "twisted_rightwards_arrows": '1f500',
  "two": '32-20e3',
  "two_hearts": '1f495',
  "two_men_holding_hands": '1f46c',
  "two_women_holding_hands": '1f46d',
  "u5272": '1f239',
  "u5408": '1f234',
  "u55b6": '1f23a',
  "u6307": '1f22f',
  "u6708": '1f237',
  "u6709": '1f236',
  "u6e80": '1f235',
  "u7121": '1f21a',
  "u7533": '1f238',
  "u7981": '1f232',
  "u7a7a": '1f233',
  "uganda": '1f1fa-1f1ec',
  "uk": '1f1ec-1f1e7',
  "ukraine": '1f1fa-1f1e6',
  "umbrella": '2602',
  "umbrella_on_ground": '26f1',
  "umbrella_with_rain": '2614',
  "umbrella_with_rain_drops": '2614',
  "un": '1f1fa-1f1f3',
  "unamused": '1f612',
  "unamused_face": '1f612',
  "underage": '1f51e',
  "unicorn": '1f984',
  "unicorn_face": '1f984',
  "united_arab_emirates": '1f1e6-1f1ea',
  "united_kingdom": '1f1ec-1f1e7',
  "united_nations": '1f1fa-1f1f3',
  "united_states": '1f1fa-1f1f8',
  "unlock": '1f513',
  "unlocked": '1f513',
  "up": '1f53c',
  "up2": '1f199',
  "upside_down_face": '1f643',
  "uruguay": '1f1fa-1f1fe',
  "us": '1f1fa-1f1f8',
  "us_outlying_islands": '1f1fa-1f1f2',
  "us_virgin_islands": '1f1fb-1f1ee',
  "usa": '1f1fa-1f1f8',
  "uzbekistan": '1f1fa-1f1ff',
  "v": '270c',
  "vampire": '1f9db',
  "vanuatu": '1f1fb-1f1fa',
  "vatican_city": '1f1fb-1f1e6',
  "venezuela": '1f1fb-1f1ea',
  "vertical_traffic_light": '1f6a6',
  "vhs": '1f4fc',
  "vibration_mode": '1f4f3',
  "victory": '270c',
  "video_camera": '1f4f9',
  "video_game": '1f3ae',
  "videocassette": '1f4fc',
  "vietnam": '1f1fb-1f1f3',
  "violin": '1f3bb',
  "virgo": '264d',
  "volcano": '1f30b',
  "volleyball": '1f3d0',
  "vomiting": '1f92e',
  "vs": '1f19a',
  "vulcan": '1f596',
  "waffle": '1f9c7',
  "wales": '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f',
  "walking": '1f6b6',
  "wallis_futuna": '1f1fc-1f1eb',
  "waning_crescent_moon": '1f318',
  "waning_gibbous_moon": '1f316',
  "warning": '26a0',
  "wastebasket": '1f5d1',
  "watch": '231a',
  "water_buffalo": '1f403',
  "water_closet": '1f6be',
  "water_polo": '1f93d',
  "water_wave": '1f30a',
  "watermelon": '1f349',
  "watery_eyes": '1f979',
  "wave": '1f44b',
  "waving_black_flag": '1f3f4',
  "waving_hand": '1f44b',
  "waving_white_flag": '1f3f3',
  "wavy_dash": '3030',
  "waxing_crescent_moon": '1f312',
  "waxing_gibbous_moon": '1f314',
  "wc": '1f6be',
  "weary": '1f629',
  "weary_cat": '1f640',
  "weary_face": '1f629',
  "wedding": '1f492',
  "weight_lifter": '1f3cb',
  "weight_lifting": '1f3cb',
  "western_sahara": '1f1ea-1f1ed',
  "whale": '1f40b',
  "whale2": '1f40b',
  "wheel": '1f6de',
  "wheel_of_dharma": '2638',
  "wheelchair": '267f',
  "whisky": '1f943',
  "white_cane": '1f9af',
  "white_check_mark": '2705',
  "white_circle": '26aa',
  "white_exclamation": '2755',
  "white_flag": '1f3f3',
  "white_flower": '1f4ae',
  "white_frowning_face": '2639',
  "white_hair": '1f9b3',
  "white_haired": '1f9d1-200d-1f9b3',
  "white_haired_man": '1f468-200d-1f9b3',
  "white_haired_person": '1f9d1-200d-1f9b3',
  "white_haired_woman": '1f469-200d-1f9b3',
  "white_heart": '1f90d',
  "white_large_square": '2b1c',
  "white_medium_small_square": '25fd',
  "white_medium_square": '25fb',
  "white_question": '2754',
  "white_small_square": '25ab',
  "white_square_button": '1f533',
  "wilted_flower": '1f940',
  "wind_blowing_face": '1f32c',
  "wind_chime": '1f390',
  "window": '1fa9f',
  "wine_glass": '1f377',
  "wing": '1fabd',
  "wink": '1f609',
  "winking_face": '1f609',
  "wireless": '1f6dc',
  "wolf": '1f43a',
  "wolf_face": '1f43a',
  "woman": '1f469',
  "woman-biking": '1f6b4-200d-2640-fe0f',
  "woman-bouncing-ball": '26f9-fe0f-200d-2640-fe0f',
  "woman-bowing": '1f647-200d-2640-fe0f',
  "woman-boy": '1f469-200d-1f466',
  "woman-boy-boy": '1f469-200d-1f466-200d-1f466',
  "woman-cartwheeling": '1f938-200d-2640-fe0f',
  "woman-facepalming": '1f926-200d-2640-fe0f',
  "woman-frowning": '1f64d-200d-2640-fe0f',
  "woman-gesturing-no": '1f645-200d-2640-fe0f',
  "woman-gesturing-ok": '1f646-200d-2640-fe0f',
  "woman-getting-haircut": '1f487-200d-2640-fe0f',
  "woman-getting-massage": '1f486-200d-2640-fe0f',
  "woman-girl": '1f469-200d-1f467',
  "woman-girl-boy": '1f469-200d-1f467-200d-1f466',
  "woman-girl-girl": '1f469-200d-1f467-200d-1f467',
  "woman-golfing": '1f3cc-fe0f-200d-2640-fe0f',
  "woman-heart-man": '1f469-200d-2764-fe0f-200d-1f468',
  "woman-heart-woman": '1f469-200d-2764-fe0f-200d-1f469',
  "woman-juggling": '1f939-200d-2640-fe0f',
  "woman-kiss-man": '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468',
  "woman-kiss-woman": '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
  "woman-lifting-weights": '1f3cb-fe0f-200d-2640-fe0f',
  "woman-mountain-biking": '1f6b5-200d-2640-fe0f',
  "woman-playing-handball": '1f93e-200d-2640-fe0f',
  "woman-playing-water-polo": '1f93d-200d-2640-fe0f',
  "woman-pouting": '1f64e-200d-2640-fe0f',
  "woman-raising-hand": '1f64b-200d-2640-fe0f',
  "woman-rowing-boat": '1f6a3-200d-2640-fe0f',
  "woman-running": '1f3c3-200d-2640-fe0f',
  "woman-shrugging": '1f937-200d-2640-fe0f',
  "woman-surfing": '1f3c4-200d-2640-fe0f',
  "woman-swimming": '1f3ca-200d-2640-fe0f',
  "woman-tipping-hand": '1f481-200d-2640-fe0f',
  "woman-walking": '1f6b6-200d-2640-fe0f',
  "woman-wearing-turban": '1f473-200d-2640-fe0f',
  "woman-with-bunny-ears-partying": '1f46f-200d-2640-fe0f',
  "woman-woman-boy": '1f469-200d-1f469-200d-1f466',
  "woman-woman-boy-boy": '1f469-200d-1f469-200d-1f466-200d-1f466',
  "woman-woman-girl": '1f469-200d-1f469-200d-1f467',
  "woman-woman-girl-boy": '1f469-200d-1f469-200d-1f467-200d-1f466',
  "woman-woman-girl-girl": '1f469-200d-1f469-200d-1f467-200d-1f467',
  "woman-wrestling": '1f93c-200d-2640-fe0f',
  "woman_and_man_holding_hands": '1f46b',
  "woman_artist": '1f469-200d-1f3a8',
  "woman_astronaut": '1f469-200d-1f680',
  "woman_bald": '1f469-200d-1f9b2',
  "woman_bearded": '1f9d4-200d-2640-fe0f',
  "woman_biking": '1f6b4-200d-2640-fe0f',
  "woman_blond_haired": '1f471-200d-2640-fe0f',
  "woman_bouncing_ball": '26f9-fe0f-200d-2640-fe0f',
  "woman_bowing": '1f647-200d-2640-fe0f',
  "woman_cartwheeling": '1f938-200d-2640-fe0f',
  "woman_climbing": '1f9d7-200d-2640-fe0f',
  "woman_construction_worker": '1f477-200d-2640-fe0f',
  "woman_cook": '1f469-200d-1f373',
  "woman_curly_haired": '1f469-200d-1f9b1',
  "woman_dancing": '1f483',
  "woman_detective": '1f575-fe0f-200d-2640-fe0f',
  "woman_elf": '1f9dd-200d-2640-fe0f',
  "woman_facepalming": '1f926-200d-2640-fe0f',
  "woman_factory_worker": '1f469-200d-1f3ed',
  "woman_fairy": '1f9da-200d-2640-fe0f',
  "woman_farmer": '1f469-200d-1f33e',
  "woman_feeding_baby": '1f469-200d-1f37c',
  "woman_firefighter": '1f469-200d-1f692',
  "woman_frowning": '1f64d-200d-2640-fe0f',
  "woman_genie": '1f9de-200d-2640-fe0f',
  "woman_gesturing_no": '1f645-200d-2640-fe0f',
  "woman_gesturing_ok": '1f646-200d-2640-fe0f',
  "woman_getting_haircut": '1f487-200d-2640-fe0f',
  "woman_getting_massage": '1f486-200d-2640-fe0f',
  "woman_golfing": '1f3cc-fe0f-200d-2640-fe0f',
  "woman_guard": '1f482-200d-2640-fe0f',
  "woman_health_worker": '1f469-200d-2695-fe0f',
  "woman_in_lotus_position": '1f9d8-200d-2640-fe0f',
  "woman_in_manual_wheelchair": '1f469-200d-1f9bd',
  "woman_in_manual_wheelchair_facing_right": '1f469-200d-1f9bd-200d-27a1-fe0f',
  "woman_in_motorized_wheelchair": '1f469-200d-1f9bc',
  "woman_in_motorized_wheelchair_facing_right": '1f469-200d-1f9bc-200d-27a1-fe0f',
  "woman_in_steamy_room": '1f9d6-200d-2640-fe0f',
  "woman_in_tuxedo": '1f935-200d-2640-fe0f',
  "woman_judge": '1f469-200d-2696-fe0f',
  "woman_juggling": '1f939-200d-2640-fe0f',
  "woman_kneeling": '1f9ce-200d-2640-fe0f',
  "woman_kneeling_facing_right": '1f9ce-200d-2640-fe0f-200d-27a1-fe0f',
  "woman_lifting_weights": '1f3cb-fe0f-200d-2640-fe0f',
  "woman_mage": '1f9d9-200d-2640-fe0f',
  "woman_mechanic": '1f469-200d-1f527',
  "woman_mountain_biking": '1f6b5-200d-2640-fe0f',
  "woman_office_worker": '1f469-200d-1f4bc',
  "woman_pilot": '1f469-200d-2708-fe0f',
  "woman_playing_handball": '1f93e-200d-2640-fe0f',
  "woman_playing_water_polo": '1f93d-200d-2640-fe0f',
  "woman_police_officer": '1f46e-200d-2640-fe0f',
  "woman_pouting": '1f64e-200d-2640-fe0f',
  "woman_raising_hand": '1f64b-200d-2640-fe0f',
  "woman_red_haired": '1f469-200d-1f9b0',
  "woman_rowing_boat": '1f6a3-200d-2640-fe0f',
  "woman_running": '1f3c3-200d-2640-fe0f',
  "woman_running_facing_right": '1f3c3-200d-2640-fe0f-200d-27a1-fe0f',
  "woman_scientist": '1f469-200d-1f52c',
  "woman_shrugging": '1f937-200d-2640-fe0f',
  "woman_singer": '1f469-200d-1f3a4',
  "woman_standing": '1f9cd-200d-2640-fe0f',
  "woman_student": '1f469-200d-1f393',
  "woman_superhero": '1f9b8-200d-2640-fe0f',
  "woman_supervillain": '1f9b9-200d-2640-fe0f',
  "woman_surfing": '1f3c4-200d-2640-fe0f',
  "woman_swimming": '1f3ca-200d-2640-fe0f',
  "woman_teacher": '1f469-200d-1f3eb',
  "woman_technologist": '1f469-200d-1f4bb',
  "woman_tipping_hand": '1f481-200d-2640-fe0f',
  "woman_vampire": '1f9db-200d-2640-fe0f',
  "woman_walking": '1f6b6-200d-2640-fe0f',
  "woman_walking_facing_right": '1f6b6-200d-2640-fe0f-200d-27a1-fe0f',
  "woman_wearing_turban": '1f473-200d-2640-fe0f',
  "woman_white_haired": '1f469-200d-1f9b3',
  "woman_with_beard": '1f9d4-200d-2640-fe0f',
  "woman_with_headscarf": '1f9d5',
  "woman_with_probing_cane": '1f469-200d-1f9af',
  "woman_with_veil": '1f470-200d-2640-fe0f',
  "woman_with_white_cane": '1f469-200d-1f9af',
  "woman_with_white_cane_facing_right": '1f469-200d-1f9af-200d-27a1-fe0f',
  "woman_zombie": '1f9df-200d-2640-fe0f',
  "womans_clothes": '1f45a',
  "womans_flat_shoe": '1f97f',
  "womans_hat": '1f452',
  "women-with-bunny-ears-partying": '1f46f-200d-2640-fe0f',
  "women_holding_hands": '1f46d',
  "women_with_bunny_ears_partying": '1f46f-200d-2640-fe0f',
  "women_wrestling": '1f93c-200d-2640-fe0f',
  "womens": '1f6ba',
  "wood": '1fab5',
  "woozy": '1f974',
  "woozy_face": '1f974',
  "world_map": '1f5fa',
  "worm": '1fab1',
  "worried": '1f61f',
  "worried_face": '1f61f',
  "wrench": '1f527',
  "wrestlers": '1f93c',
  "wrestling": '1f93c',
  "writing_hand": '270d',
  "wry_smile_cat": '1f63c',
  "wtf": '1f914',
  "x": '274c',
  "x-ray": '1fa7b',
  "xray": '1fa7b',
  "yarn": '1f9f6',
  "yawn": '1f971',
  "yawning": '1f971',
  "yawning_face": '1f971',
  "yellow_circle": '1f7e1',
  "yellow_heart": '1f49b',
  "yellow_square": '1f7e8',
  "yemen": '1f1fe-1f1ea',
  "yen": '1f4b4',
  "yes": '1f44d',
  "yin_yang": '262f',
  "yo-yo": '1fa80',
  "yo_yo": '1fa80',
  "yum": '1f60b',
  "zambia": '1f1ff-1f1f2',
  "zany": '1f92a',
  "zany_face": '1f92a',
  "zap": '26a1',
  "zebra": '1f993',
  "zebra_face": '1f993',
  "zero": '30-20e3',
  "zimbabwe": '1f1ff-1f1fc',
  "zipper_mouth": '1f910',
  "zipper_mouth_face": '1f910',
  "zombie": '1f9df',
  "zzz": '1f4a4',
};
